// Dockview version: Experimental - key limitations have not been resolve.
// Postponed as of 2026-09-11
import { defineComponent, defineAsyncComponent, ref, mergeProps, h } from 'vue';
import {
    QInnerLoading, QSpinner, QIcon, QBtn, QMenu, QList, QItem, QItemSection, QItemLabel,
    QTooltip, QSpace, QInput, QTabs, QTab, QTabPanels, QTabPanel, QBar, QToolbarTitle,
    QDialog, QCard, QCardSection, QCardActions, QCheckbox, QSeparator,
} from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import careHelpfulFunctions from '../../../careHelpfulFunctions.jsx';
import BaseComponent from '../../BaseComponentMixin.jsx';
import EventBus from '@/Application/event-bus';
import eventCoordinator from '@/Services/serverEventCoordinator';
import webSocket from '@/Services/webSocketService';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { debounce, cloneDeep } from "lodash";
import { PlainWrapper } from '@/Shared/helperClasses';

import { dia, shapes, linkTools, elementTools } from '@joint/core';
//import { mdiAccount } from '@mdi/js';
//import * as mdiIcons from '@mdi/js';

// This function converts a Vuetify-style name (e.g., 'mdi-account')
// into the corresponding PascalCase variable name (e.g., 'mdiAccount').
//function getIconPath(iconName) {
//    const name = iconName.startsWith('mdi-') ? iconName.slice(4) : iconName;
//    const parts = name.split('-');
//    const pascalName = 'mdi' + parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('');
//    return mdiIcons[pascalName];
//}

import { AgGridVue } from "ag-grid-vue3";
import PropertyGrid from '../../form/PropertyGrid2.jsx';
import SchemaForm from '../../schemaform/SchemaForm.jsx';
import UserControl from '../../UserControl.jsx';

const CodeEditorMonaco = defineAsyncComponent(() => import('./editor/codeEditorMonaco.vue'));
import GenericDialog from './shared/genericDialog.jsx';
import FolderGrid from './browser/folderGrid.jsx';
import FlowConfigPanel from './config/FlowConfigPanel.jsx';
import ToolGrid from './browser/toolGrid.jsx';
import ApiGrid from './browser/apiGrid.jsx';
import ImportsPanel from './browser/importsPanel.jsx';
import AskAiDrawer from './askAi/askAiDrawer.jsx';
import AskAiRecipeDialog from './askAi/askAiRecipeDialog.jsx';
import { aliasDescriptionFromRow, defaultClassName, generatedClassFullName, listClassesForRow, parseGeneratedClassFullName } from './browser/siblingAliasDisplay.js';
import {
    isSiblingMethodProp,
    siblingMethodDisplayName,
    siblingHoverButtonScale,
    siblingHoverButtonMarkup,
    SIBLING_HOVER_MAGNIFY_PATH,
    SIBLING_HOVER_OPEN_PATH,
    SIBLING_HOVER_IDENTIFY_OFFSET,
    SIBLING_HOVER_OPEN_OFFSET,
    eventRelatedTarget,
    isEventInsideJointTools,
} from './canvas/siblingHoverTools.js';
import {
    CODE_CHANGING_EVENTS,
    applyDebugLockScope,
    applyDirtyNotice,
    applyLocalEdit,
    applyMethodOpened,
    applyRejectedEdit,
    applySavedNotice,
    applyValidationNotice,
    canDriveDebug,
    canFollowDebug,
    canLaunchNewDebugSession,
    canPauseDebug,
    canResumeOrStep,
    canStopDebug,
    canToggleBreakpoints,
    countValidationErrors,
    debugGateSnapshot,
    editorShouldBeReadOnly,
    formatDebugStopError,
    mergeDebugLockNotice,
    expandLockedProjectIds,
    resolveSubscribeDebugLock,
    launchBlockReason,
    reusableDebugGate,
    shouldReportDebugStopFailure,
    startButtonTip,
    stepButtonTip,
} from './debugger/flowV2DebugGate.js';
import {
    pushMethodHistory,
    jumpMethodHistory,
    renameMethodHistory,
    methodHistoryTop,
    navigateMethodHistoryBack,
    navigateMethodHistoryForward,
    popMethodHistoryIfTopMatches,
} from './shared/methodNavHistory.js';
import FlowMessageLog from './debugger/FlowMessageLog.jsx';
import {
    MESSAGE_LOG_SETTING_KEY,
    appendFlowMessage,
    defaultMessageLogPrefs,
    normalizeMessageLogPrefs,
} from './debugger/flowMessageLog.js';
import {
    applyDebugTabTransition,
    clearTransientIfSelectingPinned,
    closePinnedTab,
    debugTabTransition,
    pinTransientTabAsUser,
    unpinPinnedTabToTransient,
} from './debugger/flowV2DebugTabs.js';
import { pickStackFrameIndexForFlow } from './debugger/flowV2DebugStack.js';
import { isProtectedImportAlias, uniqueImportAlias } from './browser/importTreeRows.js';
import FloatingWindow from './shared/floatingWindow.vue';
import FolderMenu from './browser/folderMenu.vue';
import Variables from './shared/variables.vue';
import DebugLocals from './debugger/debugLocals.vue';
import DebugCallStack from './debugger/debugCallStack.vue';
import PhoneKeypad from './debugger/phoneKeypad.vue';
import RichTooltip from './shared/richTooltip.vue';
import { IVRElement, computeIconHeight, computePortYFromBottom, formatPortLabel, ICON_MIN_HEIGHT, ICON_WIDTH } from './canvas/ivrelement.js';
import { getIconPath, mergeDeltas, mapCache, cacheDebugMap, debugMapNameUrl, frameMatchesDebugMap, expandObject, common, applyGroupAccent } from './shared/helpers.js';
import { formatStatusTooltip, isBreakpointVisible } from './canvas/statusTooltip.js';
import {
    getEffectiveLinks,
    getPortId,
    getDeclareMatchSources,
    buildMatchPortsSchema,
    buildMatchPortsFormItems,
    resolveStoredLinkPortId,
    portLabelText,
} from './canvas/matchPorts.js';
import {
    listEssentialArgumentEditors,
    shouldUseMixedEssentialStack,
    getCaptionEditorDescriptor,
    getOutputEditorDescriptor,
    isSkippedPaletteArgument,
    isVoidMethodReturn,
} from './canvas/customFormModel.js';
import { inferUnavailableToolSchema } from './canvas/unavailableToolSchema.js';
import {
    buildBatchPropertyModel,
    cloneValue,
    listChangedLeaves,
    setAtPath,
} from './canvas/batchPropertyModel.js';
import IconPropertyOverlay, {
    IconPropertyDockedPanel,
    OVERLAY_WIDTH_PX,
    OVERLAY_MIN_WIDTH_PX,
    OVERLAY_HEIGHT_ESSENTIAL_MIN_PX,
    OVERLAY_HEIGHT_ADVANCED_PX,
} from './canvas/IconPropertyOverlay.jsx';
import { createVariableBindingContext, upsertVariableByName, removeVariablesByName } from './shared/variableBinding.js';
import { createFlowDesignerContext } from './shared/flowDesignerContext.js';
import { VariableBindingProvider } from '../../schemaform/VariableBindableField.jsx';
import { FlowContextProvider } from '../../schemaform/FlowContextProvider.jsx';
import { applyArgCompilerError, getCompileErrorBag, syncCompileErrorErrorsMap, errorsMapForCustomForm } from '../../schemaform/essentialsCompilerError.js';
import { resolveChannel, CHANNEL_TYPE_CALL, filterPaletteItems, loadFlowChannelList, builtinChannelFallbackList, isSiblingMethodAllowed, isFolderProjectDrag, implicitPanelVariables } from './debugger/flowChannelConfig.js';
import { getDebugAdapter, showWebRtcChrome, DEBUGGER_WEBRTC } from './debugger/flowDebuggerAdapters.js';
import { firstApiStatementFromDetected, effectiveSteppingFromStopped } from './debugger/apiFirstPause.js';
import { formatArgFieldTitle, formatDisplayName } from './shared/displayName.js';
import { coerceLiteralNumericValue, coerceModelToLiteralNumerics } from './shared/literalNumeric.js';
import { SENTENCE_CASE_BUTTON_CLASS } from '../../../../Shared/buttonAppearance.js';
import '../../css/BasicButton.css';
import './styles/flowSurfaceSwitch.css';
import './styles/flowContextStrip.css';

// Experimentation...
// import { Web } from "sip.js";

const default_props = {
    width: ICON_WIDTH,
    height: ICON_MIN_HEIGHT,
};

const DEFAULT_LINK_ROUTER = 'manhattan';
const LAST_PICKED_ROUTER_KEY = 'flowv2-default-router';
const CANVAS_VIEW_SESSION_PREFIX = 'flowv2-canvas-view:';
const LINK_ROUTER_NAMES = ['manhattan', 'metro', 'normal', 'orthogonal', 'rightAngle'];
/** Palette ToolID for the Native Start icon (EditorProjectTranspiler.START). */
const START_TOOL_ID = '3a40e1cd-ce9c-4752-b9d2-67513002f880';
const LINK_ROUTER_ARGS = {
    startDirections: ['right'],
    endDirections: ['top', 'left', 'bottom'],
    excludeEnds: ['source', 'target'],
};

/** Server default when the user has no Flow v2 settings document yet. */
const DEFAULT_PALETTE_NAME = 'IVRPalette';
const UNAVAILABLE_TOOL_TITLE = 'Unavailable tool';
const UNAVAILABLE_CAPTION = 'Unavailable';
const UNAVAILABLE_ACCENT = '#9aa0a6';

function isPaletteToolType(type) {
    return type === 'Native' || type === 'Method' || type === 'Tool';
}

function unavailablePortId(link, index) {
    if (link?.ID)
        return `unavail-${link.ID}`;
    return `unavail-${index}-${link?.Name || 'link'}`;
}

function outboundStoredLinks(item) {
    return (item?.Links || []).filter((link) => link?.TargetID);
}

/**
 * Saved palette names, or null when there is no settings document.
 * null, a missing response, and {} mean "no settings" (caller defaults to IVRPalette).
 * A document with Palettes: [] (or Palette: []) is an explicit empty selection.
 */
function paletteNamesFromSettings(settings) {
    if (settings == null || typeof settings !== 'object' || Array.isArray(settings))
        return null;
    if (Object.keys(settings).length === 0)
        return null;
    if (Array.isArray(settings.Palettes))
        return settings.Palettes.map((name) => String(name));
    if (Array.isArray(settings.Palette))
        return settings.Palette.map((name) => String(name));
    return null;
}


const saveModelChanges = debounce((f) => { f(); }, 5000);


const FolderLabel = defineComponent({
    name: 'flow-v2-folder-label',
    data: function () {
        return {}
    },
    methods: {
        handleDragStart(ev, data) {
            ev.dataTransfer.effectAllowed = 'copy';
            ev.dataTransfer.setData('application/json', JSON.stringify(data));
            ev.dataTransfer.setDragImage(ev.target, 10, 10);
        }
    },
    render() {
        let icon;
        switch (this.params.data.Type) {
            case 'Folder': icon = 'mdi-folder'; break;
            case 'Project': icon = 'mdi-folder-file-outline'; break;
            case 'Class': icon = 'mdi-window-maximize'; break;
            case 'FlowHeader': icon = 'mdi-sitemap-outline'; break;
            case 'APIHeader': icon = 'mdi-code-braces-box'; break;
        }
        return (
            <span
                draggable={this.params.data.Type == 'FlowHeader' || this.params.data.Type == 'APIHeader'}
                onDragstart={(e) => this.handleDragStart(e, this.params.data)}
            ><QIcon name={icon} size="sm" class="q-mr-sm" />{this.params.value}</span>
        );
    }
});

/** allOf / oneOf / anyOf members as a bag convertSchemaToEditable can walk. */
function compositionBag(list) {
    if (!Array.isArray(list) || !list.length)
        return null;
    const bag = {};
    for (let i = 0; i < list.length; i++)
        bag[i] = list[i];
    return bag;
}

function allowsVariableFlag(node) {
    if (!node || typeof node !== 'object')
        return false;
    if (node.AllowVariable === true || node.AllowVariable === 'true')
        return true;
    const fd = node.formatData;
    return !!(fd && typeof fd === 'object' && (fd.AllowVariable === true || fd.AllowVariable === 'true'));
}

/** JSON Schema type for a flow numeric ArgType, or null. */
function jsonTypeForFlowNumeric(argType) {
    const t = (argType == null ? '' : String(argType)).trim().toLowerCase();
    if (t === 'int' || t === 'long' || t === 'integer')
        return 'integer';
    if (t === 'float' || t === 'double' || t === 'number')
        return 'number';
    return null;
}

function allowVariableIsFalse(value) {
    return value === false || value === 'false';
}

/** Direct composition members only — do not opt in every property of an object. */
function compositionMemberAllowsVariable(node) {
    if (!node || typeof node !== 'object')
        return false;
    const lists = [node.allOf, node.oneOf, node.anyOf];
    for (let i = 0; i < lists.length; i++) {
        const list = lists[i];
        if (!Array.isArray(list))
            continue;
        for (let j = 0; j < list.length; j++) {
            if (allowsVariableFlag(list[j]))
                return true;
        }
    }
    return false;
}

export default defineComponent({
    name: 'flow-v2',
    mixins: [
        BaseComponent,
    ],
    components: {
        Splitpanes,
        Pane,
        AgGridVue,
        PropertyGrid,
        SchemaForm,
        UserControl,
        CodeEditorMonaco,
        GenericDialog,
        FolderGrid,
        FlowConfigPanel,
        ToolGrid,
        ApiGrid,
        ImportsPanel,
        AskAiDrawer,
        AskAiRecipeDialog,
        FloatingWindow,
        FolderMenu,
        FolderLabel,
        Variables,
        DebugLocals,
        DebugCallStack,
        PhoneKeypad,
        RichTooltip,
        IconPropertyOverlay,
        IconPropertyDockedPanel,
        VariableBindingProvider,
        FlowContextProvider,
        FlowMessageLog,
        QInnerLoading,
        QSpinner,
        QIcon, QBtn, QMenu, QList, QItem, QItemSection, QItemLabel,
        QTooltip, QSpace, QInput, QTabs, QTab, QTabPanels, QTabPanel, QBar, QToolbarTitle,
        QDialog, QCard, QCardSection, QCardActions, QCheckbox, QSeparator,
    },
    data: function () {
        return {
            id: utils.generateUUID(),
            flow_id: null,
            flow_type: null,
            flow_name: '',
            parent_id: null,
            project_name: '',
            class_id: null,
            /** 'document' | 'config' — center pane surface */
            editorSurface: 'document',
            /** Last flow payload from loadFlow; used to rebuild graph after config-hidden loads. */
            _lastFlowLoadData: null,
            /** True when loadFlow ran while Configuration hid the JointJS paper. */
            _flowLoadedWhileHidden: false,
            /** True when redrawOpenFlowFromGraph was deferred until the paper is measurable. */
            _pendingRedrawFromGraph: false,
            /** paperDiv / scrollContainer DOM listeners from setupPaperEventListeners. */
            _paperDomListenersAttached: false,
            _paperResizeObserver: null,
            /** Last ResizeObserver measurability; repair only on false→true edges. */
            _paperWasMeasurable: false,
            /** When true, next repair uses snapshot/restore rebind (size recovery). */
            _canvasRepairStrong: false,
            debouncedCanvasRepair: null,
            /** 'method' | 'project' */
            configScope: 'method',
            /** method: signature|touchpoints ; project: settings|releases (legacy: sandbox) */
            configTab: 'signature',
            auto_saved: 'SAVED', // SAVED, SAVING, FAILED -- tracks the auto-save
            auto_save_error: '',
            validationPending: true,
            validationErrorCount: 0,
            requiredCodeVersion: null,
            acceptNextValidation: false,
            awaitingDirty: false,
            seenEditGeneration: 0,
            lastCodeVersion: null,
            debugLocked: false,
            lockedDebugSession: null,
            lockedProjectIds: [],
            isDebugOwner: false,
            debugRole: '',
            editorReadOnly: false,
            askAiOpen: false,
            askAiRecipeOpen: false,
            askAiEnabled: false,
            askAiAwaitingValidation: false,
            pendingRecipeId: '',
            recipeHoles: [],
            loaderPromise: null,
            loaderPromiseResolve: null, // method to resolve the promise
            loaderPromiseReject: null,

            flowid_expn: null,
            type_expn: null,
            users: {},
            webSocketStatus: false,
            lastHeartbeat: null,
            heartbeatInterval: null,
            heartbeatSuccess: false,
            messages: [],
            messageLogPrefs: defaultMessageLogPrefs(),
            messageLogMutedCount: 0,

            graph: null,
            paper: null,
            isPanning: false,
            lastMouseX: 0,
            lastMouseY: 0,
            scale: 1,

            toolPalette: null,
            toolPaletteItems: [],
            toolPaletteSelection: [],
            /** True while reassigning the palette after settings save, so the watcher does not restart the editor. */
            _reloadingToolPalette: false,
            paletteSettingsOpen: false,
            paletteSettingsLoading: false,
            paletteSettingsSaving: false,
            paletteSettingsError: '',
            paletteNameOptions: [],
            userFlowHeader_cache: {},

            tabs: [{ text: '', value: '0', id: '' }],
            selected_tab: null,
            methodNavHistory: [],
            methodNavForward: [],

            upperRight_tab: 0,
            siblingRows: [],
            siblingCache: {},
            siblingDirty: {},
            siblingLoading: false,
            siblingError: '',
            canvasRejectProjectDrop: false,
            debugWindows_tab: 1,

            panelSizes: {
                toplevel: {
                    panel1: 20,
                    panel2: 60,
                },
                main: {
                    panel1: 75,
                },
                toolprops: {
                    panel1: 50,
                }
            },

            selected: null,
            schema: null,
            model: {},
            tool: null,
            variables: [],
            /** Method signature Parameters for use-variable picker (not Output save targets). */
            parameters: [],
            /** Open method ReturnType from GetMethodHeader (FlowContext.ReturnType). */
            methodReturnType: null,
            detected_locals: [],
            detected_lines: [],

            watchCaption: null,
            watchArgs: null,
            watchOutput: null,
            watchMatchPorts: null,

            debouncedUpdateCaption: null,
            debouncedUpdateArgs: null,
            debouncedUpdateOutput: null,
            debouncedUpdateMatchPorts: null,
            debouncedUpdateLink: null,
            /** When true, graph_change_source_target ignores link rebinds during port sync. */
            _suppressLinkSourceSync: false,
            /** When true, vertex edits are not persisted (canvas rebuild after a palette change). */
            _suppressVertexSync: false,

            currentLink: null,
            inputPosition: { left: 0, top: 0 },
            inputChoicesAnchorId: `flow-input-choices-anchor-${utils.generateUUID()}`,
            inputValue: '',
            showInput: false,
            showInputChoices: false,
            inputChoicesVisible: false,
            choices: ['One','Two','Three','Four'],

            originalAttrs: new Map(),
            startPoint: null,
            selectionRect: null,
            selectedCells: [],
            dragPoint: null,
            groupMove: false,
            cellLastPos: null,

            aceEditorRef: null,
            api_deltas: [],
            api_font_size: 16,
            api_source: '',
            api_is_applying: false,
            debouncedApiDelta: null,
            tooltip: null,
            activeSignature: null,

            customCompleter: {
                identifierRegexps: [/[a-zA-Z_0-9\$\-\u00A2-\uFFFF.]/], // Allow dots in identifiers for better context matching
                triggerCharacters: ['.'/*,'('*/], // Trigger popup immediately on dot
                getCompletions: this.getCompletions
            },
            hoverTimeout: null,

            viewMethodID: false,
            debugWaitForNext: null,
            connectorStyle: DEFAULT_LINK_ROUTER,
            pendingNewFlowStamp: false,
            connectorStyles: [
                { title: 'Manhattan', value: 'manhattan' },
                { title: 'Metro', value: 'metro' },
                { title: 'Normal', value: 'normal' },
                { title: 'Orthogonal', value: 'orthogonal' },
                { title: 'Right Angle', value: 'rightAngle' },
            ],

            debugSession: null,
            debugMode: 'stopped',
            /** True from Start/Step click until the session is running, paused, or back to idle. */
            debugLaunching: false,
            /** Bumped only when a launch is cancelled, not when Trace started clears debugLaunching. */
            debugLaunchToken: 0,
            /** Bumped when a WebRTC setup is cancelled so an in-flight start does not continue. */
            mediaSetupGeneration: 0,
            debugElement: null,
            debugLocals: [],
            debugStack: [],
            debugStackIndex: 0,
            /** Frame where the debugger is actually paused (VS yellow). Stack clicks change debugStackIndex only. */
            debugExecStackIndex: 0,
            debugResultsVisible: false,
            debugResults: '',
            debugSettings: null,

            flowFindOpen: false,
            flowFindQuery: '',
            flowFindCaseSensitive: false,
            flowFindMatchCells: [],
            flowFindNavIndex: -1,
            flowFindOriginalBodyAttrs: new Map(),

            WebRtcSessionId: null,
            WebRtcPhone: null,
            WebRtcConnectedFunc: null, // after WebRtc is established, this is a function to be run

            /** Resolved FlowChannelInfo for the parent project (Call / SMS / EMail / API). */
            channelConfig: resolveChannel(CHANNEL_TYPE_CALL),
            channelList: [],

            // Icon essential/advanced property popup (independent of JointJS icon size)
            iconOverlayVisible: false,
            iconOverlayCellView: null,
            iconOverlayPosition: { left: 0, top: 0 },
            iconOverlayMaxHeight: 400,
            iconOverlaySize: { width: OVERLAY_WIDTH_PX, height: OVERLAY_HEIGHT_ADVANCED_PX },
            /** 'right' | 'left' — which side of the icon the floating overlay sits on */
            iconOverlayPlacement: 'right',
            propertiesAdvancedMode: false,
            propertiesPinned: false,
            /** Advanced + Pinned multi-select summary shown above the property grid. */
            batchBanner: '',
            /** Remounts the property grid when the batch set changes. */
            batchSelectionKey: '',
            /** Shared provide/inject context for essential "use variable" assist */
            variableBindingContext: null,
            /** Host-backed flowchart identity for schema conditions / LookupURL / custom forms */
            flowContext: null,
            /** Vue-readable copy of selected icon breakAccent visibility (Joint attr is not reactive). */
            selectedHasBreakpoint: false,
        }
    },
    async created() {
        this._batchFlush = debounce(() => this.flushBatchEdits(), 300);
        this.variableBindingContext = createVariableBindingContext(this, { enabled: true });
        this.flowContext = createFlowDesignerContext(this);

        await this.loadToolPalette();

        this.flowid_expn = utils.compile(this, this.controlData.FlowID);
        this.type_expn = utils.compile(this, this.controlData.ItemType);

        this.propertiesAdvancedMode = !!common.getGlobalSetting.call(this, 'propertiesAdvancedMode', false);
        this.propertiesPinned = !!common.getGlobalSetting.call(this, 'propertiesPinned', false);
        this.messageLogPrefs = normalizeMessageLogPrefs(
            common.getGlobalSetting.call(this, MESSAGE_LOG_SETTING_KEY, defaultMessageLogPrefs),
        );
        const savedWidth = common.getGlobalSetting.call(this, 'iconOverlayWidth', null);
        const savedAdvHeight = common.getGlobalSetting.call(this, 'iconOverlayAdvancedHeight', null);
        this.iconOverlaySize = {
            width: (typeof savedWidth === 'number' && savedWidth >= OVERLAY_MIN_WIDTH_PX)
                ? savedWidth
                : OVERLAY_WIDTH_PX,
            height: (typeof savedAdvHeight === 'number' && savedAdvHeight > 0)
                ? savedAdvHeight
                : OVERLAY_HEIGHT_ADVANCED_PX,
        };

        if (this.System.careWebSocketService)
            this.webSocketStatus = this.System.careWebSocketService.IsConnected();
        else
            setTimeout(() => this.webSocketStatus = this.System.careWebSocketService.IsConnected(), 1000);
        this.refreshAskAiEnabled();

        EventBus.$on('WebSocketConnected', this.webSocketConnected);
        EventBus.$on('WebSocketDisconnected', this.webSocketDisconnected);

        this.flowFindDebouncedRecompute = debounce(() => {
            this.recomputeFlowFindMatches();
        }, 120);

        this.debouncedSaveCanvasViewState = debounce(() => {
            this.saveCanvasViewState();
        }, 200);

        this.debouncedCanvasRepair = debounce(() => {
            void this.repairOpenFlowCanvas();
        }, 50);

        this.debouncedSiblingValidate = debounce(() => {
            if (this.FlowID)
                webSocket.Validate(this.FlowID);
        }, 250);

        try {
            this.channelList = await loadFlowChannelList((url) => utils.api.get(url));
        }
        catch (e) {
            this.channelList = builtinChannelFallbackList();
        }
        await this.refreshChannelConfig();
    },
    unmounted() {
        this.endEditingFlow(this.FlowID);

        EventBus.$off('WebSocketConnected', this.webSocketConnected);
        EventBus.$off('WebSocketDisconnected', this.webSocketDisconnected);
    },
    computed: {
        FlowID() {
            //return utils.evaluate(this.flowid_expn, this);
            return this.flow_id;
        },
        ItemType() {
            //return utils.evaluate(this.type_expn, this);
            return this.flow_type;
        },
        ItemName() {
            return this.flow_name;
        },
        ParentID() {
            return this.parent_id;
        },
        siblingAliasItems() {
            const items = [];
            for (const row of this.siblingRows || []) {
                for (const alias of row.Aliases || []) {
                    if (!alias?.Alias)
                        continue;
                    items.push({
                        alias: alias.Alias,
                        detail: aliasDescriptionFromRow(row, alias),
                    });
                }
            }
            return items;
        },
        siblingAliases() {
            return this.siblingAliasItems.map((a) => a.alias);
        },
        showWebRtcDebugUi() {
            return showWebRtcChrome(this.channelConfig?.FlowDebugger);
        },
        flowMediaType() {
            return this.channelConfig?.FlowMediaType || null;
        },
        /** Palette placeholders stay read-only even when the flowchart itself is editable. */
        propertiesReadOnly() {
            return !!this.editorReadOnly || !!this.selected?.model?.attributes?.prop?.Unavailable;
        },
        /** Pin tabs stay available on Editor and method Configuration; project Configuration uses the same-height context label. */
        showFlowTabs() {
            return this.editorSurface === 'document'
                || (this.editorSurface === 'config' && this.configScope === 'method');
        },
        /** True when at least one pin tab has a label. */
        hasFlowTabs() {
            return this.tabs.some((t) => !!t.text);
        },
        /**
         * Collapse the strip on first load (no methods) so it does not leave a white gap.
         * Keep it mounted whenever tabs exist or project Configuration needs the context label,
         * so Method ↔ Project does not snap the layout.
         */
        showContextStrip() {
            if (this.hasFlowTabs)
                return true;
            return this.editorSurface === 'config' && this.configScope === 'project';
        },
        filteredToolPaletteItems() {
            return filterPaletteItems(this.toolPaletteItems, this.channelConfig, this.channelList);
        },
        IsActive() {
            if (this.heartbeatInterval && this.lastHeartbeat)
                return (careHelpfulFunctions.date_value.value - this.lastHeartbeat) < 6000;
            else
                return false;
        },
        IsHeartBeatTimeout() {
            if (this.heartbeatInterval && this.lastHeartbeat)
                return (careHelpfulFunctions.date_value.value - this.lastHeartbeat) >= 6000;
            else
                return false;
        },
        IsWebSocketActive() {
            return this.webSocketStatus && !this.IsHeartBeatTimeout;
        },
        Users() {
            return Object.keys(this.users).map(k => ({ connectionId: k, ...this.users[k] }));
        },

        eventKey() {
            if (this.FlowID)
                return `flow_method_${this.FlowID}_${this.System.careTokenService.CustomerID()}`;
            else
                return null;
        },
        storageKey: function () {
             return 'flowv2';
        },

        styles() {
            let styles = {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
                // Absolute floating overlays (icon properties) are positioned relative to this root
                position: 'relative',
            }

            if (this.controlData?.SizeOptions?.Height?.Mode === 'Auto' || this.controlData?.SizeOptions?.Height?.Mode === 'Fill')
                styles.minHeight = '100px';

            if (this.controlData?.SizeOptions?.Width?.Mode === 'Auto' || this.controlData?.SizeOptions?.Width?.Mode === 'Fill')
                styles.minWidth = '200px'

            return styles;
        },
        schemaWrapper() {
            // property grid schema
            if (this.schema)
                return {
                    type: "object",
                    filteringOptions: {
                        IncludeNullKeys: true
                    },
                    additionalProperties: true,
                    properties: {
                        API: {
                            type: 'object',
                            properties: {
                                Name: {
                                    type: 'string',
                                    readonly: true
                                },
                                Description: {
                                    type: 'string',
                                    readonly: true
                                },
                                Caption: {
                                    type: 'string'
                                }
                            }
                        },
                        Arguments: this.schema,
                        Output: {
                            type: 'object',
                            properties: {
                                ReturnVar: {
                                    type: 'string'
                                },
                            }
                        }
                    }
                };
            else
                return null;
        },
        variables_bytype() {
            const locked = this.lockedSignatureRows();
            const lockedNames = new Set(locked.map(row => String(row.Name).toLowerCase()));
            const custom = (this.variables || []).map(v => ({
                ...v,
                kind: 'variable',
            }));
            switch (this.ItemType) {
                case 'APIHeader':
                    return locked.concat(
                        (this.detected_locals || [])
                            .filter(a => a?.Name && !String(a.Name).startsWith('__auto'))
                            .filter(a => !lockedNames.has(String(a.Name).toLowerCase()))
                            .map(a => ({
                                Name: a.Name,
                                Type: a.DataType,
                                Persistent: false,
                                kind: 'code',
                                locked: true,
                            })),
                    ).concat(custom);

                case 'FlowHeader':
                    return locked.concat(custom);
            }
        },
    },
    mounted() {
        if (this.ensureJointPaper()) {
            this.setupCanvasRepairObservers();

            if (this.FlowID)
                this.beginEditingFlow(this.FlowID);

            EventBus.$on("ChannelEvent", this.handleChannelEventData);
        }
    },
    beforeUnmount() {
        EventBus.$off("ChannelEvent", this.handleChannelEventData);

        this.closeFlowFind();
        this.flowFindDebouncedRecompute?.cancel?.();
        this.cancelScrollCellIntoViewAnimation?.();

        if (this.handleKeyDown) {
            document.removeEventListener('keydown', this.handleKeyDown);
        }

        this.endEditingFlow(this.FlowID);
        this.debouncedSaveCanvasViewState?.cancel?.();
        this.debouncedSiblingValidate?.cancel?.();
        this.debouncedCanvasRepair?.cancel?.();
        this._batchFlush?.cancel?.();

        this.teardownCanvasRepairObservers();
        this.disposeJointPaper();
    },
    watch: {
        scale(newscale) {
            if (this.ItemType == 'FlowHeader') {
                this.paper.scale(newscale, newscale);
                if (this.iconOverlayVisible)
                    this.$nextTick(() => this.updateIconOverlayPosition());
                this.scheduleSaveCanvasViewState();
            }
            else
                this.api_font_size = Math.round(newscale * 16);
        },
        selected_tab(newv) {
            console.log(`selected_tab: "${newv}"`);
        },
        toolPalette: {
            flush: 'sync',
            handler(newv) {
                // Occurs when the component is first rendered, the tools haven't been
                // loaded yet but the active flow may have been set. If so, start editing
                // now that the tool palette is ready. A later reload (palette settings)
                // must not restart the editor socket. flush sync so the reload flag is
                // still set when this runs.
                if (this._reloadingToolPalette)
                    return;
                if (newv && this.flow_id && this.flow_type && this.flow_name)
                    this.beginEditingFlow(this.flow_id);
            },
        },
        parent_id(newId, oldId) {
            if (oldId && (this.siblingRows || []).length)
                this.siblingCache = { ...this.siblingCache, [oldId]: this.siblingRows.slice() };
            if (newId && Array.isArray(this.siblingCache[newId]))
                this.siblingRows = this.siblingCache[newId].slice();
            this.loadSiblingDependencies();
            this.syncDebugLockScope();
        },
        editorReadOnly() {
            this.syncPaperInteractivity();
        },
    },
    methods: {
        /**
         * JointJS paper interactivity must track debug/lock read-only and socket status.
         * loadFlow / webSocketConnected used to force true and undid the lock after a flow switch.
         */
        syncPaperInteractivity(forceOff = false) {
            if (!this.paper || typeof this.paper.setInteractivity !== 'function')
                return;
            if (forceOff) {
                this.paper.setInteractivity(false);
                return;
            }
            this.paper.setInteractivity(!!this.webSocketStatus && !this.editorReadOnly);
        },
        SetActiveFlowID(id, type, name, parentID, isNew, opts) {
            console.log(`SetActiveFlowID(id:${id}, type:${type}, name:${name}, isNew:${!!isNew})`);

            this.hideSiblingHoverTools();
            if (!id) return;

            if (this.flow_id && this.flow_id != id && opts?.recordHistory !== false)
                this.recordMethodNavLeave();

            this.pendingNewFlowStamp = !!isNew;
            this.pendingRecipeId = opts?.recipeId || '';
            if (this.flow_id != id) {
                this.recipeHoles = [];
                this.stopRecipeHoleWatch();
            }

            const openingSame = this.flow_id == id;
            if (this.flow_id && !openingSame)
                this.endEditingFlow(this.flow_id);

            this.flow_id = id;
            this.flow_type = type;
            this.flow_name = name;
            this.parent_id = parentID;
            if (!openingSame)
                this.restoreOrResetDebugGate(id);
            this.detected_locals = [];
            this.detected_lines = [];

            const tab = this.tabs.find(t => t.value == id);
            if (!tab) {
                this.tabs[0].text = name;
                this.tabs[0].value = id;
                this.tabs[0].type = type;
            }
            else {
                this.tabs = clearTransientIfSelectingPinned(this.tabs, id);
            }

            this.selected_tab = id;
            this.refreshChannelConfig();
            this.refreshProjectName();
            this.closeFlowFind();
            this.graph.clear();

            if (!this.toolPalette) return;

            this.debugSettings = this.getFlowSetting('startup');

            if (id)
                this.beginEditingFlow(id);
        },
        currentMethodNavEntry() {
            if (!this.flow_id)
                return null;
            return {
                id: this.flow_id,
                type: this.flow_type,
                name: this.flow_name,
                parentID: this.parent_id,
            };
        },
        recordMethodNavLeave() {
            if (!this.flow_id)
                return;
            this.methodNavHistory = pushMethodHistory(this.methodNavHistory, this.currentMethodNavEntry());
            this.methodNavForward = [];
        },
        goMethodNavBack() {
            const moved = navigateMethodHistoryBack(
                this.methodNavHistory,
                this.methodNavForward,
                this.currentMethodNavEntry(),
            );
            this.methodNavHistory = moved.history;
            this.methodNavForward = moved.forward;
            if (!moved.next)
                return;
            this.SetActiveFlowID(moved.next.id, moved.next.type, moved.next.name, moved.next.parentID, false, { recordHistory: false });
        },
        goMethodNavForward() {
            const moved = navigateMethodHistoryForward(
                this.methodNavHistory,
                this.methodNavForward,
                this.currentMethodNavEntry(),
            );
            this.methodNavHistory = moved.history;
            this.methodNavForward = moved.forward;
            if (!moved.next)
                return;
            this.SetActiveFlowID(moved.next.id, moved.next.type, moved.next.name, moved.next.parentID, false, { recordHistory: false });
        },
        jumpMethodNavHistory(index) {
            const { next, stack } = jumpMethodHistory(this.methodNavHistory, index);
            this.methodNavHistory = stack;
            this.methodNavForward = [];
            if (!next)
                return;
            this.SetActiveFlowID(next.id, next.type, next.name, next.parentID, false, { recordHistory: false });
        },
        methodNavHistoryItems() {
            const stack = this.methodNavHistory || [];
            return stack.map((entry, index) => ({ entry, index })).reverse();
        },
        async refreshProjectName() {
            if (!this.parent_id) {
                this.project_name = '';
                return;
            }
            try {
                const proj = await utils.api.get(`Apps/FlowV2/GetProject?ID=${this.parent_id}`);
                this.project_name = proj?.Name || '';
            }
            catch {
                this.project_name = '';
            }
        },
        openConfigSurface(scope, tab, opts = {}) {
            if (opts.projectId && opts.projectId !== this.parent_id) {
                this.parent_id = opts.projectId;
                if (opts.projectName)
                    this.project_name = opts.projectName;
                else
                    this.refreshProjectName();
            }
            if (opts.flowId && opts.flowId !== this.flow_id && opts.flowType && opts.flowName) {
                this.SetActiveFlowID(opts.flowId, opts.flowType, opts.flowName, opts.projectId || this.parent_id, false);
            }
            this.configScope = scope === 'project' ? 'project' : 'method';
            if (this.configScope === 'method')
                this.configTab = tab === 'touchpoints' ? 'touchpoints' : 'signature';
            else if (tab === 'sandbox' || tab === 'releases')
                this.configTab = 'releases';
            else if (tab === 'sharedvars')
                this.configTab = 'sharedvars';
            else
                this.configTab = 'settings';
            this.editorSurface = 'config';
        },
        closeConfigSurface() {
            this.editorSurface = 'document';
            // JointJS cannot size ports while the paper was display:none / zero-sized.
            // Rebuild the graph from the last payload once the editor surface is shown again.
            if (this._pendingRedrawFromGraph && this.ItemType === 'FlowHeader') {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            void this.redrawOpenFlowFromGraph();
                        });
                    });
                });
                return;
            }
            if (this._flowLoadedWhileHidden && this._lastFlowLoadData && this.ItemType === 'FlowHeader') {
                const data = this._lastFlowLoadData;
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            this.loadFlow(data);
                        });
                    });
                });
                return;
            }
            this.scheduleCanvasRepair('config-close');
        },
        isEditorPaperMeasurable() {
            if (this.editorSurface !== 'document')
                return false;
            const el = this.$refs.paperDiv;
            if (!el)
                return false;
            return el.clientWidth > 0 && el.clientHeight > 0;
        },
        isPaperHostHealthy() {
            if (!this.paper || !this.graph)
                return false;
            const el = this.$refs.paperDiv;
            if (!el || !this.paper.el)
                return false;
            if (!this.paper.el.isConnected || this.paper.el !== el)
                return false;
            return this.isEditorPaperMeasurable();
        },
        /**
         * Create or rebind the JointJS paper onto the current paperDiv.
         * @returns {boolean}
         */
        ensureJointPaper() {
            const el = this.$refs.paperDiv;
            if (!el)
                return false;
            if (this.paper?.el === el && this.paper.el.isConnected && this.graph)
                return true;

            this.disposeJointPaper();

            this.graph = new dia.Graph({}, { cellNamespace: shapes });
            this.paper = new dia.Paper({
                el,
                model: this.graph,
                width: 5000,
                height: 5000,
                gridSize: 10,
                drawGrid: true,
                background: { color: '#F5F5F5' },
                cellViewNamespace: shapes,
                embeddingMode: true,
                linkPinning: false,
                interactive: true,
                validateConnection: (cellViewS, _magnetS, cellViewT) => {
                    if (cellViewS?.model?.attributes?.prop?.Unavailable)
                        return false;
                    if (cellViewT?.model?.attributes?.prop?.Unavailable)
                        return false;
                    return true;
                },
                defaultRouter: {
                    name: this.normalizeLinkRouter(this.connectorStyle) || DEFAULT_LINK_ROUTER,
                    args: { ...LINK_ROUTER_ARGS },
                },
                defaultConnector: {
                    name: 'straight',
                    args: {
                        cornerType: 'line',
                        cornerRadius: 5
                    }
                },
            });

            this.setupPaperEventListeners();
            this.syncPaperInteractivity();
            return true;
        },
        teardownPaperDomListeners() {
            if (!this._paperDomListenersAttached)
                return;
            const paperContainer = this.$refs.paperDiv;
            const container = this.$refs.scrollContainer;
            if (paperContainer) {
                paperContainer.removeEventListener('keydown', this.paper_KeyDown);
                paperContainer.removeEventListener('mousedown', this.paper_mousedown);
                paperContainer.removeEventListener('mousemove', this.paper_mousemove);
                paperContainer.removeEventListener('mouseup', this.paper_mouseup);
                paperContainer.removeEventListener('mouseleave', this.paper_mouseleave);
                paperContainer.removeEventListener('wheel', this.paper_wheel);
            }
            if (container)
                container.removeEventListener('scroll', this.onFlowScrollContainerScroll);
            this._paperDomListenersAttached = false;
        },
        disposeJointPaper() {
            this.teardownPaperDomListeners();
            if (this.graph) {
                try {
                    this.graph.off('change:vertices', this.graph_change_vertices);
                    this.graph.off('change:source change:target', this.graph_change_source_target);
                    this.graph.clear();
                }
                catch {
                    /* ignore dispose races during HMR */
                }
            }
            if (this.paper) {
                try {
                    this.paper.remove();
                }
                catch {
                    /* ignore dispose races during HMR */
                }
            }
            this.paper = null;
            this.graph = null;
        },
        setupCanvasRepairObservers() {
            this.teardownCanvasRepairObservers();
            this._paperWasMeasurable = this.isEditorPaperMeasurable();
            const el = this.$refs.paperDiv;
            if (el && typeof ResizeObserver !== 'undefined') {
                this._paperResizeObserver = new ResizeObserver(() => {
                    const measurable = this.isEditorPaperMeasurable();
                    // Only heal when the paper recovers size — not on every layout twitch.
                    if (measurable && !this._paperWasMeasurable)
                        this.scheduleCanvasRepair('resize');
                    this._paperWasMeasurable = measurable;
                });
                this._paperResizeObserver.observe(el);
            }
            this._onDocumentVisibility = () => {
                if (document.visibilityState === 'visible')
                    this.scheduleCanvasRepair('visible');
            };
            this._onWindowFocus = () => {
                this.scheduleCanvasRepair('visible');
            };
            document.addEventListener('visibilitychange', this._onDocumentVisibility);
            window.addEventListener('focus', this._onWindowFocus);
        },
        teardownCanvasRepairObservers() {
            this._paperResizeObserver?.disconnect?.();
            this._paperResizeObserver = null;
            if (this._onDocumentVisibility)
                document.removeEventListener('visibilitychange', this._onDocumentVisibility);
            if (this._onWindowFocus)
                window.removeEventListener('focus', this._onWindowFocus);
            this._onDocumentVisibility = null;
            this._onWindowFocus = null;
        },
        scheduleCanvasRepair(reason) {
            if (this.ItemType !== 'FlowHeader')
                return;
            if (this.editorSurface !== 'document')
                return;
            if (reason === 'resize' || reason === 'config-close')
                this._canvasRepairStrong = true;
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.debouncedCanvasRepair?.();
                    });
                });
            });
        },
        /**
         * Cheap JointJS route refresh (no graph clear, no port DOM rewrite).
         * Do NOT call _refreshPorts here — that rebuilds magnet DOM while LinkViews
         * still hold old nodes, which collapses routes to the paper top (vertical rain).
         */
        refreshLinkGeometry() {
            if (!this.paper || !this.graph)
                return;
            for (const el of this.graph.getElements()) {
                const view = this.paper.findViewByModel(el);
                if (view && typeof view.cleanNodesCache === 'function')
                    view.cleanNodesCache();
            }
            for (const link of this.graph.getLinks()) {
                this.paper.findViewByModel(link)?.update?.();
            }
        },
        /**
         * Strong heal: snapshot/detach/restore outbound links per element so LinkViews
         * rebind to current port magnets (same pattern as syncIconPorts).
         */
        rebindAllOutboundLinks() {
            if (!this.paper || !this.graph)
                return;
            for (const el of this.graph.getElements()) {
                const ports = el.getPorts?.() || [];
                if (!ports.length)
                    continue;
                const wanted = new Set(ports.map((p) => p.id));
                const snapshots = this.snapshotOutboundLinks(el, wanted);
                this._suppressLinkSourceSync = true;
                try {
                    for (const link of this.graph.getConnectedLinks(el, { outbound: true })) {
                        if (wanted.has(link.get('source')?.port))
                            link.remove();
                    }
                }
                finally {
                    this._suppressLinkSourceSync = false;
                }
                this.restoreOutboundLinks(el, snapshots);
            }
        },
        /**
         * Heal stale Manhattan routes after HMR / layout recovery.
         * Prefer a cheap refresh; rebind links when recovering size; recreate paper when detached.
         */
        async repairOpenFlowCanvas() {
            if (this.ItemType !== 'FlowHeader' || this.editorSurface !== 'document')
                return;

            if (this._pendingRedrawFromGraph && this.isEditorPaperMeasurable()) {
                await this.redrawOpenFlowFromGraph();
                return;
            }

            if (this._flowLoadedWhileHidden && this._lastFlowLoadData && this.isEditorPaperMeasurable()) {
                await this.loadFlow(this._lastFlowLoadData);
                return;
            }

            if (!this.$refs.paperDiv)
                return;

            if (!this.isPaperHostHealthy()) {
                const el = this.$refs.paperDiv;
                const hostDetached = !this.paper || !this.graph || !this.paper.el
                    || !this.paper.el.isConnected || this.paper.el !== el;
                // Attached but zero-sized: wait for ResizeObserver / config close.
                if (!hostDetached)
                    return;

                const elements = (this.graph?.getElements?.() || [])
                    .filter((cell) => cell.attributes?.prop?.InstanceID);
                const items = elements.map((cell) => this.serializeIconForClipboard(cell));
                const router = this.connectorStyle;
                if (!this.ensureJointPaper())
                    return;
                if (items.length) {
                    this._suppressCanvasViewSave = true;
                    this._suppressLinkSourceSync = true;
                    this._suppressVertexSync = true;
                    try {
                        for (const item of items)
                            await this.addFlowItem(item);
                        for (const item of items)
                            await this.createItemLinks(item);
                        this.applyLinkRouter(router);
                        this.restoreAllBreakpoints();
                        await this.restorePausedDebugHighlight();
                        await this.restoreCanvasViewState(this.FlowID);
                    }
                    finally {
                        this._suppressLinkSourceSync = false;
                        this._suppressVertexSync = false;
                        this._suppressCanvasViewSave = false;
                    }
                    return;
                }
                if (this._lastFlowLoadData) {
                    await this.loadFlow(this._lastFlowLoadData);
                    return;
                }
                return;
            }

            // Size recovery needs a full magnet rebind; focus/visibility only refreshes routes.
            const strong = this._canvasRepairStrong;
            this._canvasRepairStrong = false;
            if (strong)
                this.rebindAllOutboundLinks();
            this.refreshLinkGeometry();
        },
        onFolderSaveRecipe(data) {
            if (!this.askAiEnabled || !data)
                return;
            if (data.Type != 'FlowHeader' && data.Type != 'APIHeader')
                return;
            this.askAiRecipeOpen = true;
        },
        onFolderOpenConfig(data) {
            if (!data) return;
            if (data.Type === 'Project') {
                this.openConfigSurface('project', 'settings', {
                    projectId: data.ID,
                    projectName: data.Name,
                });
                return;
            }
            if (data.Type === 'FlowHeader' || data.Type === 'APIHeader') {
                const projectId = data.ProjectID || this.parent_id;
                if (data.ID !== this.flow_id) {
                    this.SetActiveFlowID(data.ID, data.Type, data.Name, projectId, false);
                }
                else if (projectId && projectId !== this.parent_id) {
                    this.parent_id = projectId;
                    this.refreshProjectName();
                }
                this.$nextTick(() => this.openConfigSurface('method', 'signature', {
                    projectId,
                    flowId: data.ID,
                    flowType: data.Type,
                    flowName: data.Name,
                }));
            }
        },
        onMethodSettingsSaved(data) {
            if (data?.ID)
                this.UserFlowHeaderChanged(data.ID, data);
        },
        /**
         * Keep UI labels in sync after a method Name change (folder tree, pin tabs,
         * config breadcrumb via flow_name, nested canvas tool titles).
         */
        applyMethodNameReferences(id, name) {
            if (!id || name == null || name === '')
                return;

            if (id === this.flow_id)
                this.flow_name = name;

            for (const tab of this.tabs) {
                if (tab.value === id)
                    tab.text = name;
            }

            this.$refs.folderGrid?.updateMethodName?.(id, name);
            this.updateGraphNestedToolName(id, name);
            this.methodNavHistory = renameMethodHistory(this.methodNavHistory, id, name);
            this.methodNavForward = renameMethodHistory(this.methodNavForward, id, name);
        },
        /** Refresh title on canvas icons that call the renamed FlowHeader/APIHeader. */
        updateGraphNestedToolName(toolId, name) {
            if (!this.graph || !toolId)
                return;
            for (const cell of this.graph.getElements()) {
                const prop = cell.attributes?.prop;
                if (!prop || prop.ToolID !== toolId)
                    continue;
                cell.attr('title/text', formatDisplayName(name));
                if (prop.Model?.API)
                    prop.Model.API.Name = name;
            }
        },
        onProjectSettingsSaved(data) {
            if (data?.Name)
                this.project_name = data.Name;
            this.refreshChannelConfig();
        },
        async onFolderMovedMethod(payload) {
            if (!payload?.id || payload.id !== this.flow_id)
                return;
            try {
                const proj = await utils.api.get(`Apps/FlowV2/GetMethodProject?Type=${payload.type || this.ItemType}&ID=${payload.id}`);
                const result = proj?.Result || proj;
                if (result?.ID && result.ID !== this.parent_id)
                    this.parent_id = result.ID;
            }
            catch {
                if (payload.projectId && payload.projectId !== this.parent_id)
                    this.parent_id = payload.projectId;
            }
            this.refreshProjectName();
            this.refreshChannelConfig();
        },
        changeSelectedTab(id) {
            console.log(`changeSelectedTab(id:${id})`);
            if (id == '0') return; // Ignore, default startup value

            if (!id && this.tabs.length > 1)
                id = this.tabs[1].value;

            this.tabs = clearTransientIfSelectingPinned(this.tabs, id);

            if (this.flow_id && this.flow_id != id) {
                // During debug, tabs are view-only: do not push onto method history
                // (that breaks step-in/step-out pairing). Call-stack selection is
                // synced after load via restorePausedDebugHighlight.
                if (this.debugMode === 'stopped')
                    this.recordMethodNavLeave();
                this.endEditingFlow(this.flow_id);
            }

            const tab = this.tabs.find(t => t.value == id);
            if (tab) {
                this.flow_id = id;
                this.flow_type = tab.type;
                this.flow_name = tab.text;
            }
            this.selected_tab = id;
            this.closeFlowFind();
            if (this.graph)
                this.graph.clear();

            if (!this.toolPalette) return;

            if (id)
                this.beginEditingFlow(id);
        },
        pinSelectedTab(e) {
            e?.preventDefault?.();
            const value = this.tabs[0]?.value;
            if (!value || !this.tabs[0]?.text)
                return;
            this.tabs = pinTransientTabAsUser(this.tabs);
            this.selected_tab = value;
        },
        unpinSelectedTab(e, id) {
            e?.preventDefault?.();
            e?.stopPropagation?.();
            const value = id || this.selected_tab;
            if (!value)
                return;
            this.tabs = unpinPinnedTabToTransient(this.tabs, value);
            this.selected_tab = value;
        },
        closePinnedFlowTab(e, id) {
            e?.preventDefault?.();
            e?.stopPropagation?.();
            if (!id)
                return;
            this.tabs = closePinnedTab(this.tabs, id);
        },

        frameMatchesLeavingFlow(frame, leavingId) {
            if (!frame || !leavingId)
                return false;
            const cached = mapCache.debugMap[leavingId];
            if (cached && frameMatchesDebugMap(frame, cached))
                return true;
            if (!cached && leavingId === this.FlowID && frame.MethodName && frame.MethodName === this.flow_name)
                return true;
            return false;
        },

        applyDebugMethodTabTransition(leavingId, enteringId, stackFrames) {
            const leavingStillOnStack = (stackFrames || []).some((frame) => this.frameMatchesLeavingFlow(frame, leavingId));
            const decision = debugTabTransition({
                tabs: this.tabs,
                leavingId,
                enteringId,
                leavingStillOnStack,
            });
            if (decision.action === 'none')
                return;
            this.tabs = applyDebugTabTransition(this.tabs, decision);
        },

        /**
         * Debug method switches: push the leaving method when stepping in
         * (callee still leaves the caller on the stack); pop the destination
         * when stepping out / Return (leaving method gone from the stack).
         */
        applyDebugMethodNavHistory(leavingId, enteringId, stackFrames) {
            if (!leavingId || !enteringId || leavingId === enteringId)
                return;
            const leavingStillOnStack = (stackFrames || []).some((frame) => this.frameMatchesLeavingFlow(frame, leavingId));
            if (leavingStillOnStack) {
                this.recordMethodNavLeave();
                return;
            }
            this.methodNavHistory = popMethodHistoryIfTopMatches(this.methodNavHistory, enteringId);
            this.methodNavForward = [];
        },

        preRenderComplete() {
            this.finishRenderHandler(this);

            this.panelSizes = {
                toplevel: {
                    panel1: this.getFlowPanelSize('toplevel', 0, 20),
                    panel2: this.getFlowPanelSize('toplevel', 1, 60),
                },
                main: {
                    panel1: this.getFlowPanelSize('main', 0, 75),
                },
                toolprops: {
                    panel1: this.getFlowPanelSize('toolprops', 0, 50),
                }
            };
        },
        webSocketConnected() {
            this.webSocketStatus = true;
            this.refreshAskAiEnabled();
            this.syncPaperInteractivity();

            if (!this.heartbeatInterval && this.FlowID) {
                // A restarted API process numbers edit generations from zero again.
                this.acceptNewEditorEpoch();
                this.beginEditingFlow(this.FlowID);
            }
        },
        webSocketDisconnected() {
            this.webSocketStatus = false;
            this.syncPaperInteractivity(true);

            if (this.heartbeatInterval)
                clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        },
        undoEdit() {
            if (this.editorReadOnly || !this.FlowID)
                return;
            webSocket.UndoFlowEdit(this.FlowID);
        },
        redoEdit() {
            if (this.editorReadOnly || !this.FlowID)
                return;
            webSocket.RedoFlowEdit(this.FlowID);
        },
        async refreshAskAiEnabled() {
            try {
                this.askAiEnabled = !!(await webSocket.AskAiEnabled());
            }
            catch (err) {
                this.askAiEnabled = false;
            }
            if (!this.askAiEnabled) {
                this.askAiOpen = false;
                this.askAiRecipeOpen = false;
            }
        },
        askAiSelectionIds() {
            const ids = [];
            const cells = this.selectedCells || [];
            for (const cell of cells) {
                const id = cell?.attributes?.prop?.InstanceID;
                if (id)
                    ids.push(id);
            }
            const one = this.selected?.model?.attributes?.prop?.InstanceID;
            if (one && !ids.includes(one))
                ids.push(one);
            return ids;
        },
        askAiCurrentBody() {
            return this.$refs.codeEditor?.getContent?.() || '';
        },
        setupPaperEventListeners() {
            // Set up event listeners for panning
            const container = this.$refs.scrollContainer;
            const paperContainer = this.$refs.paperDiv;
            if (!paperContainer || !this.paper || !this.graph)
                return;

            this.teardownPaperDomListeners();

            // Make paper focusable for key events
            //paperContainer.setAttribute('tabindex', '0');
            paperContainer.tabIndex = 0; // Ensure paper can receive focus
            paperContainer.focus(); // Auto-focus on mount (optional)

            paperContainer.addEventListener('keydown', this.paper_KeyDown);
            //document.addEventListener('keydown', this.documentKeyDown);

            this.paper.on('blank:pointerdown', this.blank_pointerdown);
            this.paper.on('blank:pointermove', this.blank_pointermove);
            this.paper.on('blank:pointerup', this.blank_pointerup);

            this.paper.on('cell:pointerdown', this.cell_pointerdown);
            this.paper.on('cell:pointermove', this.cell_pointermove);
            this.paper.on('element:pointerup', this.element_pointerup);
            this.paper.on('element:contextmenu', this.element_contextmenu);
            this.paper.on('element:mouseenter', this.element_mouseenter);
            this.paper.on('element:mouseleave', this.element_mouseleave);
            this.paper.on('blank:mouseenter', this.blank_mouseenter);

            paperContainer.addEventListener('mousedown', this.paper_mousedown);
            paperContainer.addEventListener('mousemove', this.paper_mousemove);
            paperContainer.addEventListener('mouseup', this.paper_mouseup);       // Stop panning on mouseup or mouseleave
            paperContainer.addEventListener('mouseleave', this.paper_mouseleave);

            if (container)
                container.addEventListener('scroll', this.onFlowScrollContainerScroll);
            paperContainer.addEventListener('wheel', this.paper_wheel);           // Zooming: Ctrl + mouse wheel
            this._paperDomListenersAttached = true;

            this.debouncedUpdateLink = debounce((instanceid, link) => {
                this.syncFlowChanges({
                    EventType: 'UpdateLink',
                    Data: {
                        FlowID: this.FlowID,
                        Content: {
                            InstanceID: instanceid,
                            Link: link,
                        }
                    }
                }, true);
            }, 2000);

            this.graph.on('change:vertices', this.graph_change_vertices);

            const verticesTool = new linkTools.Vertices({ snapRadius: 10, redundancyRemoval: true });
            const targetArrowheadTool = new linkTools.TargetArrowhead({ focusOpacity: 0.5 });

            const linktoolsView1 = new dia.ToolsView({ tools: [targetArrowheadTool] });
            const linktoolsView2 = new dia.ToolsView({ tools: [verticesTool, targetArrowheadTool] });

            this._linkToolsSimple = linktoolsView1;
            this._linkToolsWithVertices = linktoolsView2;

            this.paper.on('link:mouseenter', this.onLinkMouseEnter);

            this.paper.on('link:mouseleave', function (linkView) {
                linkView.removeTools();
            });

            this.paper.on('link:pointerdblclick', this.paper_link_dblClick);

            this.graph.on('change:source change:target', this.graph_change_source_target);
        },

        onLinkMouseEnter(linkView, evt) {
            const sourceId = linkView?.model?.get('source')?.id;
            const sourceEl = sourceId ? this.graph?.getCell(sourceId) : null;
            if (sourceEl?.attributes?.prop?.Unavailable)
                return;
            if (evt?.shiftKey)
                linkView.addTools(this._linkToolsWithVertices);
            else
                linkView.addTools(this._linkToolsSimple);
        },
        getLinkfromJSlink(jslink) {
            if (jslink.isLink()) {
                const portId = jslink.attributes.source.port;
                const sourceEl = this.graph.getCell(jslink.attributes.source.id);
                const srcPort = sourceEl?.getPorts?.()?.find(a => a.id == portId);
                const linkDef = srcPort?.customData?.Link;

                let name = portId;
                let condition = jslink.attributes.labels?.length
                    ? jslink.attributes.labels[0].attrs.text.text
                    : null;

                if (linkDef?.DeclareMatch) {
                    name = linkDef.Name;
                    condition = linkDef.MatchValue != null ? String(linkDef.MatchValue) : condition;
                }

                return {
                    ID: jslink.id,
                    Name: name,
                    Condition: condition,
                    TargetID: jslink.attributes.target.id,
                    Vertices: jslink.attributes.vertices?.map(a => ({ X: a.x, Y: a.y })) ?? [],
                };
            }
        },
        setInputPositionFromLinkView(linkView) {
            const path = linkView.getConnection();
            const totalLength = path.length();
            const midpoint = path.pointAtLength(totalLength * 0.5);
            const clientPoint = this.paper.localToClientPoint(midpoint);
            const container = this.$refs.scrollContainer;
            const containerRect = container.getBoundingClientRect();

            this.inputPosition = {
                left: `${clientPoint.x - containerRect.left + container.scrollLeft}px`,
                top: `${clientPoint.y - containerRect.top + container.scrollTop}px`
            };
        },
        deleteSeleceted() {
            if (this.selectedCells.length) {
                const batching = !!this.watchBatch || !!this.batchBanner;
                this.deleteItems(this.selectedCells.map(a => this.paper.findViewByModel(a)));
                this.selectedCells = [];
                this.updateHighlights();
                if (batching)
                    this.clearSelected();
            }
            else if (this.selected) {
                this.deleteItems([this.selected]);
            }
        },
        deleteItems(items) {
            if (this.editorReadOnly)
                return;
            for (let item of items) {
                if (item.model.isLink()) {
                    this.syncFlowChanges({
                        EventType: 'RemoveLink',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                InstanceID: item.model.attributes.source.id,
                                Link: this.getLinkfromJSlink(item.model),
                            }
                        },
                    }, true);
                }
                else if (item.model.isElement()) {
                    // Get all links connected to the element (including via ports)
                    const connectedLinks = this.graph.getConnectedLinks(item.model);

                    // Remove all connected links
                    for (let link of connectedLinks) {
                        this.syncFlowChanges({
                            EventType: 'RemoveLink',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    InstanceID: link.attributes.source.id,
                                    Link: this.getLinkfromJSlink(link),
                                }
                            },
                        }, true);

                        link.remove();
                    }
                    this.syncFlowChanges({
                        EventType: 'Remove',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                InstanceID: item.model.attributes.prop.InstanceID,
                            }
                        },
                    }, true);
                }
                else
                    return;

                // Cell views: View.remove() only detaches the SVG. The model stays in
                // the graph, and a palette redraw serializes it back onto the canvas.
                item.model.remove();
            }

            this.closeIconPropertyOverlay();
            this.selected = null;
            this.selectedHasBreakpoint = false;
        },

        async GetFlowConnections() {
            const res = await webSocket.GetFlowConnections();

            console.log(`GetFlowConnections: ${res}`);

            return res;
        },

        storeFlowPaneSize(panelName, e) {
            if (e.prevPane)
                common.saveGlobalSetting(`panelSize-${panelName}-${e.index}`, e.prevPane.size);
        },
        getFlowPanelSize(panelName, index, defaultvalue) {
            return common.getGlobalSetting(`panelSize-${panelName}-${index}`, defaultvalue);
        },

        openArgumentEditor(e, value, sync) {
            e.preventDefault();
            this.inputDialogValue = value;
            this.openTextAreaDialog('Edit Value', (v) => sync(v), value);
        },
        async generateSchemaFromArgs(tool, errors) {
            const s = {
                type: 'object',
                properties: {}
            };
            const mediaType = this.flowMediaType;
            for (let a of tool.Arguments) {
                if (isSkippedPaletteArgument(a, mediaType))
                    continue;

                let argType = a.ArgType ?? a.Type ?? 'string';
                if (a.UseMethodReturnType) {
                    if (isVoidMethodReturn(this.methodReturnType))
                        continue;
                    argType = this.methodReturnType;
                }
                const variableTypeForPicker = argType;
                const numericJsonType = jsonTypeForFlowNumeric(argType);
                const hasChoices = !!(a.Choices && a.Choices.length);
                const hasLookup = !!a.LookupAPI;
                const literalNumeric = !!(numericJsonType && !hasChoices && !hasLookup && allowVariableIsFalse(a.AllowVariable));
                // Palette numeric args omit AllowVariable. Stamp it so Advanced stays an expression field.
                const expressionNumeric = !!(numericJsonType && !hasChoices && !hasLookup && !allowVariableIsFalse(a.AllowVariable));

                s.properties[a.Name] = literalNumeric
                    ? {
                        type: numericJsonType,
                        formatData: {},
                    }
                    : {
                        // Expression-capable values stay strings. The transpiler unwraps them.
                        // Literal numerics (explicit AllowVariable false) keep integer/number.
                        type: 'string',
                        ...((expressionNumeric || a.AllowVariable) ? { AllowVariable: true, VariableType: variableTypeForPicker } : {}),
                        formatData: {
                            EllipsisButton: this.openArgumentEditor,
                            ...((expressionNumeric || a.AllowVariable) ? { AllowVariable: true, VariableType: variableTypeForPicker } : {}),
                        },
                    };
                if (argType == 'bool' || argType == 'boolean') {
                    // Stay a checkbox. AllowVariable (sibling methods / palette) or AllowExpressions
                    // opts the essentials checkbox and advanced grid into variable / expression text.
                    s.properties[a.Name].type = 'boolean';
                    if (a.AllowVariable || a.AllowExpressions) {
                        const boolType = variableTypeForPicker || 'bool';
                        s.properties[a.Name].AllowVariable = true;
                        s.properties[a.Name].VariableType = boolType;
                        s.properties[a.Name].formatData.AllowVariable = true;
                        s.properties[a.Name].formatData.VariableType = boolType;
                    }
                    else {
                        s.properties[a.Name].formatData.AllowExpressions = false;
                        // Convert default value from string to bool when present
                        if (typeof a.DefaultValue === 'string') {
                            a.DefaultValue = JSON.parse(a.DefaultValue);
                        }
                    }
                }
                else if (argType.startsWith('Platform.Schema.')) {
                    const parts = argType.split('.');
                    const type = 'schema/public/' + parts.slice(0, parts.length - 1).join('.') + '/' + parts[parts.length - 1];
                    // Preserve palette AllowVariable across $ref resolve → convertSchemaToEditable.
                    s.properties[a.Name] = {
                        $ref: type,
                        ...(a.AllowVariable ? {
                            AllowVariable: true,
                            VariableType: variableTypeForPicker,
                        } : {}),
                    };

                    // Hide the schema name - not useful info since it will be an object
                    argType = ''; // parts[parts.length - 1];
                }
                if ('DefaultValue' in a && a.DefaultValue !== null && a.DefaultValue !== undefined)
                    s.properties[a.Name].default = a.DefaultValue;
                if ((s.properties[a.Name].type === 'integer' || s.properties[a.Name].type === 'number')
                    && typeof s.properties[a.Name].default === 'string') {
                    const coerced = coerceLiteralNumericValue(
                        s.properties[a.Name].default,
                        s.properties[a.Name].type === 'integer',
                    );
                    if (typeof coerced === 'number')
                        s.properties[a.Name].default = coerced;
                }

                if (a.Out || a.Direction == 1)
                    s.properties[a.Name].title = formatArgFieldTitle(a.Name, argType, { out: true });
                else
                    s.properties[a.Name].title = formatArgFieldTitle(a.Name, argType);

                if (a.Description)
                    s.properties[a.Name].description = a.Description;

                if (errors && errors[a.Name])
                    applyArgCompilerError(s.properties[a.Name], errors[a.Name]);

                if (a.Choices && a.Choices.length) {
                    s.properties[a.Name].titleMap = a.Choices.map(c => ({ name: c, value: c }));
                    if (!s.properties[a.Name].formatData) s.properties[a.Name].formatData = {};
                    s.properties[a.Name].formatData.AllowCustomInput = true;
                    if (a.AllowVariable) {
                        s.properties[a.Name].formatData.AllowVariable = true;
                        s.properties[a.Name].formatData.VariableType = variableTypeForPicker;
                        s.properties[a.Name].VariableType = variableTypeForPicker;
                    }
                }
                else if (a.LookupAPI) {
                    s.properties[a.Name].format = 'LookupList';
                    s.properties[a.Name].formatData = {
                        LookupType: 'URL',
                        DisplayType: 'Fieldname',
                        ValueType: 'Fieldname',
                        AllowCustomInput: true,
                        AutoCompleteInput: true,
                        ...(a.AllowVariable ? {
                            AllowVariable: true,
                            VariableType: variableTypeForPicker,
                        } : {}),
                        LookupURL: a.LookupAPI,
                        DisplayField: a.LookupAPIDisplayField,
                        ValueField: a.LookupAPIValueField,
                    };
                    if (a.AllowVariable)
                        s.properties[a.Name].VariableType = variableTypeForPicker;
                }
                else if (a.MultiLine && s.properties[a.Name].type === 'string') {
                    // Essentials SchemaForm → sform-textarea. PropertyGrid2 ignores this format
                    // and keeps Form2Input + EllipsisButton.
                    s.properties[a.Name].format = 'textarea';
                }
            }

            let s0 = {
                type: "object",
                description: tool.description ?? '',
                filteringOptions: {
                    IncludeNullKeys: true
                },
                additionalProperties: true,
                properties: {
                    API: {
                        type: 'object',
                        properties: {
                            Name: {
                                type: 'string',
                                readonly: true,
                                default: !tool.type ? tool.path + '/' + tool.name : tool.name,
                                condition: 'IsAdvanced',
                            },
                            Caption: {
                                type: 'string',
                                default: tool.name,
                            }
                        }
                    },
                    Arguments: s,
                }
            };
            if (tool.ReturnType && tool.ReturnType != 'void') {
                s0.properties.Output = {
                    type: 'object',
                    properties: {
                        ReturnVar: {
                            type: 'string',
                            title: formatArgFieldTitle('ReturnVar', tool.ReturnType),
                            AllowVariableTarget: true,
                            VariableType: tool.ReturnType || 'string',
                        }
                    }
                };
                if (errors && errors.ReturnVar) {
                    s0.properties.Output.properties.ReturnVar.formatData = { error: errors.ReturnVar.Message };

                    // For this specific error, add a button that will automatically add the named variable
                    if (errors.ReturnVar.Message == 'Variable name is not defined')
                        s0.properties.Output.properties.ReturnVar.formatData.buttons = [{
                            icon: 'mdi-plus',
                            tooltip: 'Add variable',
                            action: (e, v) => this.autoAddVariable('ReturnVar', v),
                        }];
                }
            }
            // Put Out arguments into the Output property
            for (let a of tool.Arguments.filter(a => a.Out || a.Direction == 1)) {
                if (!s0.properties.Output) s0.properties.Output = {
                    type: 'object', properties: {}
                };

                const outType = a.ArgType ?? a.Type ?? 'string';
                s0.properties.Output.properties[a.Name] = {
                    type: 'string',
                    description: a.Description ?? '',
                    title: formatArgFieldTitle(a.Name, outType),
                    default: a.DefaultValue ?? '',
                    AllowVariableTarget: true,
                    VariableType: outType,
                };

                const arg = s0.properties.Output.properties[a.Name];

                if (errors && errors[a.Name]) {
                    arg.formatData = { error: errors[a.Name].Message };

                    // For this specific error, add a button that will automatically add the named variable
                    if (errors[a.Name].Message == 'Variable name is not defined')
                        arg.formatData.buttons = [{
                            icon: 'mdi-plus',
                            tooltip: 'Add variable',
                            action: (e, v) => this.autoAddVariable(a.Name, v),
                        }];
                }
            }

            s0 = await utils.schema.resolve(s0);
            s0 = cloneDeep(s0); // Clone so adding the errors below will not alter the original schema

            // Must put the errors back for the resolved schema arguments
            if (errors)
                for (let argName of Object.keys(s0.properties.Arguments.properties)) {
                    let arg = s0.properties.Arguments.properties[argName];
                    if (errors[argName])
                        applyArgCompilerError(arg, errors[argName]);
                }

            // Per-arg AllowVariable from NativePalette (and Method/Tool defs) — apply to leaves after $ref resolve.
            const allowVariableByArg = {};
            for (const a of tool.Arguments || []) {
                if (a?.Name && a.AllowVariable)
                    allowVariableByArg[a.Name] = true;
            }
            this.convertSchemaToEditable(s0.properties.Arguments.properties, allowVariableByArg);

            const matchSchema = buildMatchPortsSchema(tool);
            if (matchSchema)
                s0.properties.MatchPorts = matchSchema;

            return s0;
        },
        /**
         * @param {Record<string, object>} props
         * @param {Record<string, boolean>|boolean} [allowVariable] top-level name→flag map, or boolean for nested walk
         */
        convertSchemaToEditable(props, allowVariable = false, seen) {
            if (!props)
                return;
            if (!seen)
                seen = new WeakSet();
            for (let key of Object.keys(props)) {
                const p = props[key];
                if (!p || typeof p !== 'object' || seen.has(p))
                    continue;
                seen.add(p);

                const inherited = typeof allowVariable === 'object' ? !!allowVariable[key] : !!allowVariable;
                const allow = inherited || allowsVariableFlag(p);
                const optedIn = allow || compositionMemberAllowsVariable(p);
                const variableType = p.VariableType
                    || p.formatData?.VariableType
                    || (typeof allowVariable === 'object' && allowVariable[key] && props[key]?.VariableType)
                    || undefined;

                // Compositions are merged later by resolve_Of. Walk them so a boolean
                // AllowVariable flag is stamped before the form still sees type boolean.
                this.convertSchemaToEditable(compositionBag(p.allOf), allow, seen);
                this.convertSchemaToEditable(compositionBag(p.oneOf), allow, seen);
                this.convertSchemaToEditable(compositionBag(p.anyOf), allow, seen);

                switch (p.type) {
                    case 'string':
                        if (!p.formatData) p.formatData = {};
                        p.formatData.EllipsisButton = this.openArgumentEditor;
                        // Do not copy a parent argument's AllowVariable onto string leaves.
                        if (allowsVariableFlag(p)) {
                            p.formatData.AllowVariable = true;
                            if (variableType) {
                                p.VariableType = variableType;
                                p.formatData.VariableType = variableType;
                            }
                        }
                        break;

                    case 'integer':
                    case 'number':
                        // Schema leaves stay numeric unless that property opted into expressions.
                        if (!allowsVariableFlag(p)) {
                            if (typeof p.default === 'string') {
                                const coerced = coerceLiteralNumericValue(p.default, p.type === 'integer');
                                if (typeof coerced === 'number')
                                    p.default = coerced;
                            }
                            break;
                        }
                        if (!p.formatData) p.formatData = {};
                        p.formatData.EllipsisButton = this.openArgumentEditor;
                        p.formatData.AllowVariable = true;
                        {
                            const vtype = variableType || (p.type === 'integer' ? 'int' : 'double');
                            p.VariableType = vtype;
                            p.formatData.VariableType = vtype;
                        }
                        // Keep a numeric default as a number. getDefaultModel copies it
                        // onto a new icon, and the essentials number box validates a number.
                        p.type = 'string';
                        break;

                    case 'object':
                        if (p.properties)
                            this.convertSchemaToEditable(p.properties, allow, seen);
                        break;

                    case 'array':
                        if (!p.items)
                            break;
                        if (Array.isArray(p.items)) {
                            const tuple = {};
                            for (let i = 0; i < p.items.length; i++)
                                tuple[i] = p.items[i];
                            this.convertSchemaToEditable(tuple, allow, seen);
                        }
                        else if (typeof p.items === 'object') {
                            this.convertSchemaToEditable({ _: p.items }, allow, seen);
                        }
                        break;

                    case 'boolean':
                        // String + true/false titleMap is the editable dropdown PropertyGrid2 already renders.
                        if (!p.formatData) p.formatData = {};
                        // Stamp before the AllowExpressions exit so a schema boolean that stays a
                        // real checkbox still exposes AllowVariable to the essentials icon.
                        if (optedIn) {
                            p.AllowVariable = true;
                            p.formatData.AllowVariable = true;
                            const boolType = variableType || 'bool';
                            p.VariableType = boolType;
                            p.formatData.VariableType = boolType;
                        }
                        if (p.formatData.AllowExpressions === false) break;

                        p.type = 'string';
                        p.titleMap = [{ name: 'true', value: 'true' }, { name: 'false', value: 'false' }];
                        p.formatData.AllowCustomInput = true;
                        // Property grid keeps the string dropdown. Essentials still renders a checkbox.
                        p.formatData.EssentialsCheckbox = true;
                        if (('default' in p) && (p.default !== undefined) && (typeof p.default !== 'string') && (p.default !== null))
                            p.default = p.default ? 'true' : 'false';
                        break;
                }
            }
        },

        handleDragStart(ev, item) {
            if (this.editorReadOnly) {
                ev.preventDefault();
                return;
            }
            ev.dataTransfer.effectAllowed = 'copy';
            ev.dataTransfer.setData('application/json', JSON.stringify({
                Type: item.type, // 'Tool',
                Item: item,

                path: item.path,
                id: item.id,
                Name: item.name,
                icon: item.icon,
                args: item.Arguments,
                returntype: item.ReturnType,
                links: item.Links,

                props: item.props,
                schema: item.schema,
                out: item.Out,
            }));
            ev.dataTransfer.setDragImage(ev.target, 10, 10);
        },
        onCanvasDragOver(ev) {
            if (isFolderProjectDrag(ev.dataTransfer)) {
                if (ev.dataTransfer)
                    ev.dataTransfer.dropEffect = 'none';
                this.canvasRejectProjectDrop = true;
                return;
            }
            ev.preventDefault();
            if (ev.dataTransfer)
                ev.dataTransfer.dropEffect = 'copy';
            this.canvasRejectProjectDrop = false;
        },
        onCanvasDragLeave(ev) {
            if (!ev.currentTarget.contains(ev.relatedTarget))
                this.canvasRejectProjectDrop = false;
        },
        onCanvasDrop(ev) {
            this.canvasRejectProjectDrop = false;
            if (isFolderProjectDrag(ev.dataTransfer)) {
                ev.preventDefault();
                return;
            }
            this.handleDrop(ev);
        },
        async handleDrop(ev) {
            if (this.editorReadOnly)
                return;
            const dataStr = ev.dataTransfer.getData('application/json');
            const draggedData = JSON.parse(dataStr);
            if (draggedData?.Type == 'Project' || draggedData?.origin == 'FlowV2FolderTree' && draggedData?.Type == 'Project')
                return;

            // Convert client coordinates (screen space) to paper local coordinates
            const localPoint = this.paper.clientToLocalPoint(ev.clientX, ev.clientY);
            const position = { x: localPoint.x - default_props.width / 2, y: localPoint.y - default_props.height / 2 };
            const instance_id = utils.generateUUID();

            switch (draggedData.Type) {
                case 'Native':
                case 'Method':
                case 'Tool':
                    {
                        if (!draggedData.Item) return;
                        const item = await this.addFlowItem(
                            {
                                Type: draggedData.Type,
                                ToolID: draggedData.Item.id,
                                InstanceID: instance_id,
                                Location: { X: position.x, Y: position.y },
                            });

                        this.syncFlowChanges({
                            EventType: 'Add',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    Type: draggedData.Type,
                                    ToolID: draggedData.Item.id,
                                    InstanceID: instance_id,
                                    Caption: item.API.Caption,
                                    Arguments: item.Arguments,
                                    Output: item.Output,
                                    MatchPorts: item.MatchPorts,
                                    Links: [],
                                    Location: { X: position.x, Y: position.y },
                                }
                            },
                        }, true);
                    }
                    break;

                case 'FlowHeader':
                case 'APIHeader':
                    {
                        if (!await this.canDropSiblingMethod(draggedData))
                            return;
                        const item = await this.addFlowItem(
                            {
                                Type: draggedData.Type,
                                ToolID: draggedData.ID,
                                InstanceID: instance_id,
                                Location: { X: position.x, Y: position.y },
                            });

                        this.syncFlowChanges({
                            EventType: 'Add',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    Type: draggedData.Type,
                                    ToolID: draggedData.ID,
                                    InstanceID: instance_id,
                                    Caption: item.API.Caption,
                                    Arguments: item.Arguments,
                                    Output: item.Output,
                                    MatchPorts: item.MatchPorts,
                                    Links: [],
                                    Location: { X: position.x, Y: position.y },
                                }
                            },
                        }, true);
                    }
                    break;
            }
        },

        highlightConnectedLinks(element) {
            const links = this.graph.getLinks();
            links.forEach((link) => {
                if (link.get('source').id === element.id) {
                    // Outgoing link
                    link.attr('line/stroke', '#000000'); // Red for outgoing
                    link.attr('line/stroke-width', 3);
                } else if (link.get('target').id === element.id) {
                    // Incoming link
                    link.attr('line/stroke', '#AAAAAA'); // Green for incoming
                    link.attr('line/stroke-width', 1);
                }
            });
        },
        clearLinkHighlights() {
            const links = this.graph.getLinks();
            links.forEach((link) => {
                link.attr('line/stroke', '#000000'); // Default color
                link.attr('line/stroke-width', 1); // Default width
            });
        },
        updateHighlights() {
            // Clear existing highlights
            this.graph.getElements().forEach((cell) => {
                if (this.originalAttrs.has(cell.id)) {
                    const original = this.originalAttrs.get(cell.id);
                    cell.attr('body', original);
                    this.originalAttrs.delete(cell.id);
                }
            });
            // Highlight selected cells
            this.selectedCells.forEach((cell) => {
                // Store original attributes before modifying
                const currentAttrs = cell.attr('body');
                this.originalAttrs.set(cell.id, { ...currentAttrs });
                // Apply highlight
                cell.attr('body', {
                    //fill: 'lightblue',
                    stroke: 'orange',
                    strokeWidth: 2,
                });
            });
        },
        clearSelected() {
            this.closeIconPropertyOverlay();

            if (this.selected)
                this.selected.unhighlight(this.selected.el);

            this.clearLinkHighlights();
            this.disposePropertyWatches();

            this.showInput = false;

            this.selected = null;
            this.schema = null;
            this.model = null;
            this.tool = null;
            this.selectedHasBreakpoint = false;
            this.batchBanner = '';
            this.batchSelectionKey = '';

            this.$refs.folderGrid?.clearCanvasSourceHighlight?.();

            this.scheduleSaveCanvasViewState();
        },

        disposePropertyWatches() {
            // Argument edits wait 2s. Cancel drops that send, so leaving the icon
            // or the flow loses ReturnValue and every other pending property.
            this.flushPendingPropertyEdits();
            if (this.watchCaption)
                this.watchCaption();
            if (this.watchArgs)
                this.watchArgs();
            if (this.watchOutput)
                this.watchOutput();
            if (this.watchMatchPorts)
                this.watchMatchPorts();
            this.watchCaption = null;
            this.watchArgs = null;
            this.watchOutput = null;
            this.watchMatchPorts = null;
            this.disposeBatchWatch();
        },

        flushPendingPropertyEdits() {
            this.debouncedUpdateArgs?.flush?.();
            this.debouncedUpdateOutput?.flush?.();
            this.debouncedUpdateMatchPorts?.flush?.();
            this.debouncedUpdateCaption?.flush?.();
            this.debouncedUpdateArgs?.cancel?.();
            this.debouncedUpdateOutput?.cancel?.();
            this.debouncedUpdateMatchPorts?.cancel?.();
            this.debouncedUpdateCaption?.cancel?.();
        },

        disposeBatchWatch() {
            this._batchGen = (this._batchGen || 0) + 1;
            if (this.watchBatch) {
                this.watchBatch();
                this.watchBatch = null;
            }
            // Persist a pending edit before the selection or panel goes away.
            this._batchFlush?.flush?.();
            this._batchFlush?.cancel?.();
            this._batchShadow = null;
            this._batchCells = null;
        },

        batchEditingEnabled() {
            return !!(this.propertiesAdvancedMode && this.propertiesPinned);
        },

        batchSelectionCells() {
            if (this.selectedCells?.length)
                return this.selectedCells.slice();
            if (this.selected?.model?.isElement?.())
                return [this.selected.model];
            return [];
        },

        /**
         * Advanced + Pinned: bind the docked grid to every usable icon in selectedCells.
         * One icon falls through to the normal single-tool editor.
         */
        async applyCanvasMultiSelection() {
            if (!this.batchEditingEnabled())
                return;
            const cells = (this.selectedCells || []).filter((cell) => cell?.isElement?.() && cell.attributes?.prop);
            const usable = cells.filter((cell) => {
                const prop = cell.attributes.prop;
                return !prop.Unavailable && prop.Model && prop.ToolID;
            });
            if (usable.length >= 2) {
                await this.showBatchProperties(usable);
                return;
            }
            const single = cells.length === 1 ? cells[0] : (usable.length === 1 ? usable[0] : null);
            if (!single)
                return;
            const view = this.paper?.findViewByModel(single);
            if (view)
                await this.selectCellView(view);
        },

        async toggleBatchCell(cellView) {
            const cell = cellView?.model;
            if (!cell?.isElement?.() || !cell.attributes?.prop?.Model)
                return;

            const current = this.batchSelectionCells();
            const exists = current.some((item) => item.id === cell.id);
            const next = exists ? current.filter((item) => item.id !== cell.id) : current.concat([cell]);

            if (next.length >= 2) {
                this.selectedCells = next;
                this.updateHighlights();
                const stamp = next.map((item) => item.id).join('|');
                const ok = await this.showBatchProperties(next);
                const currentStamp = (this.selectedCells || []).map((item) => item.id).join('|');
                if (!ok && currentStamp === stamp)
                    await this.applyCanvasMultiSelection();
                this.scheduleSaveCanvasViewState();
                return;
            }

            this.selectedCells = [];
            this.updateHighlights();
            this.clearSelected();
            if (next.length === 1) {
                const view = this.paper?.findViewByModel(next[0]);
                if (view)
                    await this.selectCellView(view);
            }
            this.scheduleSaveCanvasViewState();
        },

        syncBatchEditorMode() {
            if (this.batchEditingEnabled()) {
                if ((this.selectedCells?.length || 0) > 1)
                    this.applyCanvasMultiSelection();
                return;
            }
            this.disposeBatchWatch();
            if ((this.selectedCells?.length || 0) > 1) {
                this.schema = null;
                this.model = null;
                this.tool = null;
                this.batchBanner = '';
                this.batchSelectionKey = '';
            }
        },

        async showBatchProperties(cells) {
            this.disposePropertyWatches();
            const gen = this._batchGen;
            if (this.selected) {
                this.selected.unhighlight(this.selected.el);
                this.selected = null;
            }
            this.selectedHasBreakpoint = false;
            this.clearLinkHighlights();
            this.tool = null;
            this.schema = null;
            this.model = null;
            this.batchBanner = '';
            this.batchSelectionKey = '';

            const usable = [];
            for (const cell of cells || []) {
                const prop = cell?.attributes?.prop;
                if (!cell?.isElement?.() || !prop?.Model || prop.Unavailable || !prop.ToolID)
                    continue;
                usable.push(cell);
            }
            if (usable.length < 2 || gen !== this._batchGen)
                return false;

            const schemas = [];
            const models = [];
            const kept = [];
            for (const cell of usable) {
                if (gen !== this._batchGen)
                    return false;
                const prop = cell.attributes.prop;
                let schema = null;
                try {
                    const tool = await this.resolveToolForProp(prop);
                    if (tool)
                        schema = await this.generateSchemaFromArgs(tool);
                }
                catch (err) {
                    console.warn('FlowV2: batch schema failed', err);
                }
                if (gen !== this._batchGen)
                    return false;
                if (!schema)
                    continue;
                schemas.push(schema);
                if (prop.Model)
                    coerceModelToLiteralNumerics(schema, prop.Model);
                models.push(prop.Model);
                kept.push(cell);
            }
            if (gen !== this._batchGen || kept.length < 2)
                return false;

            const built = buildBatchPropertyModel(schemas, models);
            built.model.$objectId = utils.generateUUID();
            this._batchShadow = cloneValue(built.model);
            this._batchCells = kept;
            this.schema = built.schema;
            this.model = built.model;
            this.batchBanner = `Editing ${kept.length} icons. Blank fields differ.`;
            this.batchSelectionKey = kept
                .map((cell) => cell.attributes?.prop?.InstanceID || cell.id)
                .filter(Boolean)
                .sort()
                .join('|');
            this.watchBatch = this.$watch(
                () => this.model,
                () => { this._batchFlush?.(); },
                { deep: true },
            );
            return true;
        },

        flushBatchEdits() {
            if (this.editorReadOnly)
                return;
            const shadow = this._batchShadow;
            const model = this.model;
            const cells = this._batchCells;
            const schema = this.schema;
            if (!shadow || !model || !schema || !cells?.length)
                return;

            const changes = listChangedLeaves(shadow, model, schema);
            if (!changes.length)
                return;

            let captionChanged = false;
            let argsChanged = false;
            let outputChanged = false;
            let matchChanged = false;
            for (const change of changes) {
                const section = change.path[0];
                if (section === 'API' && change.path[1] !== 'Caption')
                    continue;
                if (section === 'API')
                    captionChanged = true;
                else if (section === 'Arguments')
                    argsChanged = true;
                else if (section === 'Output')
                    outputChanged = true;
                else if (section === 'MatchPorts')
                    matchChanged = true;
                else
                    continue;

                for (const cell of cells) {
                    const prop = cell.attributes?.prop;
                    if (!prop?.Model)
                        continue;
                    setAtPath(prop.Model, change.path, change.value);
                    if (section === 'API')
                        cell.attr('label/text', formatDisplayName(change.value == null ? '' : String(change.value)));
                }
            }

            for (const cell of cells) {
                const prop = cell.attributes?.prop;
                if (!prop?.Model)
                    continue;
                const instanceId = prop.InstanceID;
                if (captionChanged) {
                    this.syncFlowChanges({
                        EventType: 'UpdateCaption',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                InstanceID: instanceId,
                                Caption: prop.Model.API?.Caption,
                            },
                        },
                    });
                }
                if (argsChanged) {
                    this.syncFlowChanges({
                        EventType: 'UpdateArgs',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                Type: prop.Type,
                                InstanceID: instanceId,
                                Arguments: prop.Model.Arguments,
                            },
                        },
                    }, true);
                }
                if (outputChanged) {
                    this.syncFlowChanges({
                        EventType: 'UpdateOutput',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                Type: prop.Type,
                                InstanceID: instanceId,
                                Output: prop.Model.Output,
                            },
                        },
                    }, true);
                }
                if (matchChanged) {
                    this.syncIconPorts(cell);
                    this.syncFlowChanges({
                        EventType: 'UpdateMatchPorts',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                Type: prop.Type,
                                InstanceID: instanceId,
                                MatchPorts: prop.Model.MatchPorts,
                            },
                        },
                    }, true);
                }
            }

            this._batchShadow = cloneValue(model);
        },

        async element_contextmenu(cellView, evt) {
            evt?.preventDefault?.();
            evt?.stopPropagation?.();
            if (!cellView?.model?.isElement?.())
                return;

            this.clearSelected();
            await this.selectCellView(cellView);
            if (!this.propertiesPinned)
                this.openIconPropertyOverlay(cellView);
        },

        createSiblingHoverToolsView(elementView) {
            const prop = elementView?.model?.attributes?.prop;
            const showOpen = !!(prop?.ToolID && prop.ToolID !== this.FlowID);
            const methodName = siblingMethodDisplayName(prop);
            const scale = siblingHoverButtonScale(this.scale);
            const tools = [
                new elementTools.Button({
                    name: 'identify',
                    markup: siblingHoverButtonMarkup(SIBLING_HOVER_MAGNIFY_PATH, 'Show in tree'),
                    x: 0,
                    y: 0,
                    offset: SIBLING_HOVER_IDENTIFY_OFFSET,
                    scale,
                    action: (_evt, view) => this.identifySiblingMethodFromCanvas(view),
                }),
            ];
            if (showOpen) {
                tools.push(new elementTools.Button({
                    name: 'open',
                    markup: siblingHoverButtonMarkup(SIBLING_HOVER_OPEN_PATH, `Open ${methodName}`),
                    x: 0,
                    y: 0,
                    offset: SIBLING_HOVER_OPEN_OFFSET,
                    scale,
                    action: (_evt, view) => this.openSiblingMethodFromCanvas(view),
                }));
            }
            return new dia.ToolsView({ name: 'sibling-hover', tools });
        },

        showSiblingHoverTools(elementView) {
            if (!elementView?.model?.isElement?.())
                return;
            const prop = elementView.model.attributes.prop;
            if (!isSiblingMethodProp(prop))
                return;
            if (this.isPanning || this.groupMove || this.selectionRect)
                return;
            this.cancelSiblingToolHide();
            if (this._siblingToolCellView === elementView && elementView.hasTools?.('sibling-hover'))
                return;
            this.hideSiblingHoverTools();
            elementView.addTools(this.createSiblingHoverToolsView(elementView));
            this._siblingToolCellView = elementView;
            this.bindSiblingToolPointerGuards(elementView);
        },

        bindSiblingToolPointerGuards(elementView) {
            this.unbindSiblingToolPointerGuards();
            const toolsEl = elementView?._toolsView?.el;
            if (!toolsEl)
                return;
            const enter = () => {
                this._siblingToolsPointerInside = true;
                this.cancelSiblingToolHide();
            };
            const leave = () => {
                this._siblingToolsPointerInside = false;
                this.scheduleHideSiblingHoverTools();
            };
            toolsEl.addEventListener('mouseenter', enter);
            toolsEl.addEventListener('mouseleave', leave);
            this._siblingToolGuardCleanup = () => {
                toolsEl.removeEventListener('mouseenter', enter);
                toolsEl.removeEventListener('mouseleave', leave);
            };
        },

        unbindSiblingToolPointerGuards() {
            if (this._siblingToolGuardCleanup) {
                this._siblingToolGuardCleanup();
                this._siblingToolGuardCleanup = null;
            }
            this._siblingToolsPointerInside = false;
        },

        hideSiblingHoverTools() {
            this.cancelSiblingToolHide();
            this.unbindSiblingToolPointerGuards();
            const view = this._siblingToolCellView;
            this._siblingToolCellView = null;
            if (view?.removeTools)
                view.removeTools();
        },

        cancelSiblingToolHide() {
            if (this._siblingToolHideTimer) {
                clearTimeout(this._siblingToolHideTimer);
                this._siblingToolHideTimer = null;
            }
        },

        scheduleHideSiblingHoverTools() {
            this.cancelSiblingToolHide();
            this._siblingToolHideTimer = setTimeout(() => {
                this._siblingToolHideTimer = null;
                if (this._siblingToolsPointerInside)
                    return;
                this.hideSiblingHoverTools();
            }, 250);
        },

        element_mouseenter(elementView) {
            this.showSiblingHoverTools(elementView);
        },

        element_mouseleave(elementView, evt) {
            const related = eventRelatedTarget(evt);
            if (related && (elementView?.el?.contains?.(related) || isEventInsideJointTools(related))) {
                this._siblingToolsPointerInside = isEventInsideJointTools(related);
                this.cancelSiblingToolHide();
                return;
            }
            this.scheduleHideSiblingHoverTools();
        },

        blank_mouseenter() {
            this.hideSiblingHoverTools();
        },

        identifySiblingMethodFromCanvas(elementView) {
            const toolId = elementView?.model?.attributes?.prop?.ToolID;
            if (!toolId)
                return;
            this.$refs.folderGrid?.revealCanvasSource?.(toolId);
        },

        async openSiblingMethodFromCanvas(elementView) {
            const prop = elementView?.model?.attributes?.prop;
            const toolId = prop?.ToolID;
            if (!toolId || toolId === this.FlowID)
                return;
            if (this.$refs.folderGrid?.openFlowById?.(toolId))
                return;
            let parentID;
            try {
                const proj = await utils.api.get(`Apps/FlowV2/GetMethodProject?Type=${prop.Type}&ID=${toolId}`);
                const result = proj?.Result || proj;
                parentID = result?.ID || result?.ProjectID;
            }
            catch (_) { /* fall through with name/type only */ }
            const tool = await this.fetchFlowTool(toolId, prop.Type);
            this.SetActiveFlowID(toolId, prop.Type, tool?.name || siblingMethodDisplayName(prop), parentID);
        },

        onFlowScrollContainerScroll() {
            if (this.iconOverlayVisible)
                this.updateIconOverlayPosition();
            this.scheduleSaveCanvasViewState();
        },

        openIconPropertyOverlay(cellView) {
            if (!cellView?.model?.isElement?.() || this.propertiesPinned)
                return;

            // Toggle closed if already open on this icon
            if (this.iconOverlayVisible && this.iconOverlayCellView === cellView) {
                this.closeIconPropertyOverlay();
                return;
            }

            // Close any other open popup first
            if (this.iconOverlayVisible)
                this.closeIconPropertyOverlay();

            this.iconOverlayCellView = cellView;
            this.iconOverlayVisible = true;

            const width = this.iconOverlaySize.width || OVERLAY_WIDTH_PX;
            // Essential starts with a modest height; content-height events grow it
            if (!this.propertiesAdvancedMode) {
                this.iconOverlaySize = {
                    width,
                    height: OVERLAY_HEIGHT_ESSENTIAL_MIN_PX,
                };
            }
            else {
                this.iconOverlaySize = {
                    width,
                    height: this.iconOverlaySize.height || OVERLAY_HEIGHT_ADVANCED_PX,
                };
            }

            this.$nextTick(() => {
                this.updateIconOverlayPosition();
            });
        },

        closeIconPropertyOverlay() {
            this.iconOverlayVisible = false;
            this.iconOverlayCellView = null;
            this.iconOverlayPlacement = 'right';
        },

        setPropertiesPinned(value) {
            this.propertiesPinned = !!value;
            common.saveGlobalSetting.call(this, 'propertiesPinned', this.propertiesPinned);
            if (this.propertiesPinned)
                this.closeIconPropertyOverlay();
            this.syncBatchEditorMode();
        },

        setPropertiesAdvancedMode(value) {
            this.propertiesAdvancedMode = !!value;
            common.saveGlobalSetting.call(this, 'propertiesAdvancedMode', this.propertiesAdvancedMode);

            const width = this.iconOverlaySize.width || OVERLAY_WIDTH_PX;
            if (this.propertiesAdvancedMode) {
                this.iconOverlaySize = {
                    width,
                    height: this.iconOverlaySize.height || OVERLAY_HEIGHT_ADVANCED_PX,
                };
            }
            else {
                this.iconOverlaySize = {
                    width,
                    height: OVERLAY_HEIGHT_ESSENTIAL_MIN_PX,
                };
            }

            if (this.iconOverlayVisible)
                this.$nextTick(() => this.updateIconOverlayPosition());
            this.syncBatchEditorMode();
        },

        onIconOverlayResize({ width, height }) {
            // Overlay emits paper-local sizes (resize deltas already divided by scale)
            const next = {
                width: this.iconOverlaySize.width || OVERLAY_WIDTH_PX,
                height: this.iconOverlaySize.height || OVERLAY_HEIGHT_ADVANCED_PX,
            };
            if (typeof width === 'number' && width > 0) {
                next.width = Math.max(OVERLAY_MIN_WIDTH_PX, Math.round(width));
                common.saveGlobalSetting.call(this, 'iconOverlayWidth', next.width);
            }
            if (this.propertiesAdvancedMode && typeof height === 'number' && height > 0) {
                next.height = Math.max(OVERLAY_HEIGHT_ESSENTIAL_MIN_PX, Math.round(height));
                common.saveGlobalSetting.call(this, 'iconOverlayAdvancedHeight', next.height);
            }
            this.iconOverlaySize = next;
            if (this.iconOverlayVisible)
                this.updateIconOverlayPosition();
        },

        onIconOverlayContentHeight(paperLocalHeight) {
            // Essential auto-size: overlay measures in paper-local px (pre-transform)
            if (this.propertiesAdvancedMode || !this.iconOverlayVisible)
                return;
            const localH = Math.max(OVERLAY_HEIGHT_ESSENTIAL_MIN_PX, Math.round(paperLocalHeight));
            if (Math.abs((this.iconOverlaySize.height || 0) - localH) < 2)
                return;
            this.iconOverlaySize = {
                width: this.iconOverlaySize.width || OVERLAY_WIDTH_PX,
                height: localH,
            };
            this.updateIconOverlayPosition();
        },

        /**
         * Anchor the property popup next to the icon, positioned against the FlowV2 root
         * so it can paint over Splitpane side panels (Tool Palette / Project Browser).
         * Prefer the right of the icon; flip left only when it would leave the designer.
         */
        updateIconOverlayPosition() {
            const cellView = this.iconOverlayCellView;
            const root = this.$el;
            if (!cellView || !this.paper || !root || !this.iconOverlayVisible)
                return;

            const bbox = cellView.model.getBBox();
            const gap = 8;
            const s = this.scale || 1;
            const rootRect = root.getBoundingClientRect();
            const overlayW = (this.iconOverlaySize.width || OVERLAY_WIDTH_PX) * s;
            const inset = 8;
            const rightLimit = rootRect.width - inset;
            const leftLimit = inset;

            // Default: popup top-left just to the right of the icon (may cover Tool Palette)
            const rightAnchorClient = this.paper.localToClientPoint({
                x: bbox.x + bbox.width + gap,
                y: bbox.y,
            });
            let left = rightAnchorClient.x - rootRect.left;
            let top = rightAnchorClient.y - rootRect.top;
            let placement = 'right';

            if (left + overlayW > rightLimit) {
                // Flip to the left of the icon (may cover Project Browser)
                const leftAnchorClient = this.paper.localToClientPoint({
                    x: bbox.x - gap,
                    y: bbox.y,
                });
                left = leftAnchorClient.x - rootRect.left - overlayW;
                placement = 'left';
                // Prefer staying inside the designer when possible
                if (left < leftLimit)
                    left = leftLimit;
            }

            // Space available below within the designer → paper-local maxHeight
            const availableBelowScreen = Math.max(
                OVERLAY_HEIGHT_ESSENTIAL_MIN_PX * s,
                rootRect.height - (rightAnchorClient.y - rootRect.top) - inset
            );

            this.iconOverlayPlacement = placement;
            this.iconOverlayPosition = { left, top };
            this.iconOverlayMaxHeight = Math.max(
                OVERLAY_HEIGHT_ESSENTIAL_MIN_PX,
                Math.round(availableBelowScreen / s)
            );
        },

        applyUnavailablePropertyForm(prop) {
            const source = prop?.Model && typeof prop.Model === 'object' ? prop.Model : {};
            const model = cloneDeep(source);
            if (!model.API || typeof model.API !== 'object' || Array.isArray(model.API))
                model.API = {};
            if (!model.API.Name)
                model.API.Name = UNAVAILABLE_TOOL_TITLE;
            this.schema = inferUnavailableToolSchema(model);
            this.model = model;
            this.tool = null;
        },

        async resolveToolForProp(prop) {
            if (!prop?.ToolID || prop.Unavailable)
                return null;
            switch (prop.Type) {
                case 'Native':
                case 'Method':
                case 'Tool':
                    return this.toolPalette?.[prop.ToolID] || null;
                case 'FlowHeader':
                case 'APIHeader':
                    return await this.fetchFlowTool(prop.ToolID, prop.Type);
                default:
                    return null;
            }
        },

        async updateSelected(prop) {
            if (prop?.Unavailable) {
                this.applyUnavailablePropertyForm(prop);
                return;
            }
            const tool = await this.resolveToolForProp(prop);
            if (tool)
                this.schema = await this.generateSchemaFromArgs(tool, prop.Errors ?? {});
            else
                this.schema = null;

            if (this.schema && prop?.Model)
                coerceModelToLiteralNumerics(this.schema, prop.Model);

            this.model = prop.Model;
            this.tool = tool;
        },

        flowFindTargetIsPaperArea(target) {
            const host = this.$refs.flowEditorHost;
            if (!host || !target || this.ItemType !== 'FlowHeader') return false;
            if (target.closest('.c-FlowV2-find-widget')) return false;
            return host.contains(target);
        },

        openFlowFind() {
            if (this.ItemType !== 'FlowHeader' || !this.graph || !this.paper) return;
            this.flowFindOpen = true;
            this.$nextTick(() => {
                this.$refs.flowFindInput?.focus?.();
            });
        },

        closeFlowFind() {
            this.flowFindOpen = false;
            this.flowFindQuery = '';
            this.flowFindMatchCells = [];
            this.flowFindNavIndex = -1;
            this.clearFlowFindMatchHighlights();
            if (this.graph && this.paper) {
                this.selectedCells = [];
                this.updateHighlights();
            }
            if (this.watchBatch || this.batchBanner)
                this.clearSelected();
        },

        clearFlowFindMatchHighlights() {
            if (!this.graph) {
                this.flowFindOriginalBodyAttrs.clear();
                return;
            }
            for (const [id, orig] of this.flowFindOriginalBodyAttrs) {
                const c = this.graph.getCell(id);
                if (!c || !orig) continue;
                c.attr('body/stroke', orig.stroke);
                c.attr('body/strokeWidth', orig.strokeWidth);
                if (orig.strokeDasharray != null && orig.strokeDasharray !== '')
                    c.attr('body/strokeDasharray', orig.strokeDasharray);
                else
                    c.attr('body/strokeDasharray', '');
            }
            this.flowFindOriginalBodyAttrs.clear();
        },

        getFlowSearchableElements() {
            if (!this.graph) return [];
            return this.graph.getElements()
                .filter((c) => c.isElement() && c.get('prop')?.ToolID)
                .sort((a, b) => {
                    const pa = a.get('position');
                    const pb = b.get('position');
                    if (pa.y !== pb.y) return pa.y - pb.y;
                    return pa.x - pb.x;
                });
        },

        flowFindShallowValuesToString(obj) {
            if (!obj || typeof obj !== 'object') return '';
            const parts = [];
            for (const v of Object.values(obj)) {
                if (v == null) continue;
                if (typeof v === 'object') parts.push(JSON.stringify(v));
                else parts.push(String(v));
            }
            return parts.join(' ');
        },

        buildFlowFindHaystack(cell) {
            const prop = cell.get('prop');
            const parts = [];
            const cap = prop?.Model?.API?.Caption ?? cell.attr('label/text');
            if (cap != null && cap !== '') parts.push(String(cap));
            const title = cell.attr('title/text');
            if (title != null && title !== '') parts.push(String(title));
            if (prop?.ToolID && this.toolPalette[prop.ToolID]?.name)
                parts.push(String(this.toolPalette[prop.ToolID].name));
            if (prop?.Model?.Arguments)
                parts.push(this.flowFindShallowValuesToString(prop.Model.Arguments));
            if (prop?.Model?.Output && typeof prop.Model.Output === 'object')
                parts.push(this.flowFindShallowValuesToString(prop.Model.Output));
            if (prop?.Model?.MatchPorts && typeof prop.Model?.MatchPorts === 'object')
                parts.push(this.flowFindShallowValuesToString(prop.Model.MatchPorts));
            return parts.join(' ');
        },

        flowFindTestMatch(haystack, query) {
            const q = (query || '').trim();
            if (!q || !haystack) return false;
            if (this.flowFindCaseSensitive)
                return haystack.includes(q);
            return haystack.toLowerCase().includes(q.toLowerCase());
        },

        recomputeFlowFindMatches() {
            this.clearFlowFindMatchHighlights();
            const query = (this.flowFindQuery || '').trim();
            this.flowFindMatchCells = [];
            this.flowFindNavIndex = -1;
            if (!this.graph || !query) return;

            const matches = this.getFlowSearchableElements().filter((cell) =>
                this.flowFindTestMatch(this.buildFlowFindHaystack(cell), query));

            this.flowFindMatchCells = matches;

            // Use subpath attrs only so Joint's gradient fill on `body` is preserved (full `body` merge can drop it).
            // Stroke must contrast with default icon stroke (#4285F4) — previous #6b9eff was nearly invisible.
            const hiliteStroke = '#e65100';
            const hiliteWidth = 3;
            const hiliteDash = '4 3';

            for (const cell of matches) {
                if (!this.flowFindOriginalBodyAttrs.has(cell.id)) {
                    this.flowFindOriginalBodyAttrs.set(cell.id, {
                        stroke: cell.attr('body/stroke'),
                        strokeWidth: cell.attr('body/strokeWidth'),
                        strokeDasharray: cell.attr('body/strokeDasharray'),
                    });
                }
                cell.attr('body/stroke', hiliteStroke);
                cell.attr('body/strokeWidth', hiliteWidth);
                cell.attr('body/strokeDasharray', hiliteDash);
            }
        },

        getFlowFindStatusText() {
            const n = this.flowFindMatchCells.length;
            const q = (this.flowFindQuery || '').trim();
            if (!q) return '';
            if (n === 0) return 'No results';
            if (this.flowFindNavIndex < 0) return `${n} match${n > 1 ? 'es' : ''}`;
            return `${this.flowFindNavIndex + 1} of ${n}`;
        },

        scrollFlowFindMatchIntoView(cell) {
            const view = this.paper?.findViewByModel(cell);
            if (!view?.el) return;
            try {
                view.el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
            catch (_) { /* ignore */ }
        },

        cancelScrollCellIntoViewAnimation() {
            this._scrollIntoViewToken = (this._scrollIntoViewToken || 0) + 1;
            if (this._scrollIntoViewRaf != null) {
                cancelAnimationFrame(this._scrollIntoViewRaf);
                this._scrollIntoViewRaf = null;
            }
        },

        /**
         * Smoothly center a graph cell in the flowchart scroll container when it
         * is off-screen or clipped. No-ops when already fully visible with padding.
         * Uses a short rAF ease-out (native scroll-behavior:smooth is unreliable
         * on this nested overflow container).
         */
        scrollCellIntoScrollContainer(cell, { padding = 40, durationMs = 280 } = {}) {
            const container = this.$refs.scrollContainer;
            const view = this.paper?.findViewByModel(cell);
            const el = view?.el;
            if (!container || !el) return;

            const cRect = container.getBoundingClientRect();
            const eRect = el.getBoundingClientRect();
            if (cRect.width <= 0 || cRect.height <= 0) return;

            const fullyVisible =
                eRect.left >= cRect.left + padding &&
                eRect.right <= cRect.right - padding &&
                eRect.top >= cRect.top + padding &&
                eRect.bottom <= cRect.bottom - padding;
            if (fullyVisible) return;

            const deltaX = (eRect.left + eRect.width / 2) - (cRect.left + cRect.width / 2);
            const deltaY = (eRect.top + eRect.height / 2) - (cRect.top + cRect.height / 2);
            const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
            const maxTop = Math.max(0, container.scrollHeight - container.clientHeight);
            const toLeft = Math.min(maxLeft, Math.max(0, container.scrollLeft + deltaX));
            const toTop = Math.min(maxTop, Math.max(0, container.scrollTop + deltaY));
            const fromLeft = container.scrollLeft;
            const fromTop = container.scrollTop;
            if (Math.abs(toLeft - fromLeft) < 0.5 && Math.abs(toTop - fromTop) < 0.5)
                return;

            this.cancelScrollCellIntoViewAnimation();
            const token = this._scrollIntoViewToken;

            const duration = Math.max(80, durationMs);
            const start = performance.now();
            // easeOutCubic — quick start, soft landing
            const ease = (t) => 1 - Math.pow(1 - t, 3);

            const step = (now) => {
                if (token !== this._scrollIntoViewToken) {
                    this._scrollIntoViewRaf = null;
                    return;
                }
                const t = Math.min(1, (now - start) / duration);
                const k = ease(t);
                container.scrollLeft = fromLeft + (toLeft - fromLeft) * k;
                container.scrollTop = fromTop + (toTop - fromTop) * k;
                if (t < 1)
                    this._scrollIntoViewRaf = requestAnimationFrame(step);
                else
                    this._scrollIntoViewRaf = null;
            };
            this._scrollIntoViewRaf = requestAnimationFrame(step);
        },

        scheduleScrollDebugElementIntoView(element) {
            if (!element) return;
            const token = (this._scrollIntoViewToken = (this._scrollIntoViewToken || 0) + 1);
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    if (token !== this._scrollIntoViewToken) return;
                    this.scrollCellIntoScrollContainer(element);
                });
            });
        },

        async flowFindSelectAndScrollByIndex(index) {
            const n = this.flowFindMatchCells.length;
            if (n === 0 || index < 0 || index >= n) return;
            const cell = this.flowFindMatchCells[index];
            const cellView = this.paper.findViewByModel(cell);
            if (!cellView) return;

            this.selectedCells = [];
            this.updateHighlights();
            this.clearSelected();

            this.$refs.paperDiv?.focus?.();
            await this.selectCellView(cellView);
            this.flowFindNavIndex = index;
            this.scrollFlowFindMatchIntoView(cell);
        },

        async flowFindNext() {
            const n = this.flowFindMatchCells.length;
            if (n === 0) return;
            const next = this.flowFindNavIndex < 0 ? 0 : (this.flowFindNavIndex + 1) % n;
            await this.flowFindSelectAndScrollByIndex(next);
        },

        async flowFindPrevious() {
            const n = this.flowFindMatchCells.length;
            if (n === 0) return;
            const prev = this.flowFindNavIndex < 0 ? n - 1 : (this.flowFindNavIndex - 1 + n) % n;
            await this.flowFindSelectAndScrollByIndex(prev);
        },

        flowFindInputKeydown(e) {
            if ((e.ctrlKey || e.metaKey) && (e.key === 'f' || e.key === 'F')) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                this.closeFlowFind();
                this.$refs.paperDiv?.focus?.();
                return;
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                this.flowFindNext();
                return;
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                this.flowFindNext();
                return;
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                this.flowFindPrevious();
                return;
            }
        },

        //---- Flowchart event handlers ----//

        paper_KeyDown(e) {
            if (this.iconOverlayVisible && e.key === 'Escape') {
                e.preventDefault();
                this.closeIconPropertyOverlay();
                return;
            }

            if (this.flowFindOpen && e.key === 'Escape') {
                e.preventDefault();
                this.closeFlowFind();
                return;
            }

            if (this.flowFindOpen && this.flowFindTargetIsPaperArea(e.target)) {
                if (e.key === 'ArrowDown' || e.key === 'Enter') {
                    e.preventDefault();
                    this.flowFindNext();
                    return;
                }
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.flowFindPrevious();
                    return;
                }
            }

            if (this.ItemType === 'FlowHeader' && this.graph && (e.ctrlKey || e.metaKey) && (e.key === 'f' || e.key === 'F')) {
                if (this.flowFindTargetIsPaperArea(e.target)) {
                    e.preventDefault();
                    if (this.flowFindOpen)
                        this.$nextTick(() => this.$refs.flowFindInput?.focus?.());
                    else
                        this.openFlowFind();
                    return;
                }
            }

            if (this.editorReadOnly) {
                const key = e.key;
                const mod = e.ctrlKey || e.metaKey;
                if (key === 'Delete' || (mod && ['z', 'y', 'x', 'v', 'Z', 'Y', 'X', 'V'].includes(key)))
                    return;
            }

            switch (e.key) {
                case 'Tab':
                    if (e.shiftKey) {
                        e.preventDefault();
                        if (this.tabs.length > 1) {
                            let idx = this.tabs.findIndex(t => t.value == this.selected_tab);
                            if (idx >= 0) {
                                idx = (idx + 1) % this.tabs.length;

                                this.changeSelectedTab(this.tabs[idx].value);
                                this.$nextTick(() => {
                                    if (this.flow_type == 'APIHeader')
                                        this.$refs.codeEditor?.focus();
                                        //this.$refs.aceEditor.editor.focus();
                                    else if (this.flow_type == 'FlowHeader')
                                        this.paper.el.focus();
                                });
                            }
                        }
                    }
                    break;

                case 'Delete':
                    e.preventDefault(); // Prevent browser default behavior
                    this.deleteSeleceted();
                    break;

                case 'z':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.undoEdit();
                    }
                    break;

                case 'y':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.redoEdit();
                    }
                    break;

                case 'c':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.copyToClipboard();
                    }
                    break;

                case 'v':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.pasteFromClipboard();
                    }
                    break;

                case 'x':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.copyToClipboard();
                        this.deleteSeleceted();
                    }
                    break;
            }
        },

        blank_pointerdown(evt, x, y) {
            this.$refs.paperDiv.focus();

            if (evt.button !== 0)
                return;

            this.hideSiblingHoverTools();
            this.clearSelected();

            this.cellLastPos = null;
            this.showInputChoices = false;

            this.startPoint = { x, y };
            this.selectionRect = new shapes.standard.Rectangle({
                position: { x, y },
                size: { width: 0, height: 0 },
                attrs: {
                    body: {
                        fill: 'rgba(0, 0, 255, 0.01)',
                        stroke: 'blue',
                        strokeWidth: 1,
                        strokeDasharray: '5,5',
                    },
                    label: { visibility: 'hidden' },
                },
            });
            this.graph.addCell(this.selectionRect);
        },
        blank_pointermove(evt, x, y) {
            if (this.selectionRect) {
                // Update selection rectangle size
                const minX = Math.min(this.startPoint.x, x);
                const minY = Math.min(this.startPoint.y, y);
                const width = Math.abs(x - this.startPoint.x);
                const height = Math.abs(y - this.startPoint.y);
                this.selectionRect.position(minX, minY);
                this.selectionRect.resize(width, height);
            }
        },
        async blank_pointerup(evt, x, y) {
            if (this.selectionRect) {
                // Select elements intersecting the rectangle
                const rectBbox = this.selectionRect.getBBox();
                this.selectedCells = this.graph
                    .getElements()
                    .filter((el) => el !== this.selectionRect && rectBbox.intersect(el.getBBox()));

                // Remove selection rectangle
                this.selectionRect.remove();
                this.selectionRect = null;
                this.startPoint = null;

                // Highlight selected elements
                this.updateHighlights();
                this.scheduleSaveCanvasViewState();
                if (this.batchEditingEnabled())
                    await this.applyCanvasMultiSelection();
            }
        },

        cell_pointermove(cellView, evt, x, y) {
            if (this.groupMove) {
                const draggedModel = cellView.model;
                const dx = x - this.dragPoint.x;
                const dy = y - this.dragPoint.y;
                for (let item of this.selectedCells) {
                    if (item.id == draggedModel.id) continue;
                    const lastPos = item.attributes.position;
                    if (lastPos)
                        item.position(lastPos.x + dx, lastPos.y + dy);

                    const links = this.graph.getConnectedLinks(item);
                    for (let link of links) {
                        if (this.selectedCells.some(c => c.id == link.attributes.source.id) &&
                            this.selectedCells.some(c => c.id == link.attributes.target.id)) {
                            if (link.attributes.vertices)
                                for (let v of link.attributes.vertices) {
                                    //debugger;
                                    v.x += dx;
                                    v.y += dy;
                                }
                        }
                    }
                }
                this.dragPoint = { x, y };
            }

            if (this.iconOverlayVisible && this.iconOverlayCellView === cellView)
                this.updateIconOverlayPosition();

            if (this._siblingToolCellView && this.cellLastPos) {
                const pos = cellView.model.get('position');
                if (pos && (pos.x !== this.cellLastPos.x || pos.y !== this.cellLastPos.y))
                    this.hideSiblingHoverTools();
            }
        },
        async cell_pointerdown(cellView, evt, x, y) {
            this.$refs.paperDiv.focus();
            this.showInputChoices = false;

            if (evt.button !== 0)
                return;

            if ((evt.ctrlKey || evt.metaKey) && this.batchEditingEnabled() && cellView?.model?.isElement?.()) {
                await this.toggleBatchCell(cellView);
                return;
            }

            if (this.selectedCells.length > 1) {
                if (this.selectedCells.some(a => a.cid == cellView.model.cid)) {
                    // group move
                    this.groupMove = true;
                    this.dragPoint = { x, y };
                    this.hideSiblingHoverTools();
                    return;
                }
                else {
                    this.selectedCells = [];
                    this.updateHighlights();
                }
            }

            this.clearSelected();

            /* This is a failed effort (Grok tried but did not know) to cause links to connect from
             * the base element rather than the port. This would let the rendering look much more natural.
            const portElement = evt.target.closest('g.port');
            if (portElement) {
                const portId = portElement.getAttribute('data-port-id');
                const port = cellView.model.getPort(portId);
                if (!port) return; // Can't find?

                console.log(`cell_pointerdown found port: ${portId}`);

                evt.stopPropagation();  // Prevent bubbling/default magnet handling
                cellView.options.interactive = false;  // Temporarily disable element dragging

                // Create link with source as element (no port)
                const link = new joint.shapes.standard.Link({
                    source: { id: cellView.model.id },  // Element only
                    target: { x: x, y: y },  // Initial target at click position
                    attrs: {
                        line: { stroke: '#585858', strokeWidth: 2 }
                        // Add labels or other visuals
                    },
                    router: { name: 'manhattan' },
                    connector: { name: 'rounded' }
                });

                this.graph.addCell(link);

                console.log(`cell_pointerdown created new link from the element instead of the port`);

                // Get the link view and start dragging the target end from current position
                const linkView = this.paper.findViewByModel(link);
                linkView.startArrowheadDragging(evt, x, y, 'target');

                // Re-enable interactive after a tick (or on pointerup globally)
                setTimeout(() => { cellView.options.interactive = true; }, 0);

                return;
            }
            */

            await this.selectCellView(cellView);
        },

        async selectCellView(cellView) {
            if (this.watchBatch || this.batchBanner) {
                this.disposeBatchWatch();
                this.batchBanner = '';
                this.batchSelectionKey = '';
            }

            this.highlightConnectedLinks(cellView.model);

            cellView.highlight(cellView.el);
            this.selected = cellView;
            this.syncSelectedBreakpoint();

            this.cellLastPos = cellView.model.get('position');

            const prop = cellView.model.attributes.prop;
            if (prop?.Unavailable) {
                this.applyUnavailablePropertyForm(prop);
                this.syncFolderGridCanvasSource(prop);
                this.scheduleSaveCanvasViewState();
                return;
            }
            if (prop && prop.ToolID) {
                await this.updateSelected(prop);

                if (prop.Model) {
                    if (this.debouncedUpdateArgs == null)
                        this.debouncedUpdateArgs = debounce((newv, instanceid) => {
                            this.syncFlowChanges({
                                EventType: 'UpdateArgs',
                                Data: {
                                    FlowID: this.FlowID,
                                    Content: {
                                        Type: prop.Type,
                                        InstanceID: instanceid,
                                        Arguments: newv,
                                    }
                                },
                            }, true);
                        }, 2000);

                    if (this.debouncedUpdateOutput == null)
                        this.debouncedUpdateOutput = debounce((newv, instanceid) => {
                            this.syncFlowChanges({
                                EventType: 'UpdateOutput',
                                Data: {
                                    FlowID: this.FlowID,
                                    Content: {
                                        Type: prop.Type,
                                        InstanceID: instanceid,
                                        Output: newv,
                                    }
                                },
                            }, true);
                        }, 2000);

                    if (this.debouncedUpdateMatchPorts == null)
                        this.debouncedUpdateMatchPorts = debounce((newv, instanceid) => {
                            this.syncFlowChanges({
                                EventType: 'UpdateMatchPorts',
                                Data: {
                                    FlowID: this.FlowID,
                                    Content: {
                                        Type: prop.Type,
                                        InstanceID: instanceid,
                                        MatchPorts: newv,
                                    }
                                },
                            }, true);
                        }, 500);

                    if (this.debouncedUpdateCaption == null)
                        this.debouncedUpdateCaption = debounce((newv, instanceid) => {
                            this.syncFlowChanges({
                                EventType: 'UpdateCaption',
                                Data: {
                                    FlowID: this.FlowID,
                                    Content: {
                                        InstanceID: instanceid,
                                        Caption: newv,
                                    }
                                },
                            });
                        }, 2000);

                    const instance_id = prop.InstanceID;

                    this.watchCaption = this.$watch(
                        () => this.model.API.Caption,
                        (newv) => {
                            cellView.model.attr('label/text', formatDisplayName(newv));
                            this.debouncedUpdateCaption(newv, instance_id);
                        }
                    );
                    this.watchArgs = this.$watch(
                        () => this.model.Arguments,
                        (newv) => {
                            //console.log('change');
                            this.debouncedUpdateArgs(newv, instance_id);
                        },
                        {
                            deep: true
                        }
                    );
                    if (this.model.Output)
                        this.watchOutput = this.$watch(
                            () => this.model.Output,
                            (newv) => {
                                //console.log('change');
                                this.debouncedUpdateOutput(newv, instance_id);
                            },
                            {
                                deep: true
                            }
                        );

                    this.attachMatchPortsWatch(cellView);

                    if (this.schema) {
                        let tool_model = utils.schema.getDefaultModel(this.schema);

                        // Merge in new fields with default values into the existing model where
                        // the new fields are missing.
                        for (let key of Object.keys(tool_model.Arguments)) {
                            const fieldvalue = tool_model.Arguments[key];
                            if (!(key in this.model.Arguments) && fieldvalue !== undefined && fieldvalue !== null) {
                                // Note: modifying the model after the watch to ensure it is sent to the server
                                this.model.Arguments[key] = fieldvalue;
                            }
                        }
                    }
                }
            }
            else {
                this.schema = null;
                this.model = null;
            }

            this.syncFolderGridCanvasSource(prop);
            this.scheduleSaveCanvasViewState();
        },
        syncFolderGridCanvasSource(prop) {
            const folderGrid = this.$refs.folderGrid;
            if (!folderGrid)
                return;
            if (prop && (prop.Type === 'FlowHeader' || prop.Type === 'APIHeader') && prop.ToolID)
                folderGrid.highlightCanvasSource?.(prop.ToolID);
            else
                folderGrid.clearCanvasSourceHighlight?.();
        },
        element_pointerup(cellView, evt) {
            const undo_group = utils.generateUUID();
            if (this.groupMove) {
                for (let cell of this.selectedCells) {
                    const item = cell.attributes.prop;
                    let position = cell.get('position');

                    this.offsetOverlapping(cell);
                    position = cell.get('position');

                    this.syncFlowChanges({
                        EventType: 'Move',
                        Data: {
                            FlowID: this.FlowID,
                            UndoGroup: undo_group,
                            Content: {
                                InstanceID: item.InstanceID,
                                Location: { X: position.x, Y: position.y },
                            }
                        },
                    });
                }
                this.groupMove = false;
                return;
            }

            const cell = cellView.model;
            if (cell.isElement()) { // Ensure it's an element, not a link
                let position = cell.get('position');
                if (this.cellLastPos && this.cellLastPos.x == position.x && this.cellLastPos.y == position.y)
                    return; // Click with no drag — leave selection as-is (popup is right-click)

                this.offsetOverlapping(cell);
                position = cell.get('position');

                const item = cell.attributes.prop;

                this.syncFlowChanges({
                    EventType: 'Move',
                    Data: {
                        FlowID: this.FlowID,
                        UndoGroup: undo_group,
                        Content: {
                            InstanceID: item.InstanceID,
                            Location: { X: position.x, Y: position.y },
                        }
                    },
                });

                if (this.iconOverlayVisible && this.iconOverlayCellView === cellView)
                    this.updateIconOverlayPosition();
            }
        },

        paper_mousedown(evt) {
            this.$refs.paperDiv.focus();

            // Check for middle mouse button (button 1)
            if (evt.button === 1) {
                this.hideSiblingHoverTools();
                this.isPanning = true;
                this.lastMouseX = evt.clientX;
                this.lastMouseY = evt.clientY;
                evt.preventDefault(); // Prevent default scrolling behavior
            }
        },
        paper_mousemove(evt) {
            if (this.isPanning) {
                const deltaX = evt.clientX - this.lastMouseX;
                const deltaY = evt.clientY - this.lastMouseY;

                const container = this.$refs.scrollContainer;

                // Update scroll position of the container
                container.scrollLeft -= deltaX;
                container.scrollTop -= deltaY;
            }

            // Update last mouse position
            this.lastMouseX = evt.clientX;
            this.lastMouseY = evt.clientY;
        },
        paper_mouseup(evt) {
            this.isPanning = false;
        },
        paper_mouseleave(evt) {
            this.isPanning = false;
        },
        paper_wheel(evt) {
            if (evt.button === 1) {
                evt.preventDefault();
                return;
            }
            if (evt.ctrlKey) {
                evt.preventDefault(); // Prevent browser zoom

                const container = this.$refs.scrollContainer;

                // Get container's bounding rect and current scroll position
                const containerRect = container.getBoundingClientRect();
                const oldScrollLeft = container.scrollLeft;
                const oldScrollTop = container.scrollTop;

                // Get mouse position relative to the container
                const containerX = evt.clientX - containerRect.left;
                const containerY = evt.clientY - containerRect.top;

                // Get mouse position in paper's local coordinates for zoom pivot
                const localPoint = this.paper.clientToLocalPoint({
                    x: evt.clientX,
                    y: evt.clientY
                });

                // Calculate new scale
                const delta = evt.deltaY;
                const scaleFactor = 0.1; // Adjust zoom sensitivity
                const oldScale = this.scale;
                const newScale = this.scale + (delta < 0 ? scaleFactor : -scaleFactor);

                // Restrict scale to reasonable bounds (e.g., 0.2 to 3)
                if (newScale >= 0.2 && newScale <= 3) {
                    this.scale = newScale;

                    // Apply scale with pivot at mouse position
                    this.paper.scale(this.scale, this.scale, localPoint.x, localPoint.y);

                    // Calculate new scroll position to keep mouse point in view
                    const scaleChange = this.scale / oldScale;
                    const newScrollLeft = scaleChange * (oldScrollLeft + containerX) - containerX;
                    const newScrollTop = scaleChange * (oldScrollTop + containerY) - containerY;

                    // Update scroll position
                    container.scrollLeft = newScrollLeft;
                    container.scrollTop = newScrollTop;

                    if (this.iconOverlayVisible)
                        this.updateIconOverlayPosition();
                    if (this._siblingToolCellView) {
                        const hoverView = this._siblingToolCellView;
                        this.hideSiblingHoverTools();
                        this.showSiblingHoverTools(hoverView);
                    }
                }
            }
        },

        graph_change_vertices(linkView, vertices) {
            if (this._suppressVertexSync)
                return;
            this.debouncedUpdateLink(linkView.attributes.source.id, this.getLinkfromJSlink(linkView));


            ////debugger;
            //const verts = JSON.stringify(linkView.attributes.vertices);
            //console.log(`Verts: ${verts}`);

            //linkView.attributes.customMetadata.Vertices = linkView.attributes.vertices;
            //const source = this.graph.getCell(linkView.attributes.source.id);
            //if (source) {
            //    const link = source.attributes.prop.Model.Links.find(a => a.ID == linkView.attributes.customMetadata.ID);
            //    if (link) {
            //        link.Vertices = linkView.attributes.vertices.map(a => ({ X: a.x, Y: a.y }));

            //        // Save
            //        this.debouncedUpdateLink(linkView.attributes.source.id, this.getLinkfromJSlink(linkView));
            //    }
            //}
        },
        graph_change_source_target(link) {
            // The event listener receives the link model as an argument.
            if (this._suppressLinkSourceSync)
                return;

            const sourceId = link.get('source').id;
            const targetId = link.get('target').id;

            // Check if both the source and target of the link are set.
            if (sourceId && targetId) {
                const sourceEl = this.graph.getCell(sourceId);
                const targetEl = this.graph.getCell(targetId);
                if (!sourceEl || !targetEl)
                    return;
                if (sourceEl.attributes?.prop?.Unavailable || targetEl.attributes?.prop?.Unavailable)
                    return;

                const source = sourceEl.attributes.prop.Model;

                const portId = link.attributes.source.port;
                const srcPort = sourceEl.getPorts().find(a => a.id == portId);

                const newLink = {
                    ID: link.id,
                    Name: srcPort.customData?.Link?.DeclareMatch
                        ? srcPort.customData.Link.Name
                        : srcPort.id,
                    Condition: srcPort.customData?.Link?.DeclareMatch
                        ? (srcPort.customData.Link.MatchValue != null
                            ? String(srcPort.customData.Link.MatchValue)
                            : null)
                        : (link.attributes.labels ? link.attributes.labels[0].attrs.text.text : null),
                    TargetID: targetEl.id,
                };

                this.syncFlowChanges({
                    EventType: 'UpdateLink',
                    Data: {
                        FlowID: this.FlowID,
                        Content: {
                            InstanceID: sourceId,
                            Link: newLink,
                        }
                    },
                }, true);

                if (srcPort.customData?.Link?.DeclareMatch) {
                    // Declared match port: condition is fixed; one link per port; no prompt
                    const alllinks = this.graph.getConnectedLinks(sourceEl);
                    const oldlink = alllinks.find(a =>
                        a.id != link.id &&
                        a.attributes &&
                        a.attributes.source.id == sourceId &&
                        a.attributes.source.port == portId);

                    if (oldlink) {
                        this.syncFlowChanges({
                            EventType: 'RemoveLink',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    InstanceID: sourceId,
                                    Link: {
                                        ID: oldlink.id,
                                        Name: newLink.Name,
                                        Condition: newLink.Condition,
                                        TargetID: oldlink.attributes.target.id,
                                    },
                                }
                            },
                        }, true);

                        oldlink.remove();
                    }
                    return;
                }

                if (!srcPort.customData.Link.EnableCondition) {
                    const alllinks = this.graph.getConnectedLinks(sourceEl);
                    const oldlink = alllinks.find(a =>
                        a.id != link.id &&
                        a.attributes &&
                        a.attributes.source.id == sourceId &&
                        a.attributes.source.port == portId);

                    if (oldlink) {
                        this.syncFlowChanges({
                            EventType: 'RemoveLink',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    InstanceID: sourceId,
                                    Link: {
                                        ID: oldlink.id,
                                        Name: portId,
                                        TargetID: oldlink.attributes.target.id,
                                    },
                                }
                            },
                        }, true);

                        oldlink.remove();
                    }
                    return;
                }

                let labels = link.get('labels');

                if (srcPort.customData.Link.EnableCondition && (!labels || !labels.length || !labels[0].attrs.text.text))
                    setTimeout(() => {
                        if (!labels || labels.length === 0)
                            link.insertLabel(-1, this.styledLabel());

                        const linkView = this.paper.findViewByModel(link);

                        this.currentLink = link;
                        this.setInputPositionFromLinkView(linkView);

                        switch (srcPort.customData.Link.ConditionType) {
                            case 'enum':
                                this.inputValue = srcPort.customData.Link.EnumValues[0];
                                this.currentLink.prop('labels/0', this.styledLabel(this.inputValue));
                                this.choices = srcPort.customData.Link.EnumValues.map(a => ({ title: formatDisplayName(a), value: a }));
                                this.showInputChoices = true;
                                this.$nextTick(() => {
                                    this.inputChoicesVisible = true;
                                });
                                break;

                            default:
                                this.inputValue = '';
                                this.resizeInput();
                                this.showInput = true;
                                this.$nextTick(() => {
                                    this.$refs.input.focus();
                                });
                                break;
                        }
                    }, 125);
            }
        },

        paper_link_dblClick(linkView) {
            const link = linkView.model;

            const sourceId = link.get('source').id;
            if (!sourceId) return;

            const sourceEl = this.graph.getCell(sourceId);
            if (sourceEl?.attributes?.prop?.Unavailable)
                return;

            const labels = link.get('labels');
            if (!labels || labels.length === 0)
                return;

            const portId = link.attributes.source.port;
            const srcPort = sourceEl.getPorts().find(a => a.id == portId);

            if (srcPort?.customData?.Link?.DeclareMatch)
                return;

            this.currentLink = link;
            this.setInputPositionFromLinkView(linkView);
            this.inputValue = labels?.[0]?.attrs?.text?.text || '';

            switch (srcPort.customData.Link.ConditionType) {
                case 'enum':
                    this.choices = srcPort.customData.Link.EnumValues.map(a => ({ title: formatDisplayName(a), value: a }));
                    this.showInputChoices = true;
                    this.$nextTick(() => {
                        this.inputChoicesVisible = true;
                    });
                    break;

                default:
                    this.resizeInput();
                    this.showInput = true;
                    this.$nextTick(() => {
                        this.$refs.input.focus();
                    });
                    break;
            }
        },

        //----------------------------------//

        updateLabel() {
            if (this.editorReadOnly)
                return;
            const value = this.inputValue.trim();
            if (this.currentLink && value) {
                // Update label text
                this.currentLink.prop('labels/0', this.styledLabel(value));
                this.syncFlowChanges({
                    EventType: 'UpdateLink',
                    Data: {
                        FlowID: this.FlowID,
                        Content: {
                            InstanceID: this.currentLink.attributes.source.id,
                            Link: this.getLinkfromJSlink(this.currentLink),
                        }
                    },
                }, true);

                // Find another link with the same source and the same label. If found, remove the existing one.
                const source = this.graph.getCell(this.currentLink.attributes.source.id);
                if (source) {
                    const alllinks = this.graph.getConnectedLinks(source);
                    const oldlink = alllinks.find(a =>
                        a.id != this.currentLink.id &&
                        a.attributes &&
                        a.attributes.source.id == this.currentLink.attributes.source.id &&
                        a.attributes.source.port == this.currentLink.attributes.source.port &&
                        a.attributes.labels?.length &&
                        a.attributes.labels[0].attrs.text.text == value
                    );
                    if (oldlink) {
                        this.syncFlowChanges({
                            EventType: 'RemoveLink',
                            Data: {
                                FlowID: this.FlowID,
                                Content: {
                                    InstanceID: this.currentLink.attributes.source.id,
                                    Link: this.getLinkfromJSlink(oldlink),
                                }
                            },
                        }, true);

                        oldlink.remove();
                    }
                }
            }
            this.showInput = false;
            this.currentLink = null;
        },
        resizeInput() {
            // Copy the value to the mirror (invisible span) to allow it to compute the width
            this.$refs.inputMirror.textContent = this.inputValue;
            // Then copy the span's width to the input box
            this.$refs.input.style.width = this.$refs.inputMirror.offsetWidth + 'px';
        },
        inputBoxInput(e) {
            this.inputValue = e.target.value;
            this.resizeInput();

        //    // Copy the value to the mirror (invisible span) to allow it to compute the width
        //    this.$refs.inputMirror.textContent = e.target.value;
        //    // Then copy the span's width to the input box
        //    this.$refs.inputOriginal.style.width = this.$refs.inputMirror.offsetWidth + 'px';
        },
        onInputKeyup(event) {
            if (event.key === 'Enter') {
                this.updateLabel();
            } else if (event.key === 'Escape') {
                this.showInput = false;
                this.currentLink = null;
            }
        },
        inputLostFocus() {
            this.showInput = false;
            if (this.currentLink && !this.inputValue.trim()) {
                // Label is blank, discard new link
                this.syncFlowChanges({
                    EventType: 'RemoveLink',
                    Data: {
                        FlowID: this.FlowID,
                        Content: {
                            InstanceID: this.currentLink.attributes.source.id,
                            Link: this.getLinkfromJSlink(this.currentLink),
                        }
                    },
                }, true);
                this.currentLink.remove();
                this.currentLink = null;
            }
        },

        UserFlowHeaderChanged(id, data) {
            delete this.userFlowHeader_cache[id];

            if (data)
                this.syncFlowChanges({
                    EventType: 'SettingsChanged',
                    Data: {
                        FlowID: id,
                        Content: data,
                    }
                }, true);

            if (data?.Name)
                this.applyMethodNameReferences(id, data.Name);

            if (id === this.FlowID) {
                if (data?.ReturnType != null)
                    this.methodReturnType = data.ReturnType;
                if (data?.ClassID)
                    this.class_id = data.ClassID;
                if (Array.isArray(data?.Parameters)) {
                    this.parameters = data.Parameters.map(p => ({
                        Name: p.Name,
                        Type: p.Type,
                        Description: p.Description,
                        Out: !!(p.Out || p.Direction === 1 || p.Direction === 'out'),
                    }));
                    this.refreshSelectedSchemaForMethodReturn();
                }
                else {
                    this.hydrateMethodParameters();
                }
            }
        },
        /**
         * Rebuild the open inspector when a palette argument follows the method return type.
         * A void signature drops ReturnValue; a typed signature shows it with that type.
         */
        async refreshSelectedSchemaForMethodReturn() {
            if (this.batchEditingEnabled() && this._batchCells?.length > 1) {
                await this.showBatchProperties(this._batchCells.slice());
                return;
            }
            const tool = this.tool;
            if (!tool?.Arguments?.some(a => a.UseMethodReturnType))
                return;
            const errors = this.selected?.model?.attributes?.prop?.Errors ?? {};
            this.schema = await this.generateSchemaFromArgs(tool, errors);
        },
        /**
         * Load current method Parameters + ReturnType for the use-variable picker / FlowContext.
         * Flow Load payload omits Parameters; GetMethodHeader is the source of truth.
         */
        async hydrateMethodParameters() {
            if (!this.FlowID || !this.ItemType)
                return;
            try {
                const model = await utils.api.get(
                    `Apps/FlowV2/GetMethodHeader?Type=${this.ItemType}&ID=${this.FlowID}`,
                );
                this.parameters = Array.isArray(model?.Parameters)
                    ? model.Parameters.map(p => ({
                        Name: p.Name,
                        Type: p.Type,
                        Description: p.Description,
                        Out: !!(p.Out || p.Direction === 1 || p.Direction === 'out'),
                    }))
                    : [];
                this.methodReturnType = model?.ReturnType ?? null;
                if (model?.ClassID)
                    this.class_id = model.ClassID;
                this.refreshSelectedSchemaForMethodReturn();
            }
            catch (err) {
                console.warn('FlowV2: failed to hydrate method parameters', err);
                this.parameters = [];
                this.methodReturnType = null;
                this.refreshSelectedSchemaForMethodReturn();
            }
        },
        async resolveDroppedSiblingChannelType(draggedData) {
            if (draggedData?.ChannelType)
                return draggedData.ChannelType;
            if (!draggedData?.ID || !draggedData?.Type)
                return null;
            try {
                const proj = await utils.api.get(`Apps/FlowV2/GetMethodProject?Type=${draggedData.Type}&ID=${draggedData.ID}`);
                const result = proj?.Result || proj;
                return result?.ChannelType || null;
            }
            catch (err) {
                console.warn('FlowV2: failed to resolve sibling channel type', err);
                return null;
            }
        },
        async canDropSiblingMethod(draggedData) {
            const calleeType = await this.resolveDroppedSiblingChannelType(draggedData);
            if (isSiblingMethodAllowed(this.channelConfig, calleeType, this.channelList))
                return true;
            EventBus.$emit('v-toast', {
                type: 'warning',
                text: 'Incompatible channel',
                subtext: 'That method belongs to a different channel and cannot be added to this flow.',
            });
            return false;
        },
        async fetchFlowTool(id, type) {
            // TODO: monitor events from the server whenever the header for a user flow
            //       is updated and clear out our cache for that item.

            if (id in this.userFlowHeader_cache)
                return this.userFlowHeader_cache[id];

            let model = await utils.api.get(`Apps/FlowV2/GetMethodHeader?Type=${type}&ID=${id}`);
            const tool = {
                id: model.ID,
                name: model.Name,
                path: model.Path,
                icon: 'mdi-sitemap-outline',
                description: model.Description ?? '',
                Arguments: model.Parameters.map(a => ({
                    Name: a.Name,
                    ArgType: a.Type,
                    Description: a.Description ?? '',
                    DefaultValue: a.DefaultValue,
                    Out: a.Out,
                    ...(!(a.Out || a.Direction == 1 || a.Direction === 'out') ? { AllowVariable: true } : {}),
                })),
                Links: [],
                ReturnType: model.ReturnType,
            };

            // Default first, then out params, then Return — port stack order follows Links index
            tool.Links.push({
                Category: 'default',
                Icon: 'mdi-arrow-right-bold',
                Tooltip: 'Default',
                Name: 'Default',
                EnableCondition: false,
            });

            const outLinks = model.Parameters.filter(p => p.Out || p.Direction == 'out').map(p => ({
                Category: 'results',
                ConditionType: p.Type,
                EnableCondition: true,
                DeclareMatchPorts: !!p.DeclareMatchPorts,
                // Icon is the first letter of the name
                Icon: `mdi-alpha-${p.Name.substr(0, 1).toLowerCase()}-box`,
                Name: p.Name,
                Tooltip: p.Name
            })).slice(0, 3); // Only allow up to 3 out args with links (takes up too much space)
            tool.Links.push(...outLinks);

            if (model.ReturnType && model.ReturnType != 'void')
                tool.Links.push({
                    Category: 'results',
                    Icon: 'mdi-keyboard-return',
                    Tooltip: 'Return Value',
                    Name: 'Return',
                    EnableCondition: true,
                    DeclareMatchPorts: !!model.DeclareMatchPortsOnReturn,
                    ConditionType: model.ReturnType,
                });

            this.userFlowHeader_cache[id] = tool;

            return tool;
        },

        editProperties() {
            if (this.editorReadOnly)
                return;
            if (shouldUseMixedEssentialStack(this.tool)) {
                this.editPropertiesForm();
                return;
            }

            // Open a large dialog with the regular form
            const model = ref(cloneDeep(this.model.Arguments));
            const saveFunc = () => {
                this.model.Arguments = model.value;
            };

            this.$refs.genericDialog.showDialog(`${formatDisplayName(this.model.API.Name)} Properties`, 800, (dlg) =>
                <FlowContextProvider context={this.flowContext}>
                    <VariableBindingProvider context={this.variableBindingContext}>
                        <SchemaForm
                            name="iconPropertiesForm"
                            root={this.root}
                            schema={this.schema.properties.Arguments}
                            form={['*']}
                            cmodel={model.value}
                            noinput={!!this.editorReadOnly}
                            enableVariableBinding={true}
                            flowContext={this.flowContext}
                            parentType="VerticalStack"
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            child={0}
                        >
                        </SchemaForm>
                    </VariableBindingProvider>
                </FlowContextProvider>
                , saveFunc);
        },
        editPropertiesForm() {
            if (this.editorReadOnly)
                return;
            // Mixed stack: custom forms bind FormModel to Arguments[argName] only (PlainWrapper).
            // Save.Func is a close-only bridge for PromptForm until its Save button is removed.
            const closeDialog = () => {
                this.$refs.genericDialog.hideDialog();
            };
            const editors = listEssentialArgumentEditors(
                this.tool,
                this.model.Arguments,
                this.schema?.properties?.Arguments?.properties,
            );
            const matchForm = buildMatchPortsFormItems(this.tool);
            const showMatchPorts = matchForm.length > 0 && this.schema?.properties?.MatchPorts;
            const nodes = [];
            const vbCtx = this.variableBindingContext;
            const flowCtx = this.flowContext;

            const caption = getCaptionEditorDescriptor(this.model, this.schema);
            if (caption) {
                nodes.push(
                    <SchemaForm
                        key="dlg-caption"
                        name="iconCaptionForm"
                        root={this.root}
                        schema={caption.schema}
                        form={caption.form}
                        cmodel={caption.cmodel}
                        noinput={!!this.editorReadOnly}
                        IsAdvanced={false}
                        enableVariableBinding={true}
                        flowContext={flowCtx}
                        parentType="VerticalStack"
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        child={0}
                    />
                );
            }

            for (const ed of editors) {
                if (ed.kind === 'customForm') {
                    const bag = getCompileErrorBag(this, ed.argName);
                    const selectedErrors = this.selected?.model?.attributes?.prop?.Errors;
                    syncCompileErrorErrorsMap(bag, errorsMapForCustomForm(selectedErrors, ed.argName));
                    nodes.push(
                        <UserControl
                            key={`dlg-form-${ed.argName}-${this.editorReadOnly ? 'ro' : 'rw'}`}
                            name={`iconPropertiesForm_${ed.argName}`}
                            root={this.root}
                            controlURL={ed.formUrl}
                            controlName={`iconPropertiesForm_${ed.argName}`}
                            controlData={{
                                FormModel: ed.cmodel != null ? new PlainWrapper(ed.cmodel) : null,
                                CompileError: new PlainWrapper(bag),
                                ReadOnly: !!this.editorReadOnly,
                                Save: { Func: closeDialog },
                                VariableBinding: vbCtx || null,
                                FlowContext: flowCtx || null,
                                $onUseVariable: (payload) => vbCtx?.notifyUseVariable?.(payload),
                                $onCreateVariable: (name) => vbCtx?.createVariable?.(
                                    typeof name === 'string' ? name : name?.Name || name?.name,
                                ),
                            }}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                        />
                    );
                    continue;
                }
                nodes.push(
                    <SchemaForm
                        key={`dlg-arg-${ed.argName}`}
                        name={`iconArgForm_${ed.argName}`}
                        root={this.root}
                        schema={ed.schema}
                        form={ed.form || ['*']}
                        cmodel={ed.cmodel}
                        noinput={!!this.editorReadOnly}
                        IsAdvanced={false}
                        enableVariableBinding={true}
                        flowContext={flowCtx}
                        parentType="VerticalStack"
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        child={0}
                    />
                );
            }

            if (showMatchPorts) {
                nodes.push(
                    <SchemaForm
                        key="dlg-match"
                        name="iconMatchPortsForm"
                        root={this.root}
                        schema={this.schema}
                        form={matchForm}
                        cmodel={this.model}
                        noinput={!!this.editorReadOnly}
                        IsAdvanced={false}
                        enableVariableBinding={true}
                        flowContext={flowCtx}
                        parentType="VerticalStack"
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        child={0}
                    />
                );
            }

            const output = getOutputEditorDescriptor(this.model, this.schema);
            if (output) {
                nodes.push(
                    <SchemaForm
                        key="dlg-output"
                        name="iconOutputForm"
                        root={this.root}
                        schema={output.schema}
                        form={output.form}
                        cmodel={output.cmodel}
                        noinput={!!this.editorReadOnly}
                        IsAdvanced={false}
                        enableVariableBinding={true}
                        flowContext={flowCtx}
                        parentType="VerticalStack"
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        child={0}
                    />
                );
            }

            this.$refs.genericDialog.showDialog(`${formatDisplayName(this.model.API.Name)} Properties`, 800, (dlg) =>
                <FlowContextProvider context={flowCtx}>
                    <VariableBindingProvider context={vbCtx}>
                        <div class="c-FlowV2-icon-custom-form-stack" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {nodes}
                        </div>
                    </VariableBindingProvider>
                </FlowContextProvider>); // no dialog savefunc — model is live; PromptForm Save only closes
        },

        beginEditingFlow(flowId) {
            console.log(`FlowV2 beginEditingFlow flowId:${flowId}`);
            this._awaitingSubscribeLock = true;
            this._debugLockSeen = false;
            if (flowId) {
                this.users = {};

                webSocket.StartFlowEditor(flowId, this.ItemType, this.eventCallback);
            }
        },
        endEditingFlow(flowId) {
            console.log(`FlowV2 endEditingFlow flowId:${flowId}`);
            if (flowId) {
                if (this.flow_id === flowId) {
                    if (this.ItemType === 'FlowHeader')
                        this.saveCanvasViewState(flowId);
                    this._suppressCanvasViewSave = true;
                    try {
                        this.clearCanvasSelectionUi();
                        this.debouncedSaveCanvasViewState?.cancel?.();
                    }
                    finally {
                        this._suppressCanvasViewSave = false;
                    }
                }

                this.users = {};

                if (this.heartbeatInterval)
                    clearInterval(this.heartbeatInterval);

                this.heartbeatInterval = null;

                webSocket.StopFlowEditor(flowId, this.eventCallback);
            }
            this.stopRecipeHoleWatch();
        },

        eventCallback(eventData) {
            const eventStr = eventData.toString();
            if (!eventStr.includes('HeartBeat'))
                console.log(`FlowV2 eventCallback eventData:${eventData}`);

            const data = JSON.parse(eventStr);

            this.InvokeEvent(data);
        },
        async InvokeEvent(data) {
            this.noteIncomingEdit(data);
            switch (data.EventType) {
                case "Welcome":
                    console.log(`Welcome received for flow ID: ${data.Data?.FlowID}`);
                    //this.id = data.Data.FlowID;
                    break;

                case "AskAiStatus":
                    this.$refs.askAiDrawer?.onStatus(data.Data?.Text);
                    break;

                case "ToolPalette":
                    void this.applyRemoteToolPalette();
                    break;

                case "Error":
                    console.log(`FlowV2 Error: ${data.Data.Reason}`);
                    this.pushEditorMessage(data.Data.Reason, 'error');
                    if (this.loaderPromiseReject)
                        this.loaderPromiseReject(err.message);
                    break;

                case "Loading":
                    // Display some kind of progress indicator
                    break;

                case "Loaded":
                    // Load the flow into the editor
                    try {
                        switch (this.ItemType) {
                            case 'FlowHeader': await this.loadFlow(data.Data.Content); break;
                            case 'APIHeader': await this.loadAPI(data.Data.Content); break;
                        }
                        if (this._awaitingSubscribeLock && data.Data?.FlowID == this.FlowID) {
                            this._awaitingSubscribeLock = false;
                            const decision = resolveSubscribeDebugLock({
                                seen: this._debugLockSeen,
                                openProjectId: this.parent_id,
                                projectIds: this.lockedProjectIds,
                            });
                            this._debugLockSeen = decision.seen;
                            if (decision.dropOpenProject)
                                this.dropOpenProjectFromLockSet();
                            else
                                this.syncDebugLockScope();
                        }
                        this.lastHeartbeat = new Date();

                        if (this.loaderPromiseResolve)
                            this.loaderPromiseResolve('');
                    }
                    catch (err) {
                        console.warn(`EventType: Loaded failed - ${err.message}`);
                        console.error("An error occurred:", err.message);
                        console.error("Stack trace:", err.stack);
                        if (this.loaderPromiseReject)
                            this.loaderPromiseReject(err.message);
                    }
                    this.loaderPromiseResolve = null;
                    this.loaderPromiseReject = null;
                    break;

                case "Saved":
                    if (data.Data.FlowID == this.FlowID) {
                        const state = this.debugGateState();
                        applySavedNotice(state, { editGeneration: data.Data.EditGeneration });
                        this.applyDebugGateState(state);
                        this.auto_save_error = '';
                    }
                    break;

                case "SaveErr":
                    if (data.Data.FlowID == this.FlowID) {
                        this.auto_saved = 'FAILED';
                        this.auto_save_error = data.Data.Reason;
                        this.rememberDebugGate();
                    }
                    break;

                case "Dirty":
                    if (data.Data?.FlowID == this.FlowID)
                        this.applyDirtyFromServer(data.Data);
                    break;

                case "DebugLock":
                    this.applyDebugLock(data);
                    break;

                case "DebugUnlock":
                    this.applyDebugUnlock(data);
                    break;

                case "ImportSiblingAs":
                case "RemoveSiblingAlias":
                case "AddExplicitSibling":
                case "RemoveExplicitSibling":
                    if (!this.consumeSiblingEcho(data.EventType, data?.Data?.Content || data?.Content || {}))
                        this.applySiblingEventLocal(data);
                    break;

                case "HeartBeatEcho":
                    this.lastHeartbeat = new Date();
                    break;

                case "Add":
                    if (data.Data.FlowID == this.FlowID) {
                        await this.addFlowItem(data.Data.Content);
                        await this.ensureStoredLinks();
                    }
                    break;

                case "Remove":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID)
                        if (element)
                            element.remove();
                    }
                    break;

                case "UpdateArgs":
                case "UpdateOutput":
                case "UpdateCaption":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element == this.selected?.model)
                            // If the update event changes the actively selected item, the watchers
                            // will fire and it will generate a new Update event causing a loop.
                            this.clearSelected();

                        if (element && element.isElement()) {
                            const item = element.attributes.prop;
                            if ('Arguments' in data.Data.Content)
                                item.Model.Arguments = data.Data.Content.Arguments;
                            if ('Output' in data.Data.Content)
                                item.Model.Output = data.Data.Content.Output;
                            if ('Caption' in data.Data.Content) {
                                item.Model.Caption = data.Data.Content.Caption;

                                element.attr('label/text', formatDisplayName(data.Data.Content.Caption));
                            }
                        }
                    }
                    break;

                case "UpdateMatchPorts":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element && element.isElement() && 'MatchPorts' in data.Data.Content) {
                            const item = element.attributes.prop;
                            const keepPinnedSelection = this.propertiesPinned
                                && element === this.selected?.model;

                            if (element === this.selected?.model && !keepPinnedSelection)
                                // Avoid watch loops when the echo would reassign the selected model.
                                this.clearSelected();

                            if (keepPinnedSelection) {
                                if (this.watchMatchPorts) {
                                    this.watchMatchPorts();
                                    this.watchMatchPorts = null;
                                }
                                item.Model.MatchPorts = data.Data.Content.MatchPorts;
                                this.syncIconPorts(element);
                                this.attachMatchPortsWatch(this.selected);
                            }
                            else {
                                item.Model.MatchPorts = data.Data.Content.MatchPorts;
                                this.syncIconPorts(element);
                            }
                        }
                    }
                    break;

                case "Move":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element && element.isElement()) {
                            element.position(data.Data.Content.Location.X, data.Data.Content.Location.Y, { silent: false });
                        }
                    }
                    break;

                case "AddLink":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element && element.isElement()) {
                            const targetid = data.Data.Content.Link.TargetID;
                            const stored = data.Data.Content.Link;
                            let tool;
                            switch (element.attributes.prop.Type) {
                                case 'Native':
                                case 'Method':
                                case 'Tool':
                                    tool = this.toolPalette?.[element.attributes.prop.ToolID];
                                    break;
                                default:
                                    tool = this.userFlowHeader_cache?.[element.attributes.prop.ToolID];
                                    break;
                            }
                            const effectiveLinks = tool
                                ? getEffectiveLinks(tool, element.attributes.prop.Model)
                                : [];
                            const srcportname = resolveStoredLinkPortId(stored, effectiveLinks) || stored.Name;
                            const srcports = element.getPorts();
                            const srcport = srcports.find(p => p.id == srcportname)
                                || srcports.find(p => p.customData?.Link?.Name == stored.Name
                                    && String(p.customData?.Link?.MatchValue ?? '') === String(stored.Condition ?? ''));

                            if (!srcport)
                                break;

                            const newLink = new shapes.standard.Link({
                                id: data.Data.Content.Link.ID,
                                source: {
                                    id: element.id,
                                    port: srcport.id,
                                },
                                target: {
                                    id: targetid
                                },
                            });
                            if (stored.Condition && srcport.customData?.Link?.EnableCondition && !srcport.customData?.Link?.DeclareMatch)
                                newLink.prop('labels/0', this.styledLabel(stored.Condition));
                            this.graph.addCell(newLink);
                        }
                    }
                    break;

                case "UpdateLink":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element && element.isElement()) {
                            const links = this.graph.getConnectedLinks(element);
                            const jslink = links.find(a => a.id == data.Data.Content.Link.ID);
                            if (jslink) {
                                jslink.target({ id: data.Data.Content.Link.TargetID });
                                if (data.Data.Content.Link.Condition)
                                    jslink.prop('labels/0', this.styledLabel(data.Data.Content.Link.Condition));

                                if (data.Data.Content.Link.Vertices && data.Data.Content.Link.Vertices.length)
                                    jslink.set('vertices', data.Data.Content.Link.Vertices.map(a => ({ x: a.X, y: a.Y })));
                            }
                            else {
                                const stored = data.Data.Content.Link;
                                let tool;
                                switch (element.attributes.prop.Type) {
                                    case 'Native':
                                    case 'Method':
                                    case 'Tool':
                                        tool = this.toolPalette?.[element.attributes.prop.ToolID];
                                        break;
                                    default:
                                        tool = this.userFlowHeader_cache?.[element.attributes.prop.ToolID];
                                        break;
                                }
                                const effectiveLinks = tool
                                    ? getEffectiveLinks(tool, element.attributes.prop.Model)
                                    : [];
                                const srcportname = resolveStoredLinkPortId(stored, effectiveLinks) || stored.Name;
                                const srcports = element.getPorts();
                                const srcport = srcports.find(p => p.id == srcportname)
                                    || srcports.find(p => p.customData?.Link?.Name == stored.Name
                                        && String(p.customData?.Link?.MatchValue ?? '') === String(stored.Condition ?? ''));

                                if (!srcport)
                                    break;

                                const newLink = new shapes.standard.Link({
                                    id: data.Data.Content.Link.ID,
                                    source: {
                                        id: element.id,
                                        port: srcport.id,
                                    },
                                    target: {
                                        id: data.Data.Content.Link.TargetID
                                    },
                                    vertices: data.Data.Content.Link.Vertices?.map(a => ({ x: a.X, y: a.Y })),
                                });
                                if (stored.Condition && srcport.customData?.Link?.EnableCondition && !srcport.customData?.Link?.DeclareMatch)
                                    newLink.prop('labels/0', this.styledLabel(stored.Condition));

                                this.graph.addCell(newLink);
                            }
                        }
                    }
                    break;

                case "RemoveLink":
                    if (data.Data.FlowID == this.FlowID) {
                        const element = this.graph.getCell(data.Data.Content.InstanceID);
                        if (element && element.isElement()) {
                            const links = this.graph.getConnectedLinks(element);
                            const jslink = links.find(a => a.id == data.Data.Content.Link.ID);
                            if (jslink)
                                jslink.remove();
                        }
                    }
                    break;

                case "AddLocal":
                    upsertVariableByName(this.variables, data.Data.Content);
                    console.log(`variables: ${JSON.stringify(this.variables)}`);
                    break;

                case "RemoveLocal":
                    removeVariablesByName(this.variables, data.Data.Content?.Name);
                    console.log(`variables: ${JSON.stringify(this.variables)}`);
                    break;

                case "UpdateLocal":
                    {
                        const incoming = data.Data.Content;
                        const idx = this.variables.findIndex(v => v && v.Name == incoming?.Name);
                        if (idx >= 0)
                            this.variables.splice(idx, 1, incoming);
                        console.log(`variables: ${JSON.stringify(this.variables)}`);
                    }
                    break;

                case "UpdateRouter":
                    if (data.Data.FlowID == this.FlowID)
                        this.applyLinkRouter(data.Data.Content?.Router);
                    break;

                case "Locals": // Comes from validation for an API, lists all detected symbols
                    if (data.Data.FlowID == this.FlowID) {
                        this.detected_locals = data.Data.Content;
                    }
                    break;

                case "Lines": // Comes from validation for an API, lists all lines and columns where breakpoints may be set
                    if (data.Data.FlowID == this.FlowID) {
                        this.detected_lines = data.Data.Content;

                        console.log(`FlowV2 - detected_lines: ${JSON.stringify(this.detected_lines)}`);

                        // Notify the editor in case it is awaiting the validation to complete
                        if (this.$refs.codeEditor)
                            this.$refs.codeEditor.receivedDetectedLines(data.Data.Content);
                    }
                    break;

                case "AddUser":
                    if (data.Data.FlowID == this.FlowID)
                        this.users[data.Data.ConnectionId] = { userId: data.Data.UserID };
                    break;

                case "RemoveUser":
                    if (data.Data.FlowID == this.FlowID) {
                        delete this.users[data.Data.ConnectionId];
                    }
                    break;

                case "NotifyRemoteUsers":
                    if (data.Data.FlowID == this.FlowID)
                        for (let user of data.Data.UserIDs)
                            this.users[user.ConnectionId] = { userId: user.UserID, host: data.Data.Host };
                    break;

                case "Undo":
                case "Redo":
                    if (data.Data.FlowID == this.FlowID) {
                        await this.loadFlow(data.Data.Content.Data);

                        if (data.Data.Content.ConnectionID != this.System.WebSocketConnectionId && this.controlData.UndoRedoActions)
                            utils.executeAndCompileAllActions(this.controlData.UndoRedoActions, {
                                UserID: data.Data.Content.UserID,
                                ConnectionID: data.Data.Content.ConnectionID,
                                Activity: data.EventType
                            }, this);
                    }
                    break;

                case "Message":
                    this.pushEditorMessage(data.Data.Content, 'info');
                    if (data.Data?.Document && (!data.Data.FlowID || data.Data.FlowID == this.FlowID))
                        await this.applyRejectedServerDocument(data.Data.Document);
                    break;

                case "Delta":
                    // Apply the Ace editor changes
                    if (data.Data.FlowID == this.FlowID)
                        this.applyAPIDelta(data.Data.Content);
                    break;

                case "Validation":
                    if (data.Data.FlowID == this.FlowID) {
                        const state = this.debugGateState();
                        applyValidationNotice(state, {
                            codeVersion: data.Data.CodeVersion,
                            errorCount: countValidationErrors(data.Data.Content),
                        });
                        this.applyDebugGateState(state);
                        switch (this.ItemType) {
                            case 'FlowHeader': this.setValidationErrors(data.Data.Content); break;
                            case 'APIHeader': this.applyAPIValidationErrors(data.Data.Content); break;
                        }
                        if (this.askAiAwaitingValidation) {
                            this.askAiAwaitingValidation = false;
                            this.$refs.askAiDrawer?.onValidation(data.Data.Content);
                        }
                    }
                    break;
            }
        },

        async loadFlow(data) {
            this.closeFlowFind();
            this.graph.clear();
            this.debugElement = null;

            console.log(`FlowV2 loadFlow`);

            this._lastFlowLoadData = data;
            // A full payload load supersedes any deferred local palette redraw.
            this._pendingRedrawFromGraph = false;
            // Paper is hidden (v-show / display:none) while Configuration is open — port
            // anchors come out at 0,0. Defer cell/link creation until Editor is shown again.
            const deferGraph = !this.isEditorPaperMeasurable();
            this._flowLoadedWhileHidden = deferGraph;

            //this.id = data.ID;
            this.class_id = data.ClassID;

            const stampNew = !!this.pendingNewFlowStamp;
            this.pendingNewFlowStamp = false;

            const savedRouter = data?.Router;
            let router = this.normalizeLinkRouter(savedRouter);
            const persistStamp = stampNew && !this.isKnownLinkRouter(savedRouter);
            if (persistStamp)
                router = this.getLastPickedRouter();

            this.applyLinkRouter(router);

            this.variables = (data.Locals || []).map(a => ({
                Name: a.Name,
                Type: a.Type,
                Description: a.Description,
                Persistent: !!a.Persistent,
            }));
            this.hydrateMethodParameters();

            if (deferGraph) {
                if (persistStamp)
                    this.persistFlowRouter(router);
                this.setupFlowEditorHeartbeat();
                return;
            }

            if (!data.Items) {
                if (persistStamp)
                    this.persistFlowRouter(router);
                this.syncPaperInteractivity();
                await this.restoreCanvasViewState(this.FlowID);
                this.focusFlowEditor();
                this.setupFlowEditorHeartbeat();
                await this.applyPendingRecipe();
                return;
            }

            for (let item of data.Items) {
                await this.addFlowItem(item);
            }
            for (let item of data.Items) {
                await this.createItemLinks(item);
            }
            this.applyLinkRouter(router);
            if (persistStamp)
                this.persistFlowRouter(router);

            this.syncPaperInteractivity();

            this.restoreAllBreakpoints();
            await this.restorePausedDebugHighlight();

            // Pause highlight schedules a scroll; cancel it so restore's snap
            // does not fight a mid-flight animation, then scroll after restore.
            this.cancelScrollCellIntoViewAnimation();
            await this.restoreCanvasViewState(this.FlowID);
            if (this.debugMode === 'paused' && this.debugElement)
                this.scheduleScrollDebugElementIntoView(this.debugElement);
            this.focusFlowEditor();
            this.setupFlowEditorHeartbeat();
            if (!deferGraph)
                await this.applyPendingRecipe();
        },
        setupFlowEditorHeartbeat() {
            if (this.heartbeatInterval)
                clearInterval(this.heartbeatInterval);

            this.heartbeatInterval = setInterval(async () => {
                try {
                    this.heartbeatSuccess = await webSocket.HeartBeatFlowEditor(this.FlowID);
                    if (!this.heartbeatSuccess) // This means we are not subscribed to the flow ID on the web server
                    {
                        console.log(`Heartbeat to server returned ${this.heartbeatSuccess}; re-subscribing...`);

                        clearInterval(this.heartbeatInterval);
                        this.heartbeatInterval = null;
                        this.syncPaperInteractivity(true);

                        this.acceptNewEditorEpoch();
                        this.beginEditingFlow(this.FlowID);
                        return;
                    }

                    //console.log(`Heartbeat to server returned ${this.heartbeatSuccess}`);
                }
                catch (err) {
                    console.log(`Failed to send heartbeat to server: ${err.message}`);
                }
            }, 5000);
        },
        /**
         * Code editor is async-loaded; refs may be missing until the chunk mounts and the API tab renders.
         * @param {number} [maxWaitMs]
         * @returns {Promise<object|null>} code editor component instance or null
         */
        async waitForCodeEditorRef(maxWaitMs = 15000) {
            const deadline = Date.now() + maxWaitMs;
            while (Date.now() < deadline) {
                const ce = this.$refs.codeEditor;
                if (ce)
                    return ce;
                await this.$nextTick();
                await new Promise((r) => setTimeout(r, 16));
            }
            console.warn('FlowV2: codeEditor ref not available within wait window');
            return null;
        },

        async loadAPI(data) {
            this.class_id = data.ClassID;
            this.variables = data.Locals?.map(a => ({
                Name: a.Name,
                Type: a.Type,
                Description: a.Description,
                Persistent: !!a.Persistent,
            })) ?? [];
            this.hydrateMethodParameters();

            const ce = await this.waitForCodeEditorRef();
            if (ce)
                await ce.loadContent(data.Body);

            this.restoreAllBreakpoints();
            await this.restorePausedDebugHighlight();
            if (!(this.siblingRows || []).length)
                await this.loadSiblingDependencies();
            this.focusFlowEditor();

            console.log(`FlowV2 loadAPI`);
            await this.applyPendingRecipe();
        },
        stopRecipeHoleWatch() {
            if (this._recipeHoleTimer) {
                clearInterval(this._recipeHoleTimer);
                this._recipeHoleTimer = null;
            }
        },
        startRecipeHoleWatch() {
            this.stopRecipeHoleWatch();
            this._recipeHoleTimer = setInterval(() => this.refreshRecipeHoles(), 1000);
        },
        refreshRecipeHoles() {
            const next = (this.recipeHoles || []).filter(hole => !this.recipeHoleFilled(hole));
            this.recipeHoles = next;
            if (!next.length)
                this.stopRecipeHoleWatch();
        },
        recipeHoleFilled(hole) {
            if (!hole || hole.embedded || !hole.instanceId)
                return false;
            const cell = this.graph?.getCell?.(hole.instanceId);
            const args = cell?.attributes?.prop?.Model?.Arguments;
            const name = String(hole.path || '').replace(/^Arguments\./, '');
            if (!name || !args || !(name in args))
                return false;
            const value = args[name];
            return value != null && String(value).trim() !== '';
        },
        async applyPendingRecipe() {
            const recipeId = this.pendingRecipeId;
            if (!recipeId || !this.FlowID)
                return;
            this.pendingRecipeId = '';
            try {
                const raw = await webSocket.AskAiApplyRecipe(this.FlowID, recipeId);
                const result = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (!result?.ok) {
                    this.pushEditorMessage(result?.error || 'That example could not be applied.', 'error');
                    return;
                }
                const holes = await this.keepLookupsThatExist(Array.isArray(result.holes) ? result.holes : []);
                this.recipeHoles = holes;
                if (holes.length)
                    this.startRecipeHoleWatch();
            }
            catch (err) {
                this.pushEditorMessage('That example could not be applied.', 'error');
            }
        },
        async keepLookupsThatExist(holes) {
            const kept = [];
            for (const hole of holes) {
                if (hole?.kind !== 'lookup' || !hole.lookupApi || !hole.example) {
                    kept.push(hole);
                    continue;
                }
                const exists = await this.lookupHasValue(hole.lookupApi, hole.lookupValueField, hole.example);
                if (!exists) {
                    kept.push(hole);
                    continue;
                }
                const restored = await this.restoreRecipeArgument(hole);
                if (!restored)
                    kept.push(hole);
            }
            return kept;
        },
        async lookupHasValue(url, valueField, example) {
            try {
                const res = await utils.api.get(url);
                const rows = Array.isArray(res) ? res : (res?.Data || res?.Result || res?.Items || res?.rows || []);
                if (!Array.isArray(rows))
                    return false;
                const field = valueField || 'Name';
                const expected = String(example).trim();
                return rows.some(row => String(row?.[field] ?? row?.Value ?? row?.value ?? row?.Name ?? '').trim() === expected);
            }
            catch (err) {
                return false;
            }
        },
        async waitForRecipeCell(instanceId) {
            const deadline = Date.now() + 2500;
            while (Date.now() < deadline) {
                const cell = this.graph?.getCell?.(instanceId);
                if (cell)
                    return cell;
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            return this.graph?.getCell?.(instanceId) || null;
        },
        async restoreRecipeArgument(hole) {
            const cell = await this.waitForRecipeCell(hole.instanceId);
            const prop = cell?.attributes?.prop;
            if (!prop?.Model)
                return false;
            const name = String(hole.path || '').replace(/^Arguments\./, '');
            if (!name)
                return false;
            const args = { ...(prop.Model.Arguments || {}) };
            args[name] = hole.example;
            prop.Model.Arguments = args;
            this.syncFlowChanges({
                EventType: 'UpdateArgs',
                Data: {
                    FlowID: this.FlowID,
                    Content: {
                        Type: prop.Type,
                        InstanceID: hole.instanceId,
                        Arguments: args,
                    },
                },
            }, true);
            return true;
        },
        async chooseRecipeHole(hole) {
            if (hole?.instanceId && this.graph) {
                const cell = this.graph.getCell(hole.instanceId);
                const view = cell && this.paper?.findViewByModel?.(cell);
                if (view) {
                    await this.selectCellView(view);
                    this.openIconPropertyOverlay(view);
                    const field = String(hole.path || '').replace(/^Arguments\./, '');
                    this.$nextTick(() => this.focusOverlayField(hole.label || field));
                }
                return;
            }
            const editor = this.$refs.codeEditor;
            editor?.focus?.();
            if (hole?.literal)
                editor?.revealText?.(hole.literal);
        },
        focusOverlayField(label) {
            const root = this.$el?.querySelector?.('.c-FlowV2-icon-property-overlay');
            if (!root || !label)
                return;
            const needle = String(label).trim().toLowerCase();
            const labels = root.querySelectorAll('label, .q-field__label');
            for (const el of labels) {
                const text = (el.textContent || '').trim().toLowerCase();
                if (!text || (text.indexOf(needle) < 0 && needle.indexOf(text) < 0))
                    continue;
                const field = el.closest('.q-field') || el.parentElement;
                const input = field?.querySelector?.('input, textarea');
                if (input) {
                    input.focus();
                    return;
                }
            }
        },
        recipeSetupCard() {
            const holes = this.recipeHoles || [];
            if (!holes.length || this.editorSurface !== 'document')
                return null;
            return (
                <div
                    class="q-pa-sm rounded-borders shadow-2 bg-white"
                    style={{ position: 'absolute', left: '12px', bottom: '12px', zIndex: 30, width: '320px', maxWidth: 'calc(100% - 24px)' }}
                >
                    <div class="text-subtitle2">A few choices for your account</div>
                    <QList dense class="q-mt-xs" style={{ maxHeight: '180px', overflow: 'auto' }}>
                        {holes.map((hole, index) => (
                            <QItem key={(hole.instanceId || 'body') + '-' + index}>
                                <QItemSection>
                                    <QItemLabel>{(hole.caption ? hole.caption + ' — ' : '') + (hole.label || 'Choose a value')}</QItemLabel>
                                </QItemSection>
                                <QItemSection side>
                                    <QBtn dense flat no-caps color="primary" label="Choose" onClick={() => this.chooseRecipeHole(hole)} />
                                </QItemSection>
                            </QItem>
                        ))}
                    </QList>
                    <div class="row justify-end">
                        <QBtn flat no-caps label="Not now" onClick={() => { this.recipeHoles = []; this.stopRecipeHoleWatch(); }} />
                    </div>
                </div>
            );
        },

        applyAPIDelta(delta) {
            if (this.$refs.codeEditor)
                this.$refs.codeEditor.applyDelta(delta);

            //const ae = this.$refs.aceEditor.editor;

            //this.api_is_applying = true;

            //if (Array.isArray(delta))
            //    for (let d of delta)
            //        ae.getSession().getDocument().applyDelta(d);
            //else
            //    ae.getSession().getDocument().applyDelta(delta);

            //this.api_is_applying = false;
            //debugger;
        },
        applyAPIValidationErrors(errors) {
            const annotations = errors.map(e => ({
                row: e.Line,
                column: e.Column,
                text: e.Message,
                type: 'error', // warning, info
            }));

            if (this.$refs.codeEditor)
                this.$refs.codeEditor.setAnnotations(annotations);
            //this.$refs.aceEditor.editor.session.setAnnotations(annotations);
        },
        hideStatusBadge(element) {
            element.attr('statusBadge/visibility', 'hidden');
            element.attr('statusHit/visibility', 'hidden');
            element.attr('statusIcon/visibility', 'hidden');
            element.attr('statusTooltip/text', '');
        },
        showStatusBadge(element, errors) {
            element.attr('statusBadge/visibility', 'visible');
            element.attr('statusHit/visibility', 'visible');
            element.attr('statusIcon', {
                visibility: 'visible',
                fill: '#ff3333',
            });
            element.attr('statusTooltip/text', formatStatusTooltip(errors));
        },
        setValidationErrors(errors) {
            const list = Array.isArray(errors) ? errors : [];
            const byId = new Map();

            // 1. Clear all existing errors (always hide — errors without ArgName used to stick)
            const allelements = this.graph.getCells();
            for (let element of allelements) {
                if (element.attributes.prop) {
                    const hadErrors = element.attributes.prop.Errors && Object.keys(element.attributes.prop.Errors).length;
                    this.hideStatusBadge(element);
                    element.attributes.prop.Errors = {};
                    if (hadErrors && this.selected && this.selected.model == element)
                        this.updateSelected(element.attributes.prop);
                }
            }

            // 2. Group new errors by InstanceID
            for (let err of list) {
                console.log(`Error at ${err.InstanceID ?? ('line ' + err.Line + ' column ' + err.Column)}: ${err.Message}`);

                if (!err.InstanceID)
                    continue;
                const element = this.graph.getCell(err.InstanceID);
                if (!element)
                    continue;
                let bucket = byId.get(err.InstanceID);
                if (!bucket) {
                    bucket = { element, errors: [] };
                    byId.set(err.InstanceID, bucket);
                }
                bucket.errors.push(err);
                if (err.ArgName)
                    element.attributes.prop.Errors[err.ArgName] = err;
            }

            for (const { element, errors: cellErrors } of byId.values()) {
                console.log(`Element ${element.id} showing warning icon`);
                this.showStatusBadge(element, cellErrors);
                if (this.selected && this.selected.model == element)
                    this.updateSelected(element.attributes.prop);
            }
        },

        addUnavailableFlowItem(item) {
            const storedLinks = outboundStoredLinks(item);
            const portCount = storedLinks.length;
            const iconHeight = computeIconHeight(portCount);
            const position = { x: item.Location?.X || 0, y: item.Location?.Y || 0 };
            const caption = item.Caption ? String(item.Caption) : UNAVAILABLE_CAPTION;
            const tool_model = {
                API: { Caption: item.Caption || '' },
                Arguments: item.Arguments || {},
                Output: item.Output || {},
                MatchPorts: item.MatchPorts || {},
                Links: item.Links ?? [],
            };
            const iconElement = new IVRElement({
                id: item.InstanceID,
                position,
                size: { width: default_props.width, height: iconHeight },
                attrs: {
                    label: { text: formatDisplayName(caption) },
                    title: { text: UNAVAILABLE_TOOL_TITLE, fill: '#5f6368' },
                    icon: { d: getIconPath('mdi-help-circle-outline') },
                    // "passive" moves the step. magnet=false still starts a link.
                    root: { magnet: 'passive', magnetSelector: null },
                    body: {
                        magnet: 'passive',
                        stroke: UNAVAILABLE_ACCENT,
                        strokeDasharray: '4 3',
                    },
                },
                prop: {
                    InstanceID: item.InstanceID,
                    ToolID: item.ToolID,
                    Type: item.Type,
                    Unavailable: true,
                    Schema: null,
                    Model: tool_model,
                },
            });
            applyGroupAccent(iconElement, UNAVAILABLE_ACCENT);
            // magnet="false" still matches [magnet] and starts a link drag.
            // "passive" is the Joint value that moves the element instead.
            iconElement.attr('root/magnetSelector', null);
            iconElement.attr('root/magnet', 'passive');
            iconElement.attr('body/magnet', 'passive');

            for (let i = 0; i < storedLinks.length; i++) {
                const link = storedLinks[i];
                const pid = unavailablePortId(link, i);
                const label = link.Condition ? String(link.Condition) : (link.Name || '');
                iconElement.addPorts([{
                    id: pid,
                    group: 'default',
                    args: {
                        x: default_props.width,
                        y: computePortYFromBottom(i, portCount, iconHeight),
                    },
                    attrs: {
                        portBody: { magnet: 'passive', cursor: 'move', stroke: UNAVAILABLE_ACCENT },
                        portIcon: { d: getIconPath('mdi-help') },
                        portTooltip: { text: UNAVAILABLE_TOOL_TITLE },
                        labelText: { text: formatDisplayName(label) },
                    },
                    customData: {
                        Link: {
                            Name: link.Name,
                            DeclareMatch: true,
                            MatchValue: link.Condition != null && link.Condition !== ''
                                ? String(link.Condition)
                                : null,
                        },
                    },
                }]);
            }

            this.offsetOverlapping(iconElement);
            this.graph.addCell(iconElement);
            return tool_model;
        },

        async addFlowItem(item) {
            // Lookup ToolID
            let tool;
            switch (item.Type) {
                case 'Native':
                case 'Method':
                case 'Tool': tool = this.toolPalette?.[item.ToolID]; break;
                case 'Flow':
                case 'API':
                case 'FlowHeader':
                case 'APIHeader':
                    try {
                        tool = await this.fetchFlowTool(item.ToolID, item.Type);
                    }
                    catch (err) {
                        console.warn(`Failed to fetchFlowTool - ${err.message ?? err.reasonPhrase}`);
                    }
                    break;
            }
            if (!tool) {
                if (isPaletteToolType(item.Type))
                    return this.addUnavailableFlowItem(item);
                return;
            }

            const schema = await this.generateSchemaFromArgs(tool);
            const position = { x: item.Location.X, y: item.Location.Y };
            let tool_model = utils.schema.getDefaultModel(schema);

            if (item.Arguments)
                tool_model.Arguments = item.Arguments;

            if (item.Output)
                tool_model.Output = item.Output;

            if (item.MatchPorts)
                tool_model.MatchPorts = item.MatchPorts;
            else if (!tool_model.MatchPorts)
                tool_model.MatchPorts = {};

            // Seed MatchPorts from existing conditioned links for DeclareMatchPorts sources
            // so legacy Digits/Return conditions still produce ports after the flag is enabled.
            for (const src of getDeclareMatchSources(tool)) {
                if (!Array.isArray(tool_model.MatchPorts[src.Name]))
                    tool_model.MatchPorts[src.Name] = [];
                const rows = tool_model.MatchPorts[src.Name];
                for (const link of (item.Links || [])) {
                    if (link.Name !== src.Name || link.Condition == null || link.Condition === '')
                        continue;
                    const v = String(link.Condition);
                    if (!rows.some(e => String(e?.Value) === v))
                        rows.push({ Value: v, Label: '' });
                }
            }

            if (item.Caption)
                tool_model.API.Caption = item.Caption;

            tool_model.Links = item.Links ?? [];

            /*
                {
                    Type: 'Tool',
                    ToolID: draggedData.Item.id,
                    InstanceID: instance_id,
                    Caption: item.API.Caption,
                    Arguments: item.Arguments,
                    Links: [],
                    Location: { X: position.x, Y: position.y },
                }
            */

            const effectiveLinks = getEffectiveLinks(tool, tool_model);
            const portCount = effectiveLinks.length;
            const iconHeight = computeIconHeight(portCount);
            const iconElement = new IVRElement({
                id: item.InstanceID,
                position: position,
                size: { width: default_props.width, height: iconHeight },
                attrs: {
                    label: { text: formatDisplayName(tool_model.API.Caption) },
                    title: { text: formatDisplayName(tool.name) },
                    icon: { d: getIconPath(tool.icon ?? 'mdi-circle') },
                },
                prop: {
                    InstanceID: item.InstanceID,
                    ToolID: item.ToolID,
                    Type: item.Type,
                    Schema: schema,
                    Model: tool_model,
                },
            });
            applyGroupAccent(iconElement, tool.color);

            for (let i = 0; i < effectiveLinks.length; i++) {
                const p = effectiveLinks[i];
                const pid = getPortId(p);
                iconElement.addPorts([{
                    id: pid,
                    group: 'default',
                    args: {
                        x: default_props.width,
                        y: computePortYFromBottom(i, portCount, iconHeight),
                    },
                    attrs: {
                        portIcon: { d: getIconPath(p.Icon) },
                        portTooltip: { text: formatDisplayName(p.Tooltip) },
                        labelText: { text: portLabelText(p, formatPortLabel) },
                    },
                    customData: {
                        Link: p
                    }
                }]);
            }

            this.offsetOverlapping(iconElement);

            this.graph.addCell(iconElement);
            return tool_model;
        },

        /**
         * Deep-watch model.MatchPorts for the selected cell; sync Joint ports + debounce persist.
         * @param {object} cellView JointJS cell view
         */
        attachMatchPortsWatch(cellView) {
            if (this.watchMatchPorts) {
                this.watchMatchPorts();
                this.watchMatchPorts = null;
            }
            if (!cellView?.model || !this.model || !getDeclareMatchSources(this.tool).length)
                return;

            if (!this.model.MatchPorts)
                this.model.MatchPorts = {};

            const instance_id = cellView.model.attributes.prop?.InstanceID;
            this.watchMatchPorts = this.$watch(
                () => this.model.MatchPorts,
                (newv) => {
                    this.syncIconPorts(cellView.model);
                    this.debouncedUpdateMatchPorts?.(newv, instance_id);
                },
                { deep: true }
            );
        },

        /**
         * Rebuild JointJS ports from tool.Links + model.MatchPorts; resize icon height.
         * Surviving outbound links are detached before the port rewrite and re-created
         * afterward so LinkViews never keep stale magnet DOM across the rebuild.
         * @param {object} element JointJS element
         */
        syncIconPorts(element) {
            if (!element?.isElement?.())
                return;

            const prop = element.attributes.prop;
            if (!prop?.ToolID)
                return;

            let tool;
            switch (prop.Type) {
                case 'Native':
                case 'Method':
                case 'Tool':
                    tool = this.toolPalette?.[prop.ToolID];
                    break;
                default:
                    tool = this.userFlowHeader_cache?.[prop.ToolID];
                    break;
            }
            if (!tool?.Links)
                return;

            const model = prop.Model;
            const effectiveLinks = getEffectiveLinks(tool, model);
            const wantedIds = new Set(effectiveLinks.map(p => getPortId(p)));
            const existing = element.getPorts() || [];
            const obsolete = existing.filter(p => !wantedIds.has(p.id));
            const existingIds = new Set(existing.map(p => p.id));
            const missing = effectiveLinks.filter(p => !existingIds.has(getPortId(p)));

            const portCount = effectiveLinks.length;
            const iconHeight = computeIconHeight(portCount);
            const size = element.size() || {};
            const width = size.width || default_props.width;
            const structuralChange = obsolete.length > 0
                || missing.length > 0
                || size.height !== iconHeight;

            const refreshPortAttrs = (pid, p) => {
                const iconPath = getIconPath(p.Icon);
                const tooltip = formatDisplayName(p.Tooltip);
                const label = portLabelText(p, formatPortLabel);
                const ep = element.getPort(pid);
                if (!ep)
                    return;
                if (ep.attrs?.portIcon?.d !== iconPath)
                    element.portProp(pid, 'attrs/portIcon/d', iconPath);
                if (ep.attrs?.portTooltip?.text !== tooltip)
                    element.portProp(pid, 'attrs/portTooltip/text', tooltip);
                if (ep.attrs?.labelText?.text !== label)
                    element.portProp(pid, 'attrs/labelText/text', label);
                element.portProp(pid, 'customData', { Link: p });
            };

            // Label/tooltip-only (or blank-row) edits: no resize / port DOM thrash.
            if (!structuralChange) {
                for (const p of effectiveLinks)
                    refreshPortAttrs(getPortId(p), p);
                return;
            }

            // Persist-remove links on ports that are going away.
            for (const port of obsolete) {
                const connected = this.graph.getConnectedLinks(element)
                    .filter(l => l.attributes?.source?.id === element.id
                        && l.attributes?.source?.port === port.id);
                for (const cl of connected) {
                    this.syncFlowChanges({
                        EventType: 'RemoveLink',
                        Data: {
                            FlowID: this.FlowID,
                            Content: {
                                InstanceID: element.id,
                                Link: this.getLinkfromJSlink(cl),
                            }
                        },
                    }, true);
                    cl.remove();
                }
            }

            // Snapshot + locally detach surviving outbound links BEFORE port DOM rebuild
            // so LinkViews cannot keep stale magnet nodes across the rewrite.
            const linkSnapshots = this.snapshotOutboundLinks(element, wantedIds);
            this._suppressLinkSourceSync = true;
            try {
                for (const link of this.graph.getConnectedLinks(element, { outbound: true })) {
                    if (wantedIds.has(link.get('source')?.port))
                        link.remove();
                }
            }
            finally {
                this._suppressLinkSourceSync = false;
            }

            const portItems = effectiveLinks.map((p, i) => ({
                id: getPortId(p),
                group: 'default',
                args: {
                    x: width,
                    y: computePortYFromBottom(i, portCount, iconHeight),
                },
                attrs: {
                    portIcon: { d: getIconPath(p.Icon) },
                    portTooltip: { text: formatDisplayName(p.Tooltip) },
                    labelText: { text: portLabelText(p, formatPortLabel) },
                },
                customData: { Link: p },
            }));

            element.resize(width, iconHeight);
            element.prop('ports/items', portItems, { rewrite: true });

            // Ports are applied synchronously by Joint; refresh cache and re-add links now.
            this.restoreOutboundLinks(element, linkSnapshots);
            if (this.selected?.model === element)
                this.highlightConnectedLinks(element);
        },

        /**
         * @param {object} element
         * @param {Set<string>} wantedPortIds
         * @returns {object[]}
         */
        snapshotOutboundLinks(element, wantedPortIds) {
            const outbound = this.graph.getConnectedLinks(element, { outbound: true });
            const snapshots = [];
            for (const link of outbound) {
                const port = link.get('source')?.port;
                if (!port || !wantedPortIds.has(port))
                    continue;
                snapshots.push({
                    id: link.id,
                    port,
                    target: { ...(link.get('target') || {}) },
                    vertices: (link.get('vertices') || []).map(v => ({ ...v })),
                    labels: JSON.parse(JSON.stringify(link.get('labels') || [])),
                    attrs: JSON.parse(JSON.stringify(link.attr())),
                    router: link.get('router'),
                    connector: link.get('connector'),
                    z: link.get('z'),
                });
            }
            return snapshots;
        },

        /**
         * Re-add outbound links after a port rebuild (same ids; local-only, no sync).
         * @param {object} element
         * @param {object[]} snapshots
         */
        restoreOutboundLinks(element, snapshots) {
            if (!element?.isElement?.() || !this.graph || !snapshots?.length)
                return;

            const elementView = this.paper?.findViewByModel?.(element);
            if (elementView) {
                if (typeof elementView._refreshPorts === 'function')
                    elementView._refreshPorts();
                if (typeof elementView.cleanNodesCache === 'function')
                    elementView.cleanNodesCache();
            }

            this._suppressLinkSourceSync = true;
            try {
                for (const s of snapshots) {
                    if (!element.hasPort(s.port))
                        continue;
                    // Replace any leftover cell so we never keep a broken LinkView.
                    const existing = this.graph.getCell(s.id);
                    if (existing)
                        existing.remove();

                    const newLink = new shapes.standard.Link({
                        id: s.id,
                        source: { id: element.id, port: s.port },
                        target: s.target,
                        vertices: s.vertices,
                        labels: s.labels,
                        attrs: s.attrs,
                        router: s.router,
                        connector: s.connector,
                        z: s.z,
                    });
                    this.graph.addCell(newLink);
                }
            }
            finally {
                this._suppressLinkSourceSync = false;
            }

            for (const link of this.graph.getConnectedLinks(element, { inbound: true })) {
                this.paper?.findViewByModel?.(link)?.update?.();
            }
        },

        offsetOverlapping(element) {
            const position = element.get('position');
            if (this.graph.getElements().some(el => el.id !== element.id && el.get('position').x === position.x && el.get('position').y === position.y)) {
                element.translate(5, 5);
            }
        },

        styledLabel(text) {
            return {
                position: { distance: 0.5 },
                attrs: {
                    text: {
                        text: text ?? '',
                        fontSize: 18,
                        fontFamily: 'Arial, sans-serif',
                        //strokeWidth: 8, // Thick stroke creates padding effect
                        //strokeLinejoin: 'round',
                        //strokeLinecap: 'round',
                    },
                }
            };
        },
        async ensureStoredLinks() {
            const linked = new Set();
            for (const cell of this.graph.getLinks()) {
                const source = cell.get('source') || {};
                const target = cell.get('target') || {};
                if (source.id && target.id)
                    linked.add(`${source.id}|${target.id}`);
            }
            for (const element of this.graph.getElements()) {
                const prop = element.attributes?.prop;
                const links = (prop?.Model?.Links || []).filter((link) => link?.TargetID && !linked.has(`${prop.InstanceID}|${link.TargetID}`));
                if (!links.length)
                    continue;
                await this.createItemLinks({
                    Type: prop.Type,
                    ToolID: prop.ToolID,
                    InstanceID: prop.InstanceID,
                    Links: links,
                });
                for (const link of links)
                    linked.add(`${prop.InstanceID}|${link.TargetID}`);
            }
        },
        async createItemLinks(item) {
            switch (item.Type) {
                case 'Native':
                case 'Method':
                case 'Tool':
                case 'Flow':
                case 'FlowHeader':
                case 'APIHeader':
                    {
                        // Lookup ToolID
                        let tool;
                        switch (item.Type) {
                            case 'Native':
                            case 'Method':
                            case 'Tool': tool = this.toolPalette?.[item.ToolID]; break;
                            case 'Flow':
                            case 'FlowHeader':
                            case 'APIHeader':
                                tool = await this.fetchFlowTool(item.ToolID, item.Type); break;
                        }
                        if (!tool) {
                            const element = this.graph.getCell(item.InstanceID);
                            if (!element?.attributes?.prop?.Unavailable || !item.Links)
                                return;

                            const storedLinks = outboundStoredLinks(item);
                            for (let i = 0; i < storedLinks.length; i++) {
                                const link = storedLinks[i];
                                const targetEl = this.graph.getCell(link.TargetID);
                                if (!targetEl)
                                    continue;

                                const portId = unavailablePortId(link, i);
                                if (!element.getPort(portId))
                                    continue;

                                const newLink = new shapes.standard.Link({
                                    id: link.ID,
                                    source: {
                                        id: element.id,
                                        port: portId,
                                    },
                                    target: {
                                        id: targetEl.id,
                                    },
                                    vertices: link.Vertices?.map(a => ({ x: a.X, y: a.Y })),
                                });

                                if (link.Condition)
                                    newLink.prop('labels/0', this.styledLabel(link.Condition));

                                this.graph.addCell(newLink);
                            }
                            return;
                        }

                        if (item.Links) {
                            const element = this.graph.getCell(item.InstanceID);
                            if (!element) return;

                            const effectiveLinks = getEffectiveLinks(tool, element.attributes.prop.Model);

                            for (let link of item.Links) {
                                if (!link.TargetID) continue;

                                const targetEl = this.graph.getCell(link.TargetID);
                                if (!targetEl) continue;

                                const portId = resolveStoredLinkPortId(link, effectiveLinks);
                                if (!element.getPort(portId))
                                    continue;

                                const newLink = new shapes.standard.Link({
                                    id: link.ID,
                                    source: {
                                        id: element.id,
                                        port: portId,
                                    },
                                    target: {
                                        id: targetEl.id
                                    },
                                    vertices: link.Vertices?.map(a => ({ x: a.X, y: a.Y })),
                                });

                                const linkTool = effectiveLinks.find(a => getPortId(a) === portId)
                                    || tool.Links?.find(a => a.Name == link.Name);

                                if (link.Condition && linkTool && linkTool.EnableCondition && !linkTool.DeclareMatch)
                                    newLink.prop('labels/0', this.styledLabel(link.Condition));

                                this.graph.addCell(newLink);
                            }
                        }
                    }
                    break;
            }
        },
        canPasteFlowItem(item) {
            if (!item)
                return false;
            if (isPaletteToolType(item.Type))
                return !!(item.ToolID && this.toolPalette?.[item.ToolID]);
            return true;
        },
        async applyRemoteToolPalette() {
            if (this._remotePaletteReload) {
                this._remotePaletteReloadAgain = true;
                return;
            }
            this._remotePaletteReload = true;
            try {
                do {
                    this._remotePaletteReloadAgain = false;
                    await this.loadToolPalette(true);
                    await this.redrawOpenFlowFromGraph();
                } while (this._remotePaletteReloadAgain);
            }
            catch (err) {
                console.warn(`ToolPalette reload failed - ${err?.message || err}`);
            }
            finally {
                this._remotePaletteReload = false;
            }
        },
        async loadToolPalette(ignoreCache = false) {
            const url = ignoreCache
                ? 'Apps/FlowV2/ListPalette?IgnoreCache=true'
                : 'Apps/FlowV2/ListPalette';
            const model = await utils.api.get(url);
            const items = Array.isArray(model) ? model : [];
            const alltools = {};
            for (const item of items.flatMap((group) => group.children || [])) {
                if (item?.id)
                    alltools[item.id] = item;
            }
            this._reloadingToolPalette = !!this.toolPalette;
            try {
                this.toolPalette = alltools;
                this.toolPaletteItems = items;
            }
            finally {
                this._reloadingToolPalette = false;
            }
        },
        togglePaletteName(name, selected) {
            this.paletteNameOptions = this.paletteNameOptions.map((option) => (
                option.name === name ? { ...option, selected: !!selected } : option
            ));
        },
        async openPaletteSettings() {
            this.paletteSettingsOpen = true;
            this.paletteSettingsLoading = true;
            this.paletteSettingsError = '';
            this.paletteNameOptions = [];
            try {
                const namesPayload = await utils.api.get('Apps/FlowV2/GetPaletteNames');
                let settings = null;
                try {
                    settings = await utils.api.get('Apps/Platform/Schema/Flow/v2/UserSettings');
                }
                catch {
                    settings = null;
                }
                if (!Array.isArray(namesPayload)) {
                    this.paletteSettingsError = 'Could not read palette names.';
                    return;
                }
                const saved = paletteNamesFromSettings(settings);
                const hasSavedPalettes = saved !== null;
                const seen = new Set();
                const options = [];
                for (const entry of namesPayload) {
                    const name = typeof entry === 'string' ? entry : (entry?.Name ?? entry?.name ?? '');
                    if (!name || seen.has(name))
                        continue;
                    seen.add(name);
                    options.push({
                        name: String(name),
                        selected: hasSavedPalettes
                            ? saved.includes(String(name))
                            : String(name) === DEFAULT_PALETTE_NAME,
                    });
                }
                if (hasSavedPalettes) {
                    for (const name of saved) {
                        if (!seen.has(name)) {
                            seen.add(name);
                            options.push({ name, selected: true });
                        }
                    }
                }
                this.paletteNameOptions = options;
            }
            catch (err) {
                this.paletteSettingsError = err?.message || 'Could not load palette settings.';
            }
            finally {
                this.paletteSettingsLoading = false;
            }
        },
        async savePaletteSettings() {
            if (this.paletteSettingsSaving || this.paletteSettingsLoading)
                return;
            const palettes = this.paletteNameOptions.filter((option) => option.selected).map((option) => option.name);
            this.paletteSettingsSaving = true;
            this.paletteSettingsError = '';
            try {
                await utils.api.request('POST', 'Apps/Platform/Schema/Flow/v2/UserSettings', { Palettes: palettes });
                await this.loadToolPalette(true);
                this.paletteSettingsOpen = false;
                await this.redrawOpenFlowFromGraph();
            }
            catch (err) {
                this.paletteSettingsError = err?.message || 'Could not save palette settings.';
            }
            finally {
                this.paletteSettingsSaving = false;
            }
        },
        async redrawOpenFlowFromGraph() {
            if (this.ItemType !== 'FlowHeader' || !this.graph)
                return;
            const elements = this.graph.getElements().filter((el) => el.attributes?.prop?.InstanceID);
            if (!elements.length) {
                this._pendingRedrawFromGraph = false;
                return;
            }

            // Same gate as loadFlow — port magnets come out wrong on a zero-sized paper.
            if (!this.isEditorPaperMeasurable()) {
                this._flowLoadedWhileHidden = true;
                this._pendingRedrawFromGraph = true;
                return;
            }
            this._pendingRedrawFromGraph = false;
            this._flowLoadedWhileHidden = false;

            const items = elements.map((el) => this.serializeIconForClipboard(el));
            const findWasOpen = this.flowFindOpen;
            this.debouncedSaveCanvasViewState?.cancel?.();
            this.saveCanvasViewState();
            this.debouncedUpdateLink?.cancel?.();
            this._suppressCanvasViewSave = true;
            this._suppressLinkSourceSync = true;
            this._suppressVertexSync = true;
            try {
                this.hideSiblingHoverTools();
                this.closeIconPropertyOverlay();
                this.clearSelected();
                this.debugElement = null;
                this.graph.clear();
                for (const item of items)
                    await this.addFlowItem(item);
                for (const item of items)
                    await this.createItemLinks(item);
                this.applyLinkRouter(this.connectorStyle);
                this.restoreAllBreakpoints();
                await this.restorePausedDebugHighlight();
                await this.restoreCanvasViewState(this.FlowID);
                if (findWasOpen)
                    this.recomputeFlowFindMatches();
            }
            finally {
                this._suppressLinkSourceSync = false;
                this._suppressVertexSync = false;
                this._suppressCanvasViewSave = false;
            }
        },
        getAllLinks(model) {
            const links = this.graph.getConnectedLinks(model);
            return links.filter(a => a.attributes.source.id == model.attributes.id).map(a => this.getLinkfromJSlink(a));
        },
        serializeIconForClipboard(element) {
            const pos = element.get('position');
            return {
                Type: element.attributes.prop.Type,
                ToolID: element.attributes.prop.ToolID,
                InstanceID: element.attributes.prop.InstanceID,
                Caption: element.attributes.prop.Model.API.Caption ?? '',
                Arguments: element.attributes.prop.Model.Arguments,
                Output: element.attributes.prop.Model.Output,
                MatchPorts: element.attributes.prop.Model.MatchPorts,
                Links: this.getAllLinks(element),
                Location: { X: pos.x, Y: pos.y },
            };
        },
        async copyToClipboard() {
            try {
                // Get selected icons
                if (this.selectedCells.length === 0) {
                    if (this.selected) {
                        const data = JSON.stringify([this.serializeIconForClipboard(this.selected.model)]);
                        await navigator.clipboard.writeText(data);
                        console.log('Icons copied to clipboard:', data);
                        return;
                    }

                    console.log('No icons selected to copy');
                    return;
                }

                // Serialize the selected icons from the live graph (Model.Links is a load-time snapshot)
                const data = JSON.stringify(this.selectedCells
                    .filter(a => a.isElement?.())
                    .map(a => this.serializeIconForClipboard(a)));

                // Write to clipboard
                await navigator.clipboard.writeText(data);
                console.log('Icons copied to clipboard:', data);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        },
        async pasteFromClipboard() {
            try {
                const text = await navigator.clipboard.readText();
                if (text && text.startsWith('[') && text.endsWith(']')) {
                    const clipboardItems = JSON.parse(text);
                    if (!Array.isArray(clipboardItems)) {
                        alert('Invalid data detected in clipboard');
                        return;
                    }
                    const pastedIcons = clipboardItems.filter((item) => this.canPasteFlowItem(item));
                    if (!pastedIcons.length)
                        return;

                    // create a translation table to regenerate instance IDs for those that
                    // are already in the graph.
                    const idmap = {};
                    for (let item of pastedIcons) {
                        const newid = this.graph.getCell(item.InstanceID) ? utils.generateUUID() : item.InstanceID;
                        idmap[item.InstanceID] = newid;
                        item.InstanceID = newid;
                    }
                    // Scan all pasted elements and update any Links that reference to the items being
                    // pasted to use the new id.
                    for (let p of pastedIcons) {
                        for (let i = p.Links.length - 1; i >= 0; i--) {
                            const link = p.Links[i];
                            link.ID = utils.generateUUID();
                            if (link.TargetID in idmap)
                                link.TargetID = idmap[link.TargetID];
                            else // if (!this.graph.getCell(link.TargetID))
                                p.Links.splice(i, 1);
                        }
                    }

                    for (let item of pastedIcons) {
                        await this.addFlowItem(item);
                    }
                    for (let item of pastedIcons) {
                        this.createItemLinks(item);
                    }

                    const groupId = utils.generateUUID();
                    for (let item of pastedIcons) {
                        this.syncFlowChanges({
                            EventType: 'Add',
                            Data: {
                                FlowID: this.FlowID,
                                UndoGroup: groupId,
                                Content: item,
                            },
                        }, true);
                    }

                    this.selected = null;
                    this.selectedHasBreakpoint = false;
                    this.selectedCells = pastedIcons.map(a => this.graph.getCell(a.InstanceID));

                    // Highlight selected elements
                    this.updateHighlights();
                    if (this.batchEditingEnabled())
                        await this.applyCanvasMultiSelection();
                }
            }
            catch (err) {
            }
        },

        syncFlowChanges(data, pendingSave) {
            if (this.editorReadOnly)
                return;
            if (pendingSave)
                this.noteLocalEdit(data);
            const strdata = JSON.stringify(data);
            console.log(`syncFlowChanges: ${strdata}`);
            webSocket.SendFlowEditorChanges(this.FlowID, strdata);
        },
        syncClassChanges(data, pendingSave) {
            if (this.editorReadOnly)
                return false;
            if (pendingSave)
                this.noteLocalEdit(data);
            const strdata = JSON.stringify(data);
            console.log(`syncClassChanges: ${strdata}`);
            const sent = webSocket.SendFlowEditorClassChanges(this.FlowID, strdata);
            return sent;
        },
        reservedSiblingTokens() {
            const reserved = ['Platform', 'System', 'User', 'Integrations', 'media', 'globals', 'Default'];
            const locals = (this.detected_locals || []).map(a => a.Name);
            const params = (this.variables || []).map(a => a.Name);
            return reserved.concat(locals).concat(params).concat(this.siblingAliases);
        },
        isLegalAliasToken(alias) {
            return this.isLegalAliasTokenExcept(alias, null);
        },
        isLegalAliasTokenExcept(alias, except) {
            if (!alias || !/^[A-Za-z_][A-Za-z0-9_]*$/.test(alias))
                return false;
            return !this.reservedSiblingTokens().filter(t => t != except).includes(alias);
        },
        defaultSiblingClassFullName(row) {
            const name = row?.Name || '';
            return name ? `User.${name}.Default${name}` : '';
        },
        siblingClassFullName(row, className) {
            const name = row?.Name || '';
            const cls = className || defaultClassName(name);
            return generatedClassFullName(name, cls) || this.defaultSiblingClassFullName(row);
        },
        folderClassesFor(name, path) {
            return listClassesForRow(
                { Name: name, Path: path || '', Classes: [], Aliases: [] },
                this.$refs.folderGrid?.folderData || [],
            ).map((c) => ({ Name: c.name, IsDefault: c.isDefault }));
        },
        attachSiblingClasses(row) {
            if (!row)
                return row;
            const fromFolder = this.folderClassesFor(row.Name, row.Path);
            const existing = row.Classes || [];
            if (!fromFolder.length && existing.length)
                return row;
            const seen = new Set(existing.map((c) => c.Name));
            row.Classes = existing.concat(fromFolder.filter((c) => !seen.has(c.Name)));
            return row;
        },
        ensureCanvasDefaultAliases(rows) {
            for (const row of rows || []) {
                if ((row.Aliases || []).some((a) => a?.Alias && String(a.Alias).trim()))
                    continue;
                const alias = this.suggestSiblingAlias(row.Name);
                if (alias)
                    this.addSiblingAlias(row, alias, defaultClassName(row.Name));
            }
        },
        addSiblingAlias(row, alias, className) {
            if (!row?.ProjectId || !this.isLegalAliasTokenExcept(alias, null))
                return;
            this.upsertSiblingAlias(row, alias, className);
        },
        changeSiblingAliasClass(row, alias, className) {
            if (!row?.ProjectId || !alias?.Alias || !className)
                return;
            const classFullName = this.siblingClassFullName(row, className);
            if (alias.ClassFullName == classFullName)
                return;
            this.upsertSiblingAlias(row, alias.Alias, className);
        },
        renameSiblingAlias(row, oldAlias, newAlias, className) {
            if (!row?.ProjectId || !oldAlias || oldAlias == newAlias)
                return;
            if (!this.isLegalAliasTokenExcept(newAlias, oldAlias))
                return;
            const existing = (row.Aliases || []).find(a => a.Alias == oldAlias);
            const resolvedClass = className
                || parseGeneratedClassFullName(existing?.ClassFullName)?.className
                || defaultClassName(row.Name);
            this.upsertSiblingAlias(row, newAlias, resolvedClass, oldAlias);
        },
        upsertSiblingAlias(row, alias, className, oldAlias) {
            if (!row?.ProjectId || !alias)
                return;
            const content = {
                Alias: alias,
                ProjectId: row.ProjectId,
                ClassFullName: this.siblingClassFullName(row, className),
                ProjectName: row.Name,
                ProjectPath: row.Path,
            };
            if (oldAlias && oldAlias != alias)
                content.OldAlias = oldAlias;
            this.sendSiblingEvent('ImportSiblingAs', content);
        },
        suggestSiblingAlias(projectName) {
            return uniqueImportAlias(projectName, (alias) => !this.isLegalAliasToken(alias));
        },
        formatApiError(err) {
            if (err == null)
                return '';
            if (typeof err === 'string')
                return err;
            const text = err.Reason || err.Message || err.message || err.reason || '';
            if (text)
                return text;
            if (typeof err === 'object')
                return '';
            return String(err);
        },
        rememberSiblingRows(projectId, rows) {
            if (!projectId)
                return;
            this.siblingCache = { ...this.siblingCache, [projectId]: (rows || []).slice() };
        },
        siblingEventSig(eventType, content) {
            const c = content || {};
            return [eventType, c.Alias || '', c.OldAlias || '', c.ProjectId || '', c.ClassFullName || ''].join('|');
        },
        noteSiblingSent(eventType, content) {
            const sig = this.siblingEventSig(eventType, content);
            const sent = (this._siblingSent || []).filter((e) => Date.now() - e.at < 15000);
            sent.push({ sig, at: Date.now() });
            this._siblingSent = sent.slice(-40);
            if (this.parent_id)
                this.siblingDirty = { ...this.siblingDirty, [this.parent_id]: true };
        },
        consumeSiblingEcho(eventType, content) {
            const sig = this.siblingEventSig(eventType, content);
            return (this._siblingSent || []).some((e) => e.sig == sig && Date.now() - e.at < 15000);
        },
        siblingAliasStateEqual(left, right) {
            const norm = (rows) => (rows || []).map((r) => ({
                id: r.ProjectId,
                aliases: (r.Aliases || [])
                    .map((a) => `${a.Alias}\0${a.ClassFullName || ''}`)
                    .sort()
                    .join('\n'),
            })).sort((a, b) => String(a.id).localeCompare(String(b.id)));
            return JSON.stringify(norm(left)) === JSON.stringify(norm(right));
        },
        async loadSiblingDependencies() {
            if (!this.parent_id) {
                this.siblingRows = [];
                return;
            }
            const projectId = this.parent_id;
            const cached = this.siblingCache[projectId];
            if (Array.isArray(cached) && cached.length && !(this.siblingRows || []).length)
                this.siblingRows = cached.slice();
            this.siblingLoading = true;
            this.siblingError = '';
            try {
                const res = await utils.api.get(`Apps/FlowV2/GetSiblingDependencies?ProjectID=${encodeURIComponent(projectId)}`);
                if (res && res.Success === false) {
                    this.siblingError = this.formatApiError(res);
                    return;
                }
                const rows = res?.Rows || res?.Result?.Rows || (Array.isArray(res) ? res : []);
                if (!Array.isArray(rows))
                    return;
                const incoming = rows.map((r) => this.attachSiblingClasses({ ...r, Classes: r.Classes || [] }));
                if (this.siblingDirty[projectId] && !this.siblingAliasStateEqual(this.siblingRows, incoming)) {
                    this.siblingRows = (this.siblingRows || []).map((r) => this.attachSiblingClasses(r));
                    this.rememberSiblingRows(projectId, this.siblingRows);
                    this.ensureCanvasDefaultAliases(this.siblingRows);
                    return;
                }
                if (this.siblingDirty[projectId])
                    this.siblingDirty = { ...this.siblingDirty, [projectId]: false };
                this.siblingRows = incoming;
                this.rememberSiblingRows(projectId, this.siblingRows);
                this.ensureCanvasDefaultAliases(this.siblingRows);
            }
            catch (err) {
                // Listing API is new — not on the host until CompilerCore is deployed.
                // Keep any optimistic / cached rows from this session.
                const text = this.formatApiError(err);
                const missing = /not found|unknown|404|does not exist/i.test(text)
                    || err?.StatusCode == 404
                    || err?.status == 404;
                this.siblingError = missing ? '' : text;
            }
            finally {
                this.siblingLoading = false;
            }
        },
        applySiblingEventLocal(data) {
            const content = data?.Data?.Content || data?.Content || {};
            const eventType = data.EventType;
            if (eventType == 'ImportSiblingAs') {
                const projectId = content.ProjectId;
                let row = this.siblingRows.find(r => r.ProjectId == projectId);
                if (!row) {
                    row = this.attachSiblingClasses({
                        ProjectId: projectId,
                        Name: content.ProjectName || projectId,
                        Path: content.ProjectPath || '',
                        Source: 'Added',
                        UsedByFlowNames: [],
                        Aliases: [],
                        Classes: [],
                    });
                    this.siblingRows = this.siblingRows.concat([row]);
                }
                else {
                    this.attachSiblingClasses(row);
                }
                const drop = new Set([content.Alias, content.OldAlias].filter(Boolean));
                const prior = (row.Aliases || []).find(a => a.Alias == content.OldAlias || a.Alias == content.Alias);
                const aliases = (row.Aliases || []).filter(a => !drop.has(a.Alias));
                aliases.push({
                    Alias: content.Alias,
                    ClassFullName: content.ClassFullName,
                    _key: prior?._key || content.OldAlias || content.Alias,
                });
                row.Aliases = aliases;
                this.siblingRows = this.siblingRows.slice();
            }
            else if (eventType == 'RemoveSiblingAlias') {
                for (const row of this.siblingRows) {
                    row.Aliases = (row.Aliases || []).filter(a => a.Alias != content.Alias);
                }
                this.siblingRows = this.siblingRows.slice();
            }
            else if (eventType == 'AddExplicitSibling') {
                if (!this.siblingRows.some(r => r.ProjectId == content.ProjectId)) {
                    this.siblingRows = this.siblingRows.concat([this.attachSiblingClasses({
                        ProjectId: content.ProjectId,
                        Name: content.ProjectName || content.ProjectId,
                        Path: content.ProjectPath || '',
                        Source: 'Added',
                        UsedByFlowNames: [],
                        Aliases: [],
                        Classes: [],
                    })]);
                }
            }
            else if (eventType == 'RemoveExplicitSibling') {
                this.siblingRows = this.siblingRows.filter(r => r.ProjectId != content.ProjectId || r.Source == 'Canvas');
            }
            if (this.parent_id)
                this.rememberSiblingRows(this.parent_id, this.siblingRows);
        },
        async sendSiblingEvent(eventType, content) {
            this.noteSiblingSent(eventType, content);
            this.applySiblingEventLocal({ EventType: eventType, Data: { Content: content } });
            const sent = this.syncClassChanges({
                EventType: eventType,
                Data: {
                    ProjectID: this.parent_id,
                    Content: content,
                },
            }, true);
            if (eventType == 'ImportSiblingAs' || eventType == 'RemoveSiblingAlias') {
                try {
                    await sent;
                }
                catch (err) {
                    console.warn('Sibling class change failed', err);
                }
                this.debouncedSiblingValidate?.();
            }
        },
        aliasForClass(classFullName, projectId) {
            for (const row of this.siblingRows || []) {
                if (projectId && row.ProjectId != projectId)
                    continue;
                for (const alias of row.Aliases || []) {
                    if (alias.ClassFullName == classFullName)
                        return alias.Alias;
                }
            }
            return null;
        },
        openImportAsDialog(preset) {
            const state = {
                projectId: preset?.ProjectID || preset?.ProjectId || '',
                projectName: preset?.ProjectName || '',
                projectPath: preset?.Path || '',
                className: preset?.ClassName || (preset?.ProjectName ? `Default${preset.ProjectName}` : ''),
                alias: this.suggestSiblingAlias(preset?.ProjectName || ''),
                projects: [],
            };
            const loadProjects = async () => {
                try {
                    const items = await utils.api.get('Apps/FlowV2/ListAllFolderItems');
                    const list = Array.isArray(items) ? items : (items?.Result || items?.Rows || []);
                    state.projects = (list || []).filter(p => p.Type == 'Project' && p.ID != this.parent_id);
                }
                catch {
                    state.projects = [];
                }
            };
            loadProjects();
            this.$refs.genericDialog.showDialog('Import as…', 520, () => (
                <div class="q-gutter-md">
                    <QInput
                        outlined
                        dense
                        label="Project ID"
                        modelValue={state.projectId}
                        onUpdate:modelValue={(v) => {
                            state.projectId = v;
                            const hit = state.projects.find(p => p.ID == v);
                            if (hit) {
                                state.projectName = hit.Name;
                                state.projectPath = hit.Path || '';
                                if (!state.className)
                                    state.className = `Default${hit.Name}`;
                                if (!state.alias)
                                    state.alias = this.suggestSiblingAlias(hit.Name);
                            }
                        }}
                    />
                    <div class="text-caption text-grey">
                        {state.projects.slice(0, 8).map(p => `${p.Name} (${p.ID})`).join(' · ')}
                    </div>
                    <QInput
                        outlined
                        dense
                        label="Class name"
                        modelValue={state.className}
                        onUpdate:modelValue={(v) => { state.className = v; }}
                    />
                    <QInput
                        outlined
                        dense
                        label="Alias"
                        modelValue={state.alias}
                        onUpdate:modelValue={(v) => { state.alias = v; }}
                        error={!!state.alias && !this.isLegalAliasToken(state.alias)}
                        error-message="Alias must be a unique legal identifier"
                    />
                </div>
            ), () => {
                if (!state.projectId || !this.isLegalAliasToken(state.alias) || !state.className)
                    return;
                const classFullName = `User.${state.projectName || state.className}.${state.className}`;
                this.sendSiblingEvent('ImportSiblingAs', {
                    Alias: state.alias,
                    ProjectId: state.projectId,
                    ClassFullName: classFullName,
                    ProjectName: state.projectName,
                    ProjectPath: state.projectPath,
                });
            });
        },
        async handleSiblingDrop(obj) {
            if (!obj?.ProjectID)
                return;
            if (obj.ProjectID == this.parent_id) {
                const text = this.sameProjectCallText(obj);
                if (text)
                    this.$refs.codeEditor?.insertTextAtCursor?.(text);
                return;
            }
            const classFullName = obj.ClassFullName || `User.${obj.ProjectName}.Default${obj.ProjectName}`;
            let alias = this.aliasForClass(classFullName, obj.ProjectID);
            if (!alias) {
                const suggested = this.suggestSiblingAlias(obj.ProjectName);
                alias = suggested;
                if (!alias) {
                    this.openImportAsDialog(obj);
                    return;
                }
                this.sendSiblingEvent('ImportSiblingAs', {
                    Alias: alias,
                    ProjectId: obj.ProjectID,
                    ClassFullName: classFullName,
                    ProjectName: obj.ProjectName,
                });
            }
            const text = `${alias}.${obj.Name}`;
            this.$refs.codeEditor?.insertTextAtCursor?.(text);
        },
        sameProjectCallText(obj) {
            const name = obj?.Name;
            if (!name)
                return '';
            const projectName = obj.ProjectName || '';
            const classId = obj.ClassID || obj.ProjectID;
            const openClassId = this.class_id || this.parent_id;
            if (classId && openClassId && classId == openClassId)
                return name;
            const defaultClassName = projectName ? `Default${projectName}` : '';
            const isDefault = !obj.ClassID || obj.ClassID == obj.ProjectID || obj.ClassName == defaultClassName;
            if (isDefault)
                return `Default.${name}`;
            return obj.ClassName ? `${obj.ClassName}.${name}` : name;
        },
        sameClassMethodNames() {
            const rows = this.$refs.folderGrid?.folderData || [];
            const project = rows.find(r => r.Type == 'Project' && r.ID == this.parent_id);
            if (!project)
                return [];
            const projectPath = project.Path ? `${project.Path}/${project.Name}` : project.Name;
            const onDefault = !this.class_id || this.class_id == this.parent_id;
            let methodPath = projectPath;
            if (!onDefault) {
                const cls = rows.find(r => r.Type == 'Class' && r.ID == this.class_id);
                if (!cls)
                    return [];
                methodPath = cls.Path ? `${cls.Path}/${cls.Name}` : cls.Name;
            }
            return rows
                .filter(r => (r.Type == 'APIHeader' || r.Type == 'FlowHeader')
                    && r.Path == methodPath
                    && r.ID != this.FlowID
                    && r.Name)
                .map(r => r.Name);
        },
        removeSiblingAlias(row, alias) {
            if (isProtectedImportAlias(row, alias))
                return;
            this.sendSiblingEvent('RemoveSiblingAlias', { Alias: alias.Alias, ProjectId: row.ProjectId });
        },
        removeExplicitSibling(row) {
            if (row.Source == 'Canvas')
                return;
            this.sendSiblingEvent('RemoveExplicitSibling', { ProjectId: row.ProjectId });
        },
        siblingProjectFromDrop(obj) {
            if (!obj)
                return null;
            const projectId = obj.Type == 'Project' ? (obj.ID || obj.ProjectID) : obj.ProjectID;
            if (!projectId || projectId == this.parent_id)
                return null;
            const projectName = obj.Type == 'Project' ? (obj.Name || obj.ProjectName || '') : (obj.ProjectName || '');
            const className = obj.ClassName || (projectName ? `Default${projectName}` : '');
            return {
                ProjectId: projectId,
                ProjectName: projectName,
                ProjectPath: obj.Path || obj.ProjectPath || '',
                ClassName: className,
                ClassFullName: obj.ClassFullName || (projectName && className ? `User.${projectName}.${className}` : ''),
            };
        },
        addSiblingProject(info, { bindDefaultAlias = false } = {}) {
            if (!info?.ProjectId)
                return;
            if (!(this.siblingRows || []).some(r => r.ProjectId == info.ProjectId)) {
                this.sendSiblingEvent('AddExplicitSibling', {
                    ProjectId: info.ProjectId,
                    ProjectName: info.ProjectName,
                    ProjectPath: info.ProjectPath,
                });
            }
            if (!bindDefaultAlias || !info.ClassFullName)
                return;
            if (this.aliasForClass(info.ClassFullName, info.ProjectId))
                return;
            const alias = this.suggestSiblingAlias(info.ProjectName);
            if (!alias)
                return;
            this.sendSiblingEvent('ImportSiblingAs', {
                Alias: alias,
                ProjectId: info.ProjectId,
                ClassFullName: info.ClassFullName,
                ProjectName: info.ProjectName,
                ProjectPath: info.ProjectPath,
            });
        },
        handleImportPanelDrop(obj) {
            const info = this.siblingProjectFromDrop(obj);
            if (!info)
                return;
            this.addSiblingProject(info, { bindDefaultAlias: true });
        },
        addExplicitSibling(project) {
            if (!project?.ID && !project?.ProjectId)
                return;
            this.addSiblingProject({
                ProjectId: project.ID || project.ProjectId,
                ProjectName: project.Name || project.ProjectName,
                ProjectPath: project.Path || project.ProjectPath || '',
            });
        },

        ///------------ UI ------------///

        getFlowEditor() {
            return (
                <div
                    v-show={this.ItemType == 'FlowHeader'}
                    ref="flowEditorHost"
                    class="c-FlowV2-flow-editor-host"
                    style={{
                        flexGrow: 1,
                        height: '1px',
                        minHeight: 0,
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    {this.flowFindOpen ? (
                        <div
                            class="c-FlowV2-find-widget"
                            style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                zIndex: 1100,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '4px 6px',
                                backgroundColor: '#f3f3f3',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                minWidth: '280px',
                            }}
                            onKeydown={(ev) => ev.stopPropagation()}
                        >
                            <QInput
                                ref="flowFindInput"
                                dense
                                outlined
                                placeholder="Find"
                                modelValue={this.flowFindQuery}
                                onUpdate:modelValue={(v) => {
                                    this.flowFindQuery = v;
                                    this.flowFindDebouncedRecompute?.();
                                }}
                                onKeydown={this.flowFindInputKeydown}
                                style={{ flex: '1 1 auto', minWidth: '120px' }}
                                inputStyle={{ fontSize: '13px' }}
                            />
                            <QBtn
                                flat
                                dense
                                size="sm"
                                padding="xs"
                                color={this.flowFindCaseSensitive ? 'primary' : 'grey-7'}
                                title="Match Case"
                                onClick={() => {
                                    this.flowFindCaseSensitive = !this.flowFindCaseSensitive;
                                    this.recomputeFlowFindMatches();
                                }}
                            >
                                <span style={{ fontSize: '11px', fontWeight: 600 }}>Aa</span>
                            </QBtn>
                            <span style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap', minWidth: '72px', textAlign: 'center' }}>
                                {this.getFlowFindStatusText()}
                            </span>
                            <QBtn flat dense round size="sm" icon="mdi-chevron-up" title="Previous match" onClick={() => this.flowFindPrevious()} />
                            <QBtn flat dense round size="sm" icon="mdi-chevron-down" title="Next match" onClick={() => this.flowFindNext()} />
                            <QBtn flat dense round size="sm" icon="mdi-close" title="Close" onClick={() => this.closeFlowFind()} />
                        </div>
                    ) : null}
                    <div
                        class="c-FlowV2-scroll-container"
                        ref="scrollContainer"
                        style={{
                            flex: '1 1 0',
                            minHeight: 0,
                            overflow: 'auto',
                            position: 'relative',
                        }}
                    >
                        {this.getFlowEditorInputBox()}
                        <div
                            ref="paperDiv"
                            onDragover={this.onCanvasDragOver}
                            onDragleave={this.onCanvasDragLeave}
                            onDrop={this.onCanvasDrop}>
                        </div>
                        {this.canvasRejectProjectDrop ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    zIndex: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                    background: 'rgba(255,255,255,0.72)',
                                    color: '#c62828',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    textAlign: 'center',
                                    padding: '16px',
                                }}
                            >
                                Projects cannot be dropped on the flowchart. Drop them on the Imports tab.
                            </div>
                        ) : null}
                    </div>
                </div>
            );
        },
        getFlowEditorInputBox() {
            return [
                <input
                    ref="input"
                    v-show={this.showInput}
                    class="label-input c-FlowV2-Link-Input"
                    style={{
                        minWidth: '30px',
                        position: 'absolute',
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        borderRadius: '8px',
                        textAlign: 'center',
                        left: this.inputPosition.left || '550px',
                        top: this.inputPosition.top || '300px',
                        transform: 'translate(-50%,-50%)',
                        zIndex: 1000
                    }}
                    value={this.inputValue}
                    onInput={(e) => this.inputBoxInput(e)}
                    onKeyup={this.onInputKeyup}
                    onBlur={() => this.inputLostFocus()}
                    onFocus={(e) => e.target.select()}
                >
                </input>,
                <span ref="inputMirror" style="position: absolute; left: -9999px; white-space: pre; font: inherit; padding: 8px 12px; visibility: hidden; "></span>,
                <span
                    ref="inputChoicesAnchor"
                    v-show={this.showInputChoices}
                    id={this.inputChoicesAnchorId}
                    style={{
                        position: 'absolute',
                        left: this.inputPosition.left || '550px',
                        top: this.inputPosition.top || '300px',
                        transform: 'translate(-50%,-50%)',
                        width: '1px',
                        height: '1px',
                        pointerEvents: 'none',
                        zIndex: 1000
                    }}
                >
                </span>,
                <QMenu
                    modelValue={this.showInputChoices && this.inputChoicesVisible}
                    onUpdate:modelValue={(v) => this.inputChoicesVisible = v}
                    target={`#${this.inputChoicesAnchorId}`}
                    noParentEvent={true}
                    anchor="center middle"
                    self="center middle"
                >
                    <QList dense style="min-width: 150px;">
                        {this.choices.map(c =>
                            <QItem key={c.value} clickable v-ripple onClick={() => { this.inputValue = c.value; this.inputChoicesVisible = false; this.updateLabel(); }}>
                                <QItemSection><QItemLabel>{c.title}</QItemLabel></QItemSection>
                            </QItem>
                        )}
                    </QList>
                </QMenu>
            ];
        },
        getAPIEditor() {
            if (this.ItemType == 'APIHeader')
                return (
                    <CodeEditorMonaco
                        ref="codeEditor"
                        collaborate={true}
                        FlowID={this.FlowID}
                        debugMode={this.debugMode}
                        debugSession={this.debugSession}
                        readOnly={this.editorReadOnly}
                        breakpointsEnabled={this.canToggleDebugBreakpoints()}
                        detected_locals={this.detected_locals}
                        detected_lines={this.detected_lines}
                        aliases={this.siblingAliasItems}
                        sameClassMethods={this.sameClassMethodNames()}
                        wordWrap={false}
                        onShifttab={this.shiftTab}
                        onSaveBreakpoints={this.persistAllBreakpoints}
                        onSync={this.syncFlowChanges}
                        onSiblingDrop={this.handleSiblingDrop}
                    >
                    </CodeEditorMonaco>
                );
            else
                return null;
        },

        ///---------------------------///

        /** Read-only Variables rows: media (when the channel has it), globals, then method parameters. */
        lockedSignatureRows() {
            const params = (this.parameters || [])
                .filter(p => p && p.Name != null && String(p.Name).trim())
                .map(p => ({
                    Name: String(p.Name).trim(),
                    Type: p.Type,
                    Persistent: false,
                    kind: 'parameter',
                    locked: true,
                }));
            return implicitPanelVariables(this.channelConfig).concat(params);
        },

        shiftTab(editor) {
            if (this.tabs.length > 1) {
                let idx = this.tabs.findIndex(t => t.value == this.selected_tab);
                if (idx >= 0) {
                    idx = (idx + 1) % this.tabs.length;

                    this.changeSelectedTab(this.tabs[idx].value);
                    this.$nextTick(() => {
                        if (this.flow_type == 'APIHeader')
                            this.$refs.codeEditor?.focus();
                            //this.$refs.aceEditor.editor.focus();
                        else if (this.flow_type == 'FlowHeader')
                            this.paper.el.focus();
                        //editor.focus()
                    });
                }
            }
        },

        autoAddVariable(argname, argvalue) {
            // This adds a variable named by the parameter, but detects the type
            // by reading the current model. It then adds to the variables list
            // and notifies the server.
            const toolArg = this.tool.Arguments.find(a => a.Name == argname);

            if (toolArg || argname == 'ReturnVar') {
                const type = (argname == 'ReturnVar' ? this.tool.ReturnType : toolArg.ArgType) ?? 'string';
                // Add a variable named argvalue
                const v = {
                    Name: argvalue,
                    Type: type,
                    Persistent: false,
                };
                this.variables.push(v);
                this.addVariable(v); // sync with server
            }
        },
        addVariable(v) {
            // The Variables grid drops the row immediately. Keep the same array
            // the use-variable menu reads, and collapse a create plus its echo.
            upsertVariableByName(this.variables, v);
            this.syncFlowChanges({
                EventType: 'AddLocal',
                Data: {
                    FlowID: this.FlowID,
                    Content: v
                }
            }, true);
        },
        removeVariable(v) {
            removeVariablesByName(this.variables, v?.Name);
            this.syncFlowChanges({
                EventType: 'RemoveLocal',
                Data: {
                    FlowID: this.FlowID,
                    Content: v
                }
            }, true);
        },
        updateVariable(v) {
            upsertVariableByName(this.variables, v);
            this.syncFlowChanges({
                EventType: 'UpdateLocal',
                Data: {
                    FlowID: this.FlowID,
                    Content: v
                }
            }, true);
        },

        openTextAreaDialog(title, saveFunc, initialValue) {
            let value = initialValue ?? '';
            this.$refs.genericDialog.showDialog(title, 1000, (dlg) =>
                <CodeEditorMonaco
                    minHeight={150}
                    collaborate={false}
                    FlowID={this.FlowID}
                    initialContent={value}
                    wordWrap={true}
                    detected_locals={this.variables}
                    onChange={(v) => value = v}
                >
                </CodeEditorMonaco>
                , () => saveFunc(value));
        },

        updateRouter(value) {
            const router = this.normalizeLinkRouter(value);
            this.applyLinkRouter(router);
            this.saveLastPickedRouter(router);
            this.persistFlowRouter(router);
        },
        isKnownLinkRouter(value) {
            return LINK_ROUTER_NAMES.includes(value);
        },
        normalizeLinkRouter(value) {
            return this.isKnownLinkRouter(value) ? value : DEFAULT_LINK_ROUTER;
        },
        getLastPickedRouter() {
            return this.normalizeLinkRouter(this.System.LocalStorage(LAST_PICKED_ROUTER_KEY));
        },
        saveLastPickedRouter(value) {
            const router = this.normalizeLinkRouter(value);
            this.System.LocalStorage(LAST_PICKED_ROUTER_KEY, router);
        },
        applyLinkRouter(value) {
            const router = this.normalizeLinkRouter(value);
            this.connectorStyle = router;
            if (this.paper?.options) {
                this.paper.options.defaultRouter = {
                    name: router,
                    args: { ...LINK_ROUTER_ARGS },
                };
            }
            const links = this.graph?.getLinks?.() || [];
            links.forEach(link => link.router(router, { ...LINK_ROUTER_ARGS }));
        },
        persistFlowRouter(value) {
            if (!this.FlowID)
                return;
            const router = this.normalizeLinkRouter(value);
            this.syncFlowChanges({
                EventType: 'UpdateRouter',
                Data: {
                    FlowID: this.FlowID,
                    Content: { Router: router },
                },
            }, true);
        },

        saveFlowSetting(key, value) {
            const localStorageKey = `${this.storageKey}-${this.FlowID}-${key}`;
            this.System.LocalStorage(localStorageKey, JSON.stringify(value));
        },
        getFlowSetting(key, defaultModel) {
            const localStorageKey = `${this.storageKey}-${this.FlowID}-${key}`;
            let settingsRaw = this.System.LocalStorage(localStorageKey);
            if (settingsRaw) {
                if (typeof settingsRaw === 'string' && (settingsRaw.startsWith('{') || settingsRaw.startsWith('[')))
                    return JSON.parse(settingsRaw);
                else
                    return settingsRaw;
            }
            else if (typeof defaultModel === 'function')
                return defaultModel();
            else
                return defaultModel;
        },

        /** Server Message / LogItem / local errors → scrollable message log (mute filters apply at ingest). */
        pushEditorMessage(text, color = 'info') {
            const result = appendFlowMessage(this.messages, { text, color }, this.messageLogPrefs);
            this.messages = result.messages;
            if (result.muted)
                this.messageLogMutedCount++;
        },
        onMessageLogPrefs(prefs) {
            this.messageLogPrefs = normalizeMessageLogPrefs(prefs);
            common.saveGlobalSetting.call(this, MESSAGE_LOG_SETTING_KEY, this.messageLogPrefs);
        },
        dismissEditorMessage(id) {
            this.messages = this.messages.filter(m => m.id !== id);
        },
        clearEditorMessages() {
            this.messages = [];
            this.messageLogMutedCount = 0;
        },
        clearVisibleEditorMessages(ids) {
            if (!ids?.length)
                return;
            const drop = new Set(ids);
            this.messages = this.messages.filter(m => !drop.has(m.id));
        },

        canvasViewSessionKey(flowId) {
            return `${CANVAS_VIEW_SESSION_PREFIX}${flowId}`;
        },
        focusFlowEditor() {
            this.$nextTick(() => {
                if (this.ItemType === 'APIHeader') {
                    this.$refs.codeEditor?.focus?.();
                    return;
                }
                if (this.ItemType === 'FlowHeader')
                    this.$refs.paperDiv?.focus?.();
            });
        },
        getCanvasSelectedIds() {
            if (this.selectedCells?.length)
                return this.selectedCells.map(c => c.id).filter(Boolean);
            if (this.selected?.model?.id)
                return [this.selected.model.id];
            return [];
        },
        scheduleSaveCanvasViewState() {
            if (this._suppressCanvasViewSave || this._restoringCanvasView)
                return;
            if (this.ItemType !== 'FlowHeader' || !this.FlowID)
                return;
            this.debouncedSaveCanvasViewState?.();
        },
        saveCanvasViewState(flowId = this.FlowID) {
            if (!flowId || typeof sessionStorage === 'undefined')
                return;
            try {
                const container = this.$refs.scrollContainer;
                const state = {
                    scale: typeof this.scale === 'number' ? this.scale : 1,
                    scrollLeft: container?.scrollLeft ?? 0,
                    scrollTop: container?.scrollTop ?? 0,
                    selectedIds: this.getCanvasSelectedIds(),
                };
                sessionStorage.setItem(this.canvasViewSessionKey(flowId), JSON.stringify(state));
            }
            catch (err) {
                console.warn('FlowV2 saveCanvasViewState failed:', err);
            }
        },
        clearCanvasSelectionUi() {
            this.clearSelected();
            this.selectedCells = [];
            if (this.graph)
                this.updateHighlights();
            this.iconOverlayVisible = false;
            this.iconOverlayCellView = null;
            this.iconOverlayPlacement = 'right';
        },
        async restoreCanvasSelection(selectedIds) {
            const ids = Array.isArray(selectedIds) ? selectedIds.filter(Boolean) : [];
            if (!ids.length || !this.graph || !this.paper)
                return;

            const cells = ids
                .map(id => this.graph.getCell(id))
                .filter(c => c && c.isElement && c.isElement());

            if (!cells.length)
                return;

            if (cells.length > 1) {
                this.selectedCells = cells;
                this.updateHighlights();
                if (this.batchEditingEnabled())
                    await this.applyCanvasMultiSelection();
                return;
            }

            const view = this.paper.findViewByModel(cells[0]);
            if (view)
                await this.selectCellView(view);
        },
        async restoreCanvasViewState(flowId = this.FlowID) {
            if (!flowId)
                return;

            this._restoringCanvasView = true;
            try {
                let state = null;
                try {
                    const raw = typeof sessionStorage !== 'undefined'
                        ? sessionStorage.getItem(this.canvasViewSessionKey(flowId))
                        : null;
                    if (raw)
                        state = JSON.parse(raw);
                }
                catch {
                    state = null;
                }

                let scale = 1;
                if (state?.scale != null) {
                    const n = Number(state.scale);
                    if (Number.isFinite(n))
                        scale = Math.min(3, Math.max(0.2, n));
                }
                this.scale = scale;
                if (this.paper)
                    this.paper.scale(scale, scale);

                await this.$nextTick();
                await new Promise(resolve => requestAnimationFrame(resolve));

                const container = this.$refs.scrollContainer;
                if (container) {
                    container.scrollLeft = Number(state?.scrollLeft) || 0;
                    container.scrollTop = Number(state?.scrollTop) || 0;
                }

                if (this.iconOverlayVisible)
                    this.updateIconOverlayPosition();

                await this.restoreCanvasSelection(state?.selectedIds);
            }
            finally {
                this._restoringCanvasView = false;
            }
        },

        onServerEventRecieved(eventData) {
            console.log(`onServerEventRecieved: ${JSON.stringify(eventData)}`);

            switch (eventData.EventName) {
                case 'CallAnswered':
                    break;
                case 'CallRejected':
                    break;
                case 'UserHangup':
                    break;
                case 'WebSocketDisconnected':
                    break;
                case 'InboundAnswered':
                    if (eventData.SessionId == this.WebRtcSessionId) {
                        // This is our web rtc leg that we started below. Proceed with the debug session
                        //this.debugStartWebRtc(true);
                        if (this.WebRtcConnectedFunc)
                            this.WebRtcConnectedFunc();

                        this.WebRtcConnectedFunc = null;
                    }
                    break;
                case 'CallDisconnect':
                    if (eventData.SessionId == this.WebRtcSessionId) {
                        // The flow hung up this debug leg. Stop is cleanup; the thread may already be gone.
                        console.log(`Hanging up WebRtcPhone call`);

                        const sessionId = this.WebRtcSessionId;
                        if (this.WebRtcPhone)
                            this.WebRtcPhone.Hangup();
                        this.WebRtcSessionId = null;

                        if (this.debugMode != 'stopped')
                            this.debugStop({ quiet: true });

                        eventCoordinator.unsubscribeForSessionEvents(sessionId, this.id, '');
                    }
                    break;
            }
        },
        async debugPhoneKeypress(key) {
            if (this.WebRtcPhone) {
                this.WebRtcPhone.sendDtmf(key);
            }
        },

        webrtcLegIsLive() {
            const state = this.WebRtcPhone?.state;
            return !!this.WebRtcSessionId
                || state === 'connecting'
                || state === 'connected'
                || state === 'calling'
                || state === 'accepted';
        },
        /** Hangup is a no-op until a SIP invite exists. Tear down the socket too. */
        abandonWebRtcPhone() {
            const phone = this.WebRtcPhone;
            if (!phone)
                return;
            phone.ignoreConnectionError = true;
            try { phone.invalidateSocketSession(); } catch (err) { console.warn('WebRTC invalidate failed', err); }
            try { phone.Abort(); } catch (err) { console.warn('WebRTC abort failed', err); }
            try { phone.Hangup(); } catch (err) { console.warn('WebRTC hangup failed', err); }
            try { phone.DisconnectWebSocket(); } catch (err) { console.warn('WebRTC disconnect failed', err); }
            const stamp = phone.socketGeneration;
            const settle = () => {
                if (!phone.ignoreConnectionError || phone.socketGeneration !== stamp)
                    return;
                phone.state = 'disconnected';
            };
            settle();
            queueMicrotask(settle);
            setTimeout(settle, 0);
        },
        webrtcSetupFailed() {
            const state = this.WebRtcPhone?.state;
            return state === 'failed' || state === 'error' || state === 'missing_mic';
        },
        /** Drop a softphone leg started for this debug launch. */
        releaseWebRtcLeg() {
            this.mediaSetupGeneration++;
            this.WebRtcConnectedFunc = null;
            const sessionId = this.WebRtcSessionId;
            const hangup = this.webrtcLegIsLive();
            this.WebRtcSessionId = null;
            if (sessionId)
                eventCoordinator.unsubscribeForSessionEvents(sessionId, this.id, '');
            if (hangup || this.debugLaunching)
                this.abandonWebRtcPhone();
        },
        /** Return the toolbar to idle after a failed or cancelled launch. */
        failDebugLaunch() {
            this.debugLaunchToken++;
            this._ephemeralBreakpoint = null;
            this.debugLaunching = false;
            if (this.debugMode !== 'running' && this.debugMode !== 'paused')
                this.debugMode = 'stopped';
            this.releaseDebugOwnership();
            this.syncEditorReadOnly();
            this.releaseWebRtcLeg();
        },
        /**
         * Trace started clears debugLaunching before StartDebugging's HTTP call returns.
         * That is success. Only a token bump (Stop / failed setup) means the new session should be stopped.
         */
        async stopSessionIfLaunchCancelled(launchToken, res) {
            if (launchToken === this.debugLaunchToken)
                return false;
            if (res && !String(res).startsWith('ERROR:')) {
                try {
                    await utils.api.request('DELETE', `Apps/Debug/StopDebugging/${res}`);
                }
                catch (err) {
                    console.warn('Failed to stop a debug session cancelled during launch', err);
                }
            }
            return true;
        },
        noteDebugSessionStarted(res) {
            this.debugSession = res;
            if (this.debugMode !== 'running' && this.debugMode !== 'paused')
                this.debugMode = 'starting';
        },

        async debugSetupWebRtc() {
            const generation = this.mediaSetupGeneration;
            const stale = () => generation !== this.mediaSetupGeneration;

            this.WebRtcPhone = this.Control.flowSoftPhone; // this.Root.ChildControlByName('WebRtcPhone');
            if (!this.WebRtcPhone) {
                alert('WebRtcPhone not found');
                this.failDebugLaunch();
                return;
            }

            const newguid = await utils.api.get(`Apps/Data/NewGuid`);
            if (stale()) {
                this.abandonWebRtcPhone();
                return;
            }

            this.WebRtcSessionId = `${newguid}@WebRTC`; // Generate new session Id for web rtc call
            eventCoordinator.subscribeForSessionEvents(this.WebRtcSessionId, this.id, '', this.onServerEventRecieved);
            if (stale()) {
                this.releaseWebRtcLeg();
                return;
            }

            //debugger;
            if (this.WebRtcPhone.state != 'accepted') {
                // Setup the web socket for WebRtc
                let resolve;
                const promise = new Promise((res, rej) => { resolve = res; });
                const action = { ActionData: {}, FinishFunc: (success) => { resolve() } };
                await this.WebRtcPhone.performWebRTCConnectWebSocket(action);
                await promise;
                if (stale()) {
                    this.abandonWebRtcPhone();
                    return;
                }
                if (this.webrtcSetupFailed()) {
                    alert('Softphone setup failed');
                    this.failDebugLaunch();
                    return;
                }
            }

            await this.WebRtcPhone.call(this.WebRtcSessionId);
            if (stale()) {
                this.abandonWebRtcPhone();
                return;
            }
            if (this.webrtcSetupFailed()) {
                alert('Softphone setup failed');
                this.failDebugLaunch();
            }
            // Now we should get an event via onServerEventReceived of InboundAnswered
        },
        async debugStartWebRtc(stepping) {
            const generation = this.mediaSetupGeneration;
            const stale = () => generation !== this.mediaSetupGeneration;
            try {
            // Get the startup arguments as a JSON model ({ key1: value1, ... })
            let debugArgs = this.getFlowSetting('startup');

            if (!debugArgs) {
                const schema = await this.getDebugSettingsSchema();
                debugArgs = utils.schema.getDefaultModel(schema);
            }
            if (stale())
                return;

            mapCache.debugMap = {};

            // Get the debug map
            const flowMap = await utils.api.get(`Apps/FlowV2/GetDebugMapFromID?ID=${this.FlowID}`);
            if (stale())
                return;
            if (!flowMap || !flowMap.MethodID) {
                alert('Debug map is not found. Ensure you have made a change in the project within the last 30 days.');
                this.failDebugLaunch();
                return;
            }
            cacheDebugMap(flowMap, this.FlowID);

            const entryRef = this.channelConfig?.FlowDebugProjectRef;
            const entryClass = this.channelConfig?.FlowDebugClass;
            const entryMethod = this.channelConfig?.FlowDebugMethod || 'StartDebugging';

            const startupParams = { ...(debugArgs || {}) };
            delete startupParams.media;
            delete startupParams.enableMedia;
            const flowV2 = {
                FlowID: this.FlowID,
                media: debugArgs?.media ?? {},
                ...startupParams,
            };

            if (entryRef && entryClass) {
                await this.debugStartViaEntryProject(stepping, debugArgs, flowMap, {
                    ProjectName: entryRef,
                    ClassName: entryClass,
                    MethodName: entryMethod,
                    Args: [
                        this.WebRtcSessionId,
                        {
                            ProjectReference: {
                                DataModel: {
                                    FlowV2: flowV2,
                                },
                            },
                        },
                        '{$Current}',
                    ],
                });
                return;
            }

            // Legacy Call fallback when Channel FlowDebug* not yet populated
            await this.debugStartViaEntryProject(stepping, debugArgs, flowMap, {
                ProjectName: '$IVRInboundHandler.prj',
                ClassName: 'Platform.FlowV2Handler',
                MethodName: 'StartDebugging',
                Args: [
                    this.WebRtcSessionId,
                    {
                        ProjectReference: {
                            DataModel: {
                                FlowV2: flowV2,
                            },
                        },
                    },
                    '{$Current}',
                ],
            });
            }
            catch (err) {
                alert('Failed to start: ' + (err?.message || err));
                this.failDebugLaunch();
            }
        },
        /**
         * Start debugging through a channel entry project (typed media + BranchToProject).
         * Breakpoints still target the user flow's debug map.
         */
        async debugStartViaEntryProject(stepping, debugArgs, flowMap, entry) {
            const { points, stepping: effectiveStepping } = this.prepareDebugStartPoints(flowMap, stepping);
            const settings = {
                ProjectName: flowMap.ContainerFullName,
                Methods: [{
                    ClassName: flowMap.ClassName,
                    MethodName: flowMap.MethodName,
                    Points: points,
                }],
                StepSystemCode: false,
            };
            const info = this.stampDebugInfo({
                ProjectName: entry.ProjectName,
                ClassName: entry.ClassName,
                MethodName: entry.MethodName,
                Args: entry.Args,
                Settings: settings,
                Stepping: effectiveStepping,
            });

            if (!this.debugLaunching)
                return;

            const channel = this.System.careTokenService.GetChannelName();
            const launchToken = this.debugLaunchToken;

            const res = await utils.api.request('POST', `Apps/Debug/StartDebugging/${channel}`, info);
            if (await this.stopSessionIfLaunchCancelled(launchToken, res))
                return;
            if (!res || String(res).startsWith('ERROR:')) {
                alert(`Failed to start: ${res}`);
                this.failDebugLaunch();
                return;
            }
            this.noteDebugSessionStarted(res);
        },
        findStartToolElement() {
            if (!this.graph)
                return null;
            const cells = this.graph.getCells?.() || [];
            return cells.find(c => c.attributes?.prop?.ToolID === START_TOOL_ID) || null;
        },
        /**
         * First executable API statement from Validation / Monaco detected_lines.
         * Never invents line 0 — empty metadata means unknown (use Stepping instead).
         */
        resolveFirstApiStatementLine() {
            return firstApiStatementFromDetected(this.detected_lines, this.$refs.codeEditor?.detected_lines);
        },
        /**
         * Behind-the-scenes first-pause BP for Step Over/Into from stopped.
         * FlowHeader → Start icon; APIHeader → first statement line. No UI/persist.
         */
        armEphemeralFirstPauseBreakpoint(flowMap) {
            this._ephemeralBreakpoint = null;
            const existing = this.getAllBreakpoints();

            if (this.ItemType === 'FlowHeader') {
                const start = this.findStartToolElement();
                const instanceId = start?.attributes?.prop?.InstanceID;
                if (!instanceId || !flowMap?.ItemMap)
                    return;
                if (existing.some(b => b.ID === instanceId))
                    return;
                const numericId = flowMap.ItemMap[instanceId];
                if (numericId == null || numericId < 0)
                    return;
                this._ephemeralBreakpoint = { kind: 'id', instanceId, numericId };
                return;
            }

            if (this.ItemType === 'APIHeader') {
                const first = this.resolveFirstApiStatementLine();
                if (!first)
                    return;
                const { line, column } = first;
                if (existing.some(b => 'Line' in b && b.Line === line && (b.Column ?? 0) === column))
                    return;
                this._ephemeralBreakpoint = { kind: 'line', line, column };
            }
        },
        buildDebugPoints(flowMap) {
            const points = this.getAllBreakpoints().map(i => 'Line' in i ? ({
                ByLine: true,
                Line: i.Line,
                Column: i.Column ?? 0,
                Trace: false,
                Break: 1,
            }) : ({
                ByLine: false,
                ID: flowMap.ItemMap[i.ID] ?? -1,
                Trace: false,
                Break: 1,
            }));

            const eph = this._ephemeralBreakpoint;
            if (eph?.kind === 'id') {
                if (!points.some(p => !p.ByLine && p.ID === eph.numericId))
                    points.push({ ByLine: false, ID: eph.numericId, Trace: false, Break: 1 });
            }
            else if (eph?.kind === 'line') {
                if (!points.some(p => p.ByLine && p.Line === eph.line && (p.Column ?? 0) === eph.column))
                    points.push({ ByLine: true, Line: eph.line, Column: eph.column, Trace: false, Break: 1 });
            }
            return points;
        },
        /** True when the user already has a BP at the first-pause location (Start / first line). */
        userHasFirstPauseBreakpoint(flowMap) {
            const existing = this.getAllBreakpoints();
            if (this.ItemType === 'FlowHeader') {
                const start = this.findStartToolElement();
                const instanceId = start?.attributes?.prop?.InstanceID;
                return !!(instanceId && existing.some(b => b.ID === instanceId));
            }
            if (this.ItemType === 'APIHeader') {
                const first = this.resolveFirstApiStatementLine();
                if (!first)
                    return false;
                return existing.some(b => 'Line' in b && b.Line === first.line && (b.Column ?? 0) === first.column);
            }
            return false;
        },
        /**
         * When stepping from stopped, arm ephemeral first-pause BP and use Stepping:false
         * only if that BP (or a matching user BP) is known to hit. Otherwise Stepping:true
         * so we pause on the first statement instead of free-running (e.g. into Menu12).
         */
        prepareDebugStartPoints(flowMap, stepping) {
            this._ephemeralBreakpoint = null;
            if (!stepping)
                return { points: this.buildDebugPoints(flowMap), stepping: false };

            this.armEphemeralFirstPauseBreakpoint(flowMap);
            const canPauseAtStart = !!this._ephemeralBreakpoint || this.userHasFirstPauseBreakpoint(flowMap);
            return {
                points: this.buildDebugPoints(flowMap),
                stepping: effectiveSteppingFromStopped({ stepping: true, canPauseAtStart }),
            };
        },
        async clearEphemeralBreakpoint() {
            const eph = this._ephemeralBreakpoint;
            this._ephemeralBreakpoint = null;
            if (!eph || !this.debugSession)
                return;
            try {
                if (eph.kind === 'id')
                    await utils.api.request('DELETE', `Apps/Debug/Breakpoint/${this.debugSession}/${eph.numericId}`);
                else if (eph.kind === 'line')
                    await utils.api.request('DELETE', `Apps/Debug/Breakpoint/${this.debugSession}/${eph.line}/${eph.column}`);
            }
            catch (err) {
                console.warn('Failed to clear ephemeral breakpoint', err);
            }
        },
        async refreshChannelConfig() {
            try {
                if (!this.FlowID || !this.ItemType) {
                    this.channelConfig = resolveChannel(CHANNEL_TYPE_CALL, this.channelList);
                    return;
                }
                const proj = await utils.api.get(`Apps/FlowV2/GetMethodProject?Type=${this.ItemType}&ID=${this.FlowID}`);
                const result = proj?.Result || proj;
                const ct = result?.ChannelType || CHANNEL_TYPE_CALL;
                this.channelConfig = resolveChannel(ct, this.channelList);
            }
            catch (e) {
                this.channelConfig = resolveChannel(CHANNEL_TYPE_CALL, this.channelList);
            }
        },
        debugGateState() {
            return {
                autoSaved: this.auto_saved,
                validationPending: this.validationPending,
                validationErrorCount: this.validationErrorCount,
                requiredCodeVersion: this.requiredCodeVersion,
                acceptNextValidation: this.acceptNextValidation,
                awaitingDirty: this.awaitingDirty,
                seenEditGeneration: this.seenEditGeneration,
                lastCodeVersion: this.lastCodeVersion,
                debugMode: this.debugMode,
                debugLaunching: this.debugLaunching,
                debugLocked: this.debugLocked,
                lockedProjectIds: this.lockedProjectIds,
                isDebugOwner: this.isDebugOwner,
                debugRole: this.debugRole,
            };
        },
        applyDebugGateState(state) {
            this.auto_saved = state.autoSaved;
            this.validationPending = state.validationPending;
            this.validationErrorCount = state.validationErrorCount;
            this.requiredCodeVersion = state.requiredCodeVersion;
            this.acceptNextValidation = state.acceptNextValidation;
            this.awaitingDirty = state.awaitingDirty;
            this.seenEditGeneration = state.seenEditGeneration;
            this.lastCodeVersion = state.lastCodeVersion;
            this.rememberDebugGate();
        },
        rememberDebugGate() {
            if (!this.flow_id)
                return;
            if (!this._debugGateByFlow)
                this._debugGateByFlow = Object.create(null);
            this._debugGateByFlow[this.flow_id] = debugGateSnapshot(this.debugGateState());
        },
        restoreOrResetDebugGate(flowId) {
            const reused = reusableDebugGate(this._debugGateByFlow?.[flowId]);
            if (reused)
                this.applyDebugGateState(reused);
            else
                this.applyMethodOpenedState();
        },
        applyMethodOpenedState() {
            const state = this.debugGateState();
            applyMethodOpened(state);
            this.applyDebugGateState(state);
            this.auto_save_error = '';
        },
        acceptNewEditorEpoch() {
            this.applyMethodOpenedState();
        },
        noteLocalEdit(data) {
            const state = this.debugGateState();
            applyLocalEdit(state, { codeChanged: CODE_CHANGING_EVENTS.has(data?.EventType) });
            this.applyDebugGateState(state);
        },
        noteIncomingEdit(data) {
            const type = data?.EventType;
            const flowId = data?.Data?.FlowID;
            if (flowId && this.FlowID && flowId != this.FlowID)
                return;
            if (!CODE_CHANGING_EVENTS.has(type) && type !== 'UpdateRouter')
                return;
            const state = this.debugGateState();
            const stamped = data?.Data?.CodeChanged;
            applyDirtyNotice(state, {
                editGeneration: data?.Data?.EditGeneration,
                codeVersion: data?.Data?.CodeVersion,
                codeChanged: stamped != null ? !!stamped : CODE_CHANGING_EVENTS.has(type),
                forceValidation: !!data?.Data?.ForceValidation,
            });
            this.applyDebugGateState(state);
        },
        applyDirtyFromServer(payload) {
            const state = this.debugGateState();
            applyDirtyNotice(state, {
                editGeneration: payload?.EditGeneration,
                codeVersion: payload?.CodeVersion,
                codeChanged: !!payload?.CodeChanged,
                forceValidation: !!payload?.ForceValidation,
            });
            this.applyDebugGateState(state);
        },
        syncEditorReadOnly() {
            this.editorReadOnly = editorShouldBeReadOnly(this.debugGateState());
        },
        projectIdsFromDebugMessage(data) {
            const raw = data?.Data?.ProjectIds;
            if (Array.isArray(raw) && raw.length)
                return raw.map(id => '' + id).filter(Boolean);
            const one = data?.Data?.ProjectID;
            return one ? ['' + one] : [];
        },
        openProjectIsDebugLocked() {
            const open = this.parent_id;
            if (!open)
                return false;
            return (this.lockedProjectIds || []).some(id => id == open);
        },
        /**
         * Step Into / Call Stack can land in a callee project outside the initial
         * DebugLock set. Expand the owner's lock set before switching tabs so
         * ownerViewingOutsideLock does not gray out Step/Resume.
         */
        ensureDebugLockIncludesProject(projectId) {
            if (!this.isDebugOwner || !projectId)
                return;
            const prev = this.lockedProjectIds || [];
            const next = expandLockedProjectIds(prev, projectId);
            if (next.length === prev.length)
                return;
            this.lockedProjectIds = next;
            this.syncDebugLockScope();
        },
        syncDebugLockScope() {
            const wasFollower = this.debugRole === 'follower';
            const state = this.debugGateState();
            applyDebugLockScope(state, {
                openProjectId: this.parent_id,
                projectIds: this.lockedProjectIds,
                isOwner: this.isDebugOwner,
            });
            this.debugLocked = state.debugLocked || !!this._lockOpenFlow;
            if (!this.debugLocked && wasFollower) {
                this.debugRole = '';
                this.unfollowDebugSession();
            }
            else if (this.debugLocked && this.isDebugOwner)
                this.debugRole = 'owner';
            else if (this.debugLocked && this.debugRole !== 'follower')
                this.debugRole = '';
            else if (!this.debugLocked && state.debugRole !== 'follower')
                this.debugRole = this.isDebugOwner && this.debugMode != 'stopped' ? 'owner' : state.debugRole;
            this.syncEditorReadOnly();
        },
        dropOpenProjectFromLockSet() {
            const open = this.parent_id;
            if (!open || !(this.lockedProjectIds || []).some(id => id == open))
                return;
            this.lockedProjectIds = this.lockedProjectIds.filter(id => id != open);
            if (!this.lockedProjectIds.length)
                this.lockedDebugSession = null;
            this.syncDebugLockScope();
        },
        debugTransportVisible() {
            if (this.isDebugOwner)
                return true;
            if (!this.debugLocked && this.debugMode != 'stopped' && (this.lockedProjectIds || []).length)
                return false;
            return true;
        },
        showDebugSessionPane() {
            if (this.debugMode == 'stopped')
                return false;
            return this.debugTransportVisible();
        },
        async applyRejectedServerDocument(document) {
            if (this.ItemType == 'APIHeader')
                await this.loadAPI(document);
            else
                await this.loadFlow(document);
            const state = this.debugGateState();
            applyRejectedEdit(state);
            this.applyDebugGateState(state);
            this.auto_save_error = '';
        },
        debugLockMatches(data) {
            const ids = this.projectIdsFromDebugMessage(data);
            if (ids.length && this.parent_id)
                return ids.some(id => id == this.parent_id);
            const projectId = data?.Data?.ProjectID;
            const flowId = data?.Data?.FlowID;
            if (projectId && this.parent_id)
                return projectId == this.parent_id;
            return !flowId || flowId == this.FlowID;
        },
        applyDebugLock(data) {
            const notice = mergeDebugLockNotice({
                openFlowId: this.FlowID,
                openProjectId: this.parent_id,
                flowId: data?.Data?.FlowID,
                projectIds: data?.Data?.ProjectIds ?? data?.Data?.ProjectID,
            });
            if (!notice.applies && !this.debugLockMatches(data))
                return;
            if (notice.projectIds.length)
                this.lockedProjectIds = notice.projectIds;
            const session = data?.Data?.DebugSession;
            if (session)
                this.lockedDebugSession = session;
            this._lockOpenFlow = !!notice.forOpenFlow && !this.parent_id;
            if (notice.applies || this.openProjectIsDebugLocked())
                this._debugLockSeen = true;
            this.syncDebugLockScope();
        },
        applyDebugUnlock(data) {
            const session = data?.Data?.DebugSession;
            if (session && this.lockedDebugSession && session != this.lockedDebugSession)
                return;
            const wasFollower = this.debugRole === 'follower';
            this.lockedProjectIds = [];
            this.lockedDebugSession = null;
            this.debugLocked = false;
            this._lockOpenFlow = false;
            this._debugLockSeen = false;
            this.isDebugOwner = false;
            this.debugRole = '';
            this.syncEditorReadOnly();
            if (wasFollower)
                this.clearFollowerHighlight();
        },
        claimDebugOwnership() {
            this.isDebugOwner = true;
            this.debugRole = 'owner';
        },
        releaseDebugOwnership() {
            this.isDebugOwner = false;
            if (this.debugRole === 'owner')
                this.debugRole = '';
        },
        canLaunchDebugSession() {
            return canLaunchNewDebugSession(this.debugGateState());
        },
        canDriveDebugSession() {
            return canDriveDebug(this.debugGateState());
        },
        canStepDebugSession() {
            return canResumeOrStep(this.debugGateState());
        },
        canPauseDebugSession() {
            return canPauseDebug(this.debugGateState());
        },
        canStopDebugSession() {
            return canStopDebug(this.debugGateState());
        },
        canToggleDebugBreakpoints() {
            return canToggleBreakpoints(this.debugGateState());
        },
        canFollowDebugSession() {
            return canFollowDebug(this.debugGateState());
        },
        debugStartTip() {
            return startButtonTip(this.debugGateState());
        },
        debugStepTip(label) {
            return stepButtonTip(this.debugGateState(), label);
        },
        debugLaunchBlockReason() {
            return launchBlockReason(this.debugGateState());
        },
        waitNextDisabled() {
            return !this.canLaunchDebugSession();
        },
        waitNextTip() {
            if (this.waitNextDisabled())
                return this.debugLaunchBlockReason() || 'Debugging in progress';
            return 'Wait For Next';
        },
        clearFollowerHighlight() {
            if (this.debugElement)
                this.togglePausedHighlight(this.debugElement, false);
            this.debugElement = null;
            this.debugMode = 'stopped';
            this.debugLaunching = false;
            this.syncEditorReadOnly();
            if (this.$refs.codeEditor)
                this.$refs.codeEditor.clearExecutionPoint();
        },
        async followDebugSession() {
            const session = this.lockedDebugSession;
            if (!session || !this.canFollowDebugSession())
                return;
            const channel = this.System.careTokenService.GetChannelName();
            const res = await utils.api.request('POST', `Apps/Debug/FollowDebugging/${session}/${encodeURIComponent(channel)}`);
            if (!res)
                return;
            this.debugRole = 'follower';
            this.debugSession = session;
            // Prefer HTTP snapshot over channel Break — QueueBind can race the
            // replayed Break so a follower joining on the first Step Over pause
            // would otherwise miss Monaco exec point / Locals hydrate.
            if (res && typeof res === 'object' && res.Value)
                await this.applyFollowDebugSnapshot(res);
        },
        async applyFollowDebugSnapshot(data) {
            if (!data || typeof data.Value !== 'string')
                return;
            if (data.DebugSession)
                this.debugSession = data.DebugSession;
            if (data.Value === 'Trace started') {
                this.debugMode = 'running';
                this.debugElement = null;
                this.debugStackIndex = 0;
                this.debugExecStackIndex = 0;
                this.syncEditorReadOnly();
                return;
            }
            if (data.Value.startsWith('Break|')) {
                const stack = data.Stack || [];
                const current = stack[0];
                await this.selectStack(current, { stack });
            }
        },
        async unfollowDebugSession() {
            const session = this.lockedDebugSession || this.debugSession;
            const channel = this.System.careTokenService.GetChannelName();
            if (session)
                await utils.api.request('DELETE', `Apps/Debug/UnfollowDebugging/${session}/${encodeURIComponent(channel)}`);
            this.debugRole = '';
            this.clearFollowerHighlight();
        },
        stampDebugInfo(info) {
            info.FlowProjectId = this.parent_id || '';
            info.FlowID = this.FlowID || '';
            return info;
        },
        async debugStart(stepping) {
            if (this.debugMode == 'paused') {
                if (!this.canDriveDebugSession())
                    return;
                try {
                    this.debugMode = 'running';

                    const res = await utils.api.get(`Apps/Debug/ResumeDebugging/${this.debugSession}`);

                    if (!res) {
                        alert('Failed to resume');
                        this.debugMode = 'stopped';
                    }
                }
                catch (err) {
                    alert('Failed to resume');
                    this.debugMode = 'stopped';
                }
            }
            else {
                if (!this.canLaunchDebugSession())
                    return;
                this.claimDebugOwnership();
                this.debugLaunching = true;
                this.syncEditorReadOnly();
                try {
                    await this.refreshChannelConfig();
                    if (!this.debugLaunching)
                        return;
                    let debugArgs = this.getFlowSetting('startup');

                    if (!debugArgs) {
                        const schema = await this.getDebugSettingsSchema();
                        debugArgs = utils.schema.getDefaultModel(schema);
                    }
                    if (!this.debugLaunching)
                        return;

                    const adapter = getDebugAdapter(this.channelConfig?.FlowDebugger);
                    await adapter.start({ editor: this, stepping, debugArgs });
                }
                catch (err) {
                    alert('Failed to start: ' + (err?.message || err));
                    this.failDebugLaunch();
                }
            }
        },
        /** Start debugging without establishing a media leg. */
        async debugStartWithoutMedia(stepping) {
            let debugArgs = this.getFlowSetting('startup');

            if (!debugArgs) {
                const schema = await this.getDebugSettingsSchema();
                debugArgs = utils.schema.getDefaultModel(schema);
            }

            const entryRef = this.channelConfig?.FlowDebugProjectRef;
            const entryClass = this.channelConfig?.FlowDebugClass;
            const entryMethod = this.channelConfig?.FlowDebugMethod || 'StartDebugging';

            // Email/SMS entry: envelope, datamodel, Context. The handler builds typed media and globals.
            // Call/WebRTC entry needs SessionId — only via debugStartWebRtc.
            const useEnvelopeEntry =
                entryRef && entryClass && this.channelConfig?.HasMedia
                && this.channelConfig?.FlowDebugger !== DEBUGGER_WEBRTC;

            if (useEnvelopeEntry) {
                mapCache.debugMap = {};
                const flowMap = await utils.api.get(`Apps/FlowV2/GetDebugMapFromID?ID=${this.FlowID}`);
                if (!flowMap) {
                    alert('Debug map is not found. Ensure you have made a change in the project within the last 30 days.');
                    this.failDebugLaunch();
                    return;
                }
                cacheDebugMap(flowMap, this.FlowID);

                const startupParams = { ...(debugArgs || {}) };
                delete startupParams.media;
                delete startupParams.enableMedia;

                await this.debugStartViaEntryProject(stepping, debugArgs, flowMap, {
                    ProjectName: entryRef,
                    ClassName: entryClass,
                    MethodName: entryMethod,
                    Args: [
                        debugArgs?.media ?? {},
                        {
                            ProjectReference: {
                                DataModel: {
                                    FlowV2: {
                                        FlowID: this.FlowID,
                                        ...startupParams,
                                    },
                                },
                            },
                        },
                        '{$Current}',
                    ],
                });
                return;
            }

            const globals = await utils.api.get(`Apps/Platform/Schema/Flow/Settings/GlobalVar/GetObject?ProjectID=${''}`);
            const model = await utils.api.get(`Apps/FlowV2/GetMethodHeader?Type=${this.ItemType}&ID=${this.FlowID}`);

            // Media channels without entry-envelope path: Call/WebRTC no-media uses null Voice arg;
            // schema-backed non-entry (legacy) uses saved startup.media; API-only has no slot.
            // globals is the next implicit slot (empty bag); it is not a user parameter.
            const debugParamsArray = [];
            if (this.channelConfig?.HasMedia) {
                if (this.channelConfig.FlowDebugger === DEBUGGER_WEBRTC)
                    debugParamsArray.push(null);
                else if (this.channelConfig.FlowDebugMediaSchema)
                    debugParamsArray.push(debugArgs.media ?? {});
                else
                    debugParamsArray.push(null);
            }
            debugParamsArray.push(globals ?? {});
            for (let item of model.Parameters) {
                debugParamsArray.push(this.coerceDebugStartupArg(item, debugArgs));
            }

            mapCache.debugMap = {};

            const flowMap = await utils.api.get(`Apps/FlowV2/GetDebugMapFromID?ID=${this.FlowID}`);
            if (!flowMap) {
                alert('Debug map is not found. Ensure you have made a change in the project within the last 30 days.');
                this.failDebugLaunch();
                return;
            }
            cacheDebugMap(flowMap, this.FlowID);

            const { points, stepping: effectiveStepping } = this.prepareDebugStartPoints(flowMap, stepping);
            const settings = {
                ProjectName: flowMap.ContainerFullName,
                Methods: [{
                    ClassName: flowMap.ClassName,
                    MethodName: flowMap.MethodName,
                    Points: points,
                }],
                StepSystemCode: false,
            };
            const info = this.stampDebugInfo({
                ProjectName: flowMap.ContainerFullName,
                ClassName: flowMap.ClassName,
                MethodName: flowMap.MethodName,
                Args: debugParamsArray,
                Settings: settings,
                Stepping: effectiveStepping,
            });
            if (!this.debugLaunching)
                return;

            const channel = this.System.careTokenService.GetChannelName();
            const launchToken = this.debugLaunchToken;

            const res = await utils.api.request('POST', `Apps/Debug/StartDebugging/${channel}`, info);
            if (await this.stopSessionIfLaunchCancelled(launchToken, res))
                return;
            if (!res || String(res).startsWith('ERROR:')) {
                alert(`Failed to start: ${res}`);
                this.failDebugLaunch();
                return;
            }
            this.noteDebugSessionStarted(res);
        },
        async debugStep(stepInto) {
            if (!this.canStepDebugSession())
                return;
            try {
                if (this.debugMode == 'stopped') {
                    this.debugStart(true);
                    return;
                }

                if (this.debugElement)
                    this.togglePausedHighlight(this.debugElement, false);
                this.debugElement = null;
                this.debugMode = 'running';

                const res = await utils.api.get(`Apps/Debug/StepDebugging/${this.debugSession}?stepInto=${stepInto}`);

                if (!res) {
                    alert('Failed to step');
                    this.debugMode = 'stopped';
                }
            }
            catch (err) {
                alert('Failed to step: ' + err.message);
                this.debugMode = 'stopped';
            }
        },
        async debugPause() {
            if (!this.canPauseDebugSession())
                return;
            if (this.debugMode == 'running') {
                try {
                    const res = await utils.api.get(`Apps/Debug/PauseDebugging/${this.debugSession}`);

                    if (!res) {
                        alert('Failed to pause');
                        this.debugMode = 'stopped';
                    }
                }
                catch (err) {
                    alert('Failed to pause');
                    this.debugMode = 'stopped';
                }
            }
        },
        async debugStop(options) {
            const quiet = !!(options && options.quiet);
            if (!this.canStopDebugSession())
                return;
            if (this._debugStopRequested)
                return;
            this._debugStopRequested = true;
            try {
                const sessionLive = this.debugMode == 'starting' || this.debugMode == 'running' || this.debugMode == 'paused';
                this.debugLaunchToken++;
                this.releaseWebRtcLeg();
                this.debugLaunching = false;
                if (!sessionLive) {
                    this.debugMode = 'stopped';
                    this.releaseDebugOwnership();
                    this.syncEditorReadOnly();
                    return;
                }

                // Apps/Debug/StopDebugging/{debugSessionId}
                const res = await utils.api.request('DELETE', `Apps/Debug/StopDebugging/${this.debugSession}`);

                if (!res)
                    this.finishDebugStopLocally(quiet, null);
            }
            catch (err) {
                this.finishDebugStopLocally(quiet, err);
            }
            finally {
                this._debugStopRequested = false;
            }
        },
        /** Local idle after StopDebugging missed a session the flow already finished. */
        finishDebugStopLocally(quiet, err) {
            const report = shouldReportDebugStopFailure({ quiet, debugMode: this.debugMode });
            if (report) {
                if (err)
                    alert('Failed to stop debug session: ' + formatDebugStopError(err));
                else
                    alert('Failed to stop debug session');
                this.debugMode = 'stopped';
                return;
            }
            if (err)
                console.warn('Debug session already ended', err);
            this.debugLaunching = false;
            this.debugMode = 'stopped';
            this._ephemeralBreakpoint = null;
            if (this.debugElement)
                this.togglePausedHighlight(this.debugElement, false);
            this.debugElement = null;
            if (this.$refs.codeEditor)
                this.$refs.codeEditor.clearExecutionPoint();
            this.lockedProjectIds = [];
            this.lockedDebugSession = null;
            this.debugLocked = false;
            this.releaseDebugOwnership();
            this.syncEditorReadOnly();
        },
        async debugWaitNext(debugValue) {
            const activating = debugValue === 0;
            if (activating && !this.canLaunchDebugSession())
                return;
            if (!activating && !this.canDriveDebugSession())
                return;
            mapCache.debugMap = {};

            // Get the debug map
            const flowMap = await utils.api.get(`Apps/FlowV2/GetDebugMapFromID?ID=${this.FlowID}`);
            if (!flowMap || Object.keys(flowMap).length < 1) {
                alert('Debug map is not found. Ensure you have made a change in the project within the last 30 days.');
                return;
            }
            cacheDebugMap(flowMap, this.FlowID);

            const channel = this.System.careTokenService.GetChannelName();
            const key = 'context';
            const value = `${flowMap.ContainerFullName};${flowMap.ClassName}.${flowMap.MethodName}`;

            // Index 0 is the value when selected, otherwise, it is undefined

            if (debugValue !== 0) {
                // Cancel
                const url = `Apps/Debug/Trace/${channel}/${key}?value=${encodeURIComponent(value)}`;
                const res2 = await utils.api.request('DELETE', url);
            }
            else if (debugValue === 0) {
                // Activate

                // Build the list of breakpoints from ... which projects do we consider? All??? we'll start with just the current
                // flow, the project should be considered, but we'll have to query to find the IDs of the other flows in this project
                // and that will come later...

                const list = this.getAllBreakpoints();

                // Transform the list of breakpoints specified in ID guids into ProjectContainer numeric Ids
                const methods = [{
                    ClassName: flowMap.ClassName,
                    MethodName: flowMap.MethodName,
                    Points: list.map(i => ({ ByLine: false, ID: flowMap.ItemMap[i.ID] ?? -1, Trace: false, Break: 1 })),
                }];
                const settings = {
                    ProjectName: flowMap.ContainerFullName,
                    Methods: methods,
                    StepSystemCode: false,
                };
                const url = `Apps/Debug/Trace/${channel}/${key}?value=${encodeURIComponent(value)}`;
                const res2 = await utils.api.request('PUT', url, settings);
            }
            this.debugWaitForNext = debugValue;
        },

        async debugStettings() {
            if (this.editorReadOnly)
                return;
            try {
                const schema = await this.getDebugSettingsSchema();

                // Use ref() to make the settings object reactive so the SchemaForm will work properly
                let settings = ref(this.getFlowSetting('startup', () => utils.schema.getDefaultModel(schema)));
                if (schema.properties?.media && (settings.value.media == null || typeof settings.value.media !== 'object'))
                    settings.value.media = utils.schema.getDefaultModel(schema.properties.media) || {};
                const content = () =>
                    <SchemaForm
                        name="projSettingsForm"
                        root={this.root}
                        schema={schema}
                        form={['*']}
                        cmodel={settings.value}
                        parentType="VerticalStack"
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        child={0}
                    >
                    </SchemaForm>;

                this.$refs.genericDialog.showDialog(`Startup Settings`, 800, content, () => this.saveDebugSettings(settings.value));
            }
            catch (err) {
                alert(err.message);
            }
        },
        saveDebugSettings(data) {
            this.saveFlowSetting('startup', data);
            this.debugSettings = data;
        },
        /**
         * Value-type flowchart params cannot be null for StartDebugging deserialization.
         * Prefer saved startup / DefaultValue, else type-appropriate zeros.
         */
        coerceDebugStartupArg(item, debugArgs) {
            const name = item?.Name;
            let v = name != null && debugArgs ? debugArgs[name] : undefined;
            if (v === undefined || v === null || v === '') {
                if (item?.DefaultValue !== undefined && item.DefaultValue !== null && item.DefaultValue !== '')
                    v = item.DefaultValue;
            }
            if (v !== undefined && v !== null && v !== '')
                return v;

            switch (item?.Type) {
                case 'bool':
                    return false;
                case 'int':
                case 'long':
                case 'float':
                case 'double':
                    return 0;
                default:
                    return v ?? null;
            }
        },
        async getDebugSettingsSchema() {
            const model = await utils.api.get(`Apps/FlowV2/GetMethodHeader?Type=${this.ItemType}&ID=${this.FlowID}`);
            const schema = {
                type: 'object',
                properties: {

                }
            };
            for (let item of model.Parameters) {
                const s = {
                    type: item.Type ?? 'string',
                    readonly: item.Out,
                };
                switch (s.type) {
                    case 'bool': s.type = 'boolean'; break;
                    case 'double':
                    case 'float': s.type = 'number'; break;
                    case 'int': s.type = 'integer'; break;
                    case 'json':
                        s.type = 'string';
                        break;
                }
                schema.properties[item.Name] = s;
            }

            const mediaSchemaUri = this.channelConfig?.FlowDebugMediaSchema;
            if (mediaSchemaUri) {
                const path = mediaSchemaUri.replace(/^\//, '');
                const envelope = await utils.schema.get(path);
                schema.properties.media = {
                    ...(envelope || { type: 'object', properties: {} }),
                    title: 'Media',
                };
            }

            if (this.channelConfig?.FlowDebugger === DEBUGGER_WEBRTC) {
                schema.properties.enableMedia = {
                    type: 'boolean',
                    default: true,
                    title: 'Enable Media',
                    description: 'Allows the media channel (e.g. voice path) to be established when debugging.',
                };
            }

            return schema;
        },

        syncSelectedBreakpoint(element = this.selected?.model) {
            this.selectedHasBreakpoint = isBreakpointVisible(element);
        },
        getAllBreakpoints() {
            let list = [];
            switch (this.ItemType) {
                case 'FlowHeader':
                    const allelements = this.graph.getCells();
                    for (let element of allelements) {
                        if (element.attributes.prop) {
                            const active = isBreakpointVisible(element);
                            if (active) {
                                list.push({ ID: element.attributes.prop.InstanceID });
                            }
                        }
                    }
                    break;

                case 'APIHeader':
                    list = this.$refs.codeEditor ? this.$refs.codeEditor.getAllBreakpoints() : [];
                    list = list.map(a => ({
                        Line: a.Line ?? a.line,
                        Column: a.Column ?? a.column ?? 0,
                    }));
                    break;
            }
            return list;
        },
        persistAllBreakpoints() {
            const list = this.getAllBreakpoints();
            const localStorageKey = `${this.storageKey}-${this.FlowID}-breakpoints`;
            const data = JSON.stringify(list);
            this.System.LocalStorage(localStorageKey, data);
            console.log(`persistAllBreakpoints(${localStorageKey}):${data}`);
        },
        restoreAllBreakpoints() {
            const localStorageKey = `${this.storageKey}-${this.FlowID}-breakpoints`;
            const listJson = this.System.LocalStorage(localStorageKey);
            if (listJson) {
                const list = JSON.parse(listJson);

                switch (this.ItemType) {
                    case 'FlowHeader':
                        const ids = {};
                        for (let item of list) ids[item.ID] = true;

                        const allelements = this.graph.getCells();
                        for (let element of allelements) {
                            if (element.attributes.prop) {
                                element.attr('breakAccent/visibility', element.attributes.prop.InstanceID in ids ? 'visible' : 'hidden');
                            }
                        }
                        break;

                    case 'APIHeader':
                        if (this.$refs.codeEditor)
                            this.$refs.codeEditor.setAllBreakpoints(list);
                        break;
                }
            }
            this.syncSelectedBreakpoint();
        },
        async toggleBreakpoint() {
            if (!this.canToggleDebugBreakpoints())
                return;
            // This is for flowchart icons only - API (code blocks) are done in aceEditorBreakpoint above
            const currentVisibility = this.selected.model.attr('breakAccent/visibility');
            let newstate = currentVisibility == 'hidden' ? 'visible' : 'hidden';
            this.selected.model.attr('breakAccent/visibility', newstate);
            this.syncSelectedBreakpoint();
            this.persistAllBreakpoints();

            if (this.debugMode != 'stopped') {
                const id = this.selected.model.attributes.prop.InstanceID;

                // Live debug session in progress, relay breakpoint change to server
                if (newstate == 'visible')
                    await utils.api.request('PUT', `Apps/Debug/Breakpoint/${this.debugSession}/${id}`);
                else
                    await utils.api.request('DELETE', `Apps/Debug/Breakpoint/${this.debugSession}/${id}`);
            }
        },
        clearAllBreakpoints() {
            if (!this.canToggleDebugBreakpoints())
                return;
            const allelements = this.graph.getCells();
            for (let element of allelements) {
                if (element.attributes.prop) {
                    element.attr('breakAccent/visibility', 'hidden');
                }
            }
            this.syncSelectedBreakpoint();
            this.persistAllBreakpoints();
        },

        getInstanceIDToName(id) {
            const element = this.graph.getCell(id);
            if (element)
                return formatDisplayName(element.attributes.prop.Model.API.Caption);

            return id;
        },
        /**
         * Graph / Monaco are rebuilt on method switch. Re-apply the paused icon
         * or execution point when the loaded method appears on the call stack
         * (Call Stack click, or a manual folder/tab open during debug). Also
         * syncs debugStackIndex so the Call Stack row matches the open tab.
         */
        async restorePausedDebugHighlight() {
            if (this.debugMode === 'stopped')
                return;
            const stack = this.debugStack || [];
            if (!stack.length || !this.FlowID)
                return;

            const maps = [];
            const matchIndexes = [];
            for (let i = 0; i < stack.length; i++) {
                const flowMap = await this.resolveDebugMapForFrame(stack[i]);
                maps[i] = flowMap;
                if (flowMap?.MethodID && flowMap.MethodID == this.FlowID)
                    matchIndexes.push(i);
            }

            const matchedIndex = pickStackFrameIndexForFlow(
                matchIndexes,
                this.debugStackIndex,
                this.debugExecStackIndex,
            );
            if (matchedIndex < 0) {
                this.$refs.codeEditor?.clearExecutionPoint();
                return;
            }

            this.debugStackIndex = matchedIndex;
            this.showBreakpoint(stack[matchedIndex], maps[matchedIndex]);
        },
        apiExecutionLineColumn(frame) {
            // Line -1 means "unknown" (generated / entry); ?? alone does not
            // fall through, so Follow (no ephemeral BP) missed the first pause.
            let line = frame?.Line;
            let column = frame?.Column;
            if (line == null || line < 0) {
                if (this._ephemeralBreakpoint?.kind === 'line') {
                    line = this._ephemeralBreakpoint.line;
                    column = this._ephemeralBreakpoint.column ?? 0;
                }
                else {
                    const detected = this.$refs.codeEditor?.detected_lines;
                    if (Array.isArray(detected) && detected.length > 0) {
                        line = detected[0].Line ?? 0;
                        column = detected[0].Column ?? 0;
                    }
                }
            }
            if (line == null || line < 0)
                return null;
            return {
                line: line + 1,
                column: column != null && column >= 0 ? column : 0,
            };
        },
        isViewingStackFrame() {
            return this.debugStackIndex !== this.debugExecStackIndex;
        },
        scheduleApiExecutionPoint(line, column, stackFrame) {
            const apply = () => {
                if (this.ItemType !== 'APIHeader' || this.debugMode === 'stopped')
                    return;
                this.$refs.codeEditor?.setExecutionPoint(line, column, { stackFrame: !!stackFrame });
            };
            apply();
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(apply);
                });
            });
        },
        togglePausedHighlight(element, enable, stackFrame) {
            if (enable) {
                element.attr('body/stroke', stackFrame ? '#22c55e' : '#FFFF00');
                element.attr('body/strokeWidth', 4);
            }
            else {
                element.attr('body/stroke', '#4285F4');
                element.attr('body/strokeWidth', 1);
            }
        },
        showBreakpoint(current, flowMap) {
            const stackFrame = this.isViewingStackFrame();
            switch (this.ItemType) {
                case 'FlowHeader':
                    const map = Object.keys(flowMap.ItemMap).map(a => ({ InstanceID: a, NumberId: flowMap.ItemMap[a] }));
                    const item = map.find(a => a.NumberId == current.Id);
                    if (item) {
                        const element = this.graph.getCell(item.InstanceID);
                        if (element) {
                            if (this.debugElement && this.debugElement !== element)
                                this.togglePausedHighlight(this.debugElement, false);

                            this.debugElement = element;
                            this.debugMode = 'paused';

                            this.togglePausedHighlight(element, true, stackFrame);
                            this.scheduleScrollDebugElementIntoView(element);
                        }
                    }
                    break;

                case 'APIHeader':
                    if (this.debugElement)
                        this.togglePausedHighlight(this.debugElement, false);
                    this.debugElement = null;
                    this.debugMode = 'paused';
                    const pos = this.apiExecutionLineColumn(current);
                    if (pos)
                        this.scheduleApiExecutionPoint(pos.line, pos.column, stackFrame);
                    break;
            }
            // Mix in the persistent variables which are stored in the media.UserData. Reference this.variables to
            // identify them.
            const persistNames = this.variables.filter(v => v.Persistent);
            const persistents =
                current.Locals.media && current.Locals.media.Fields && current.Locals.media.Fields.UserData ?
                    persistNames
                        .filter(p => p.Name in current.Locals.media.Fields.UserData)
                        .map(p => ({ Name: p.Name, Value: current.Locals.media.Fields.UserData[p.Name] }))
                    : [];
            const persistentVars = {};
            for (let p of persistents) persistentVars[p.Name] = p.Value;
            this.debugLocals = expandObject({ ...current.Locals, ...persistentVars }, current.LocalSymbols);

            // One-shot Step Over/Into entry BP — remove after first pause so it does not stick
            if (this._ephemeralBreakpoint)
                this.clearEphemeralBreakpoint();
        },
        debugChangeStack(index) {
            const current = this.debugStack?.[index];
            if (!current)
                return;
            this.selectStack(current, { stack: this.debugStack, frameIndex: index });
        },

        async resolveDebugMapForFrame(frame) {
            if (!frame)
                return null;

            const url = debugMapNameUrl(frame.ProjectName, frame.ClassName, frame.MethodName);
            let flowMap = mapCache.debugMap[url];
            // Only trust a cached name-URL entry if it actually belongs to this frame
            if (flowMap?.MethodID && frameMatchesDebugMap(frame, flowMap))
                return flowMap;

            const byFlowId = mapCache.debugMap[this.FlowID];
            if (frameMatchesDebugMap(frame, byFlowId)) {
                mapCache.debugMap[url] = byFlowId;
                return byFlowId;
            }

            try {
                flowMap = await utils.api.get(url);
            }
            catch (err) {
                console.warn('GetDebugMapFromName failed', frame, err);
                return null;
            }

            if (flowMap?.MethodID && frameMatchesDebugMap(frame, flowMap)) {
                cacheDebugMap(flowMap, flowMap.MethodID);
                mapCache.debugMap[url] = flowMap;
                return flowMap;
            }
            return null;
        },

        async selectStack(current, options = {}) {
            const stackFrames = options.stack || this.debugStack || (current ? [current] : []);
            const preferredIndex = Number.isInteger(options.frameIndex) ? options.frameIndex : 0;
            const fromStackClick = Number.isInteger(options.frameIndex);

            let flowMap = null;
            let resolvedFrame = current;
            let resolvedIndex = preferredIndex;

            const tryFrame = async (i) => {
                const frame = stackFrames[i];
                const map = await this.resolveDebugMapForFrame(frame);
                if (map?.MethodID) {
                    flowMap = map;
                    resolvedFrame = frame;
                    resolvedIndex = i;
                    return true;
                }
                return false;
            };

            if (fromStackClick)
                await tryFrame(preferredIndex);
            else {
                for (let i = 0; i < stackFrames.length; i++) {
                    if (await tryFrame(i))
                        break;
                }
            }

            if (!flowMap) {
                console.warn('No FlowV2 debug map for stack frame; treating as external', current);
                this.debugMode = 'paused';
                this.debugStack = stackFrames;
                this.debugStackIndex = fromStackClick ? preferredIndex : 0;
                if (!fromStackClick)
                    this.debugExecStackIndex = this.debugStackIndex;
                if (current?.Locals)
                    this.debugLocals = expandObject({ ...current.Locals }, current.LocalSymbols);
                return;
            }

            this.debugStack = stackFrames;
            this.debugStackIndex = resolvedIndex;
            if (!fromStackClick)
                this.debugExecStackIndex = resolvedIndex;

            const destProjectId = flowMap.ProjectID || this.parent_id || flowMap.ClassID;
            this.ensureDebugLockIncludesProject(destProjectId);

            if (flowMap.MethodID != this.FlowID) {
                this.applyDebugMethodTabTransition(this.FlowID, flowMap.MethodID, stackFrames);
                this.applyDebugMethodNavHistory(this.FlowID, flowMap.MethodID, stackFrames);

                this.loaderPromise = new Promise((res, rej) => {
                    this.loaderPromiseResolve = res;
                    this.loaderPromiseReject = rej;
                });

                // This triggers an asynchronous load of the specified flow, the promise is fullfilled
                // once the Loaded event comes from the web server (see above).
                this.SetActiveFlowID(
                    flowMap.MethodID,
                    flowMap.Type,
                    flowMap.MethodName,
                    destProjectId,
                    false,
                    { recordHistory: false },
                );

                try {
                    await this.loaderPromise; // Await for the flow to be loaded and displayed
                }
                catch (err) {
                    alert('Failed to load project at breakpoint: ' + err);
                    return;
                }
            }

            // Highlight item where the breakpoint stopped
            this.debugWaitForNext = undefined;
            this.showBreakpoint(resolvedFrame, flowMap);
        },

        async handleChannelEventData(eventData) {
            if (eventData.EventName == 'Debug') {
                const data = eventData.Content;
                const follower = this.debugRole === 'follower';
                this.debugSession = data.DebugSession;

                if (data.Value == 'Trace started') {
                    if (!follower)
                        this.debugLaunching = false;
                    this.debugMode = 'running';
                    this.debugElement = null;
                    this.debugStackIndex = 0;
                    this.debugExecStackIndex = 0;
                    this.syncEditorReadOnly();
                }
                else if (data.Value.startsWith('Break|')) {
                    if (!follower)
                        this.debugLaunching = false;
                    // Breakpoint hit. Open correct flow and navigate to the right location
                    const stack = data.Stack || [];
                    const current = stack[0];
                    console.log(`** BREAKPOINT ** at ID:${current?.Id}, Line:${current?.Line}, Column:${current?.Column}, Project:${current?.ProjectName}, Method:${current?.MethodName}`);

                    this.selectStack(current, { stack });
                }
                else if (data.Value.startsWith('Return|')) {
                    let value = data.Value.substr('Return|'.length);
                    if (value.startsWith('{') || value.startsWith('[')) {
                        const valueJson = JSON.parse(value);
                        value = JSON.stringify(valueJson, null, 3); // format
                        this.debugResults = value;
                        this.debugResultsVisible = true;
                    }
                }
                else if (data.Value == 'Trace ended') {
                    if (follower) {
                        this.clearFollowerHighlight();
                        return;
                    }
                    this.debugLaunching = false;
                    this.debugMode = 'stopped';
                    this._ephemeralBreakpoint = null;
                    if (this.debugElement)
                        this.togglePausedHighlight(this.debugElement, false);

                    this.debugElement = null;

                    if (this.$refs.codeEditor)
                        this.$refs.codeEditor.clearExecutionPoint();

                    if (this.WebRtcPhone && this.WebRtcPhone.state == 'accepted')
                        this.WebRtcPhone.Hangup();
                    this.lockedProjectIds = [];
                    this.lockedDebugSession = null;
                    this.debugLocked = false;
                    this._lockOpenFlow = false;
                    this.releaseDebugOwnership();
                    this.syncEditorReadOnly();
                }
                else if (data.Value.startsWith('LogItem|')) {
                    this.pushEditorMessage(data.Value.substr('LogItem|'.length), 'warning');
                }
            }
        },

        getMethodNavBackControl() {
            const backTo = methodHistoryTop(this.methodNavHistory);
            const forwardTo = methodHistoryTop(this.methodNavForward);
            const backEmpty = !backTo;
            const forwardEmpty = !forwardTo;
            const historyEmpty = backEmpty;
            const backTip = backTo?.name ? `Back to ${backTo.name}` : 'Back';
            const forwardTip = forwardTo?.name ? `Forward to ${forwardTo.name}` : 'Forward';
            return (
                <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }} class="q-ml-xs">
                    {utils.tt(backTip,
                        <QBtn
                            flat
                            dense
                            unelevated
                            color="indigo-8"
                            size="md"
                            icon="mdi-arrow-left"
                            disable={backEmpty}
                            onClick={() => this.goMethodNavBack()}
                        />,
                        'top'
                    )}
                    {utils.tt(forwardTip,
                        <QBtn
                            flat
                            dense
                            unelevated
                            color="indigo-6"
                            size="md"
                            icon="mdi-arrow-right"
                            disable={forwardEmpty}
                            onClick={() => this.goMethodNavForward()}
                        />,
                        'top'
                    )}
                    <QBtn
                        flat
                        dense
                        unelevated
                        color="indigo-8"
                        size="md"
                        icon="mdi-menu-down"
                        disable={historyEmpty}
                    >
                        <QTooltip anchor="top middle" self="bottom middle" delay={400}>
                            Navigation history
                        </QTooltip>
                        <QMenu anchor="bottom start" self="top start" auto-close>
                            <QList dense>
                                {this.methodNavHistoryItems().map(({ entry, index }) =>
                                    <QItem key={`${entry.id}-${index}`} clickable onClick={() => this.jumpMethodNavHistory(index)}>
                                        <QItemSection avatar>
                                            <QIcon
                                                name={entry.type === 'APIHeader' ? 'mdi-code-braces-box' : 'mdi-sitemap-outline'}
                                                size="sm"
                                                color="indigo-8"
                                            />
                                        </QItemSection>
                                        <QItemSection>
                                            <QItemLabel>{entry.name || entry.id}</QItemLabel>
                                        </QItemSection>
                                    </QItem>
                                )}
                            </QList>
                        </QMenu>
                    </QBtn>
                </div>
            );
        },
        getSaveStatusIcon() {
            let icon;
            let hint;
            switch (this.auto_saved) {
                case 'SAVED':
                    hint = 'Saved';
                    icon = <QIcon name="mdi-content-save-check" size="sm" color="indigo-4" class="q-ml-xs q-mt-sm" />; break;
                case 'SAVING':
                    hint = 'Saving...';
                    icon = <QIcon name="mdi-content-save" size="sm" color="indigo-3" class="q-ml-xs q-mt-sm" />; break;
                case 'FAILED':
                    hint = 'Save incomplete: ' + this.auto_save_error;
                    icon = <QIcon name="mdi-content-save-alert" size="sm" color="pink-3" class="q-ml-xs q-mt-sm" />; break;
                default:
                    return;
            }
            return utils.tt(hint, icon);
        },
        getWebRtcStatusIcon() {
            let icon;
            let hint;

            if (!this.showWebRtcDebugUi)
                return null;

            if (this.debugSettings && this.debugSettings.enableMedia === false)
                return null;

            const state = this.WebRtcPhone?.state;
            const setupFailed = state === 'failed' || state === 'error' || state === 'missing_mic';
            const settingUp = !setupFailed && state !== 'accepted' && (
                state === 'connecting' || state === 'calling' || this.debugLaunching
            );
            const iconClass = settingUp ? 'q-mr-xs q-mt-sm mdi-animate-pulse' : 'q-mr-xs q-mt-sm';

            if (this.WebRtcPhone) {
                hint = settingUp ? 'Setting up softphone…' : ('Softphone ' + state);
                switch (state) {
                    case 'connected':
                        icon = <QIcon name="mdi-phone" size="sm" color="indigo-4" class={iconClass} />;
                        break;
                    case 'connecting':
                        icon = <QIcon name="mdi-phone-settings-outline" size="sm" color="indigo-4" class={iconClass} />;
                        break;
                    case 'calling':
                        icon = <QIcon name="mdi-phone-outgoing-outline" size="sm" color="indigo-4" class={iconClass} />;
                        break;
                    case 'accepted':
                        icon = <QIcon name="mdi-phone-incoming-outgoing-outline" size="sm" color="indigo-4" class={iconClass} />;
                        break;
                    case 'dropped':
                    case 'disconnected':
                        icon = <QIcon name="mdi-phone-outline" size="sm" color="indigo-4" class={iconClass} />;
                        break;

                    case 'failed':
                    case 'error':
                        icon = <QIcon name="mdi-phone-alert" size="sm" color="red" class={iconClass} />;
                        break;

                    case 'missing_mic':
                        icon = <QIcon name="mdi-microphone-variant-off" size="sm" color="red" class={iconClass} />;
                        break;

                    case 'idle':
                    case 'init':
                    default:
                        icon = <QIcon name="mdi-phone-classic" size="sm" color="indigo-4" class={iconClass} />;
                        break;
                }
            }
            else {
                hint = settingUp ? 'Setting up softphone…' : 'Softphone idle';
                icon = <QIcon name="mdi-phone-classic" size="sm" color="indigo-4" class={iconClass} />;
            }

            if (icon)
                return utils.tt(hint, icon);
        },
    },
    props: {
    },
    render() {
        try {
            //if (!this.todisplay)
            //    return null;

            const layout = <Splitpanes horizontal={false} onResized={(e) => this.storeFlowPaneSize('toplevel', e)} push-other-panes={false}>
                <Pane
                    style="display: flex; flex-direction: column; overflow: auto; position: relative;"
                    class="ag-grid-noborder"
                    key={0}
                    size={this.panelSizes.toplevel.panel1}
                    xmin-size={25}
                    xmax-size={100}
                    dbl-click-splitter={true}
                >
                    <FolderGrid
                        ref="folderGrid"
                        FlowID={this.FlowID}
                        lockedProjectIds={this.lockedProjectIds}
                        editorSurface={this.editorSurface}
                        configScope={this.configScope}
                        projectId={this.parent_id}
                        channelConfig={this.channelConfig}
                        itemType={this.ItemType}
                        onOpenFlow={(id, type, name, parentid, isNew, recipeId) => this.SetActiveFlowID(id, type, name, parentid, isNew, { recipeId })}
                        onUpdateMethod={(id, data) => this.UserFlowHeaderChanged(id, data)}
                        onRenameMethod={(id, name) => this.applyMethodNameReferences(id, name)}
                        askAiEnabled={this.askAiEnabled}
                        onOpenConfig={(data) => this.onFolderOpenConfig(data)}
                        onSaveRecipe={(data) => this.onFolderSaveRecipe(data)}
                        onMovedMethod={(payload) => this.onFolderMovedMethod(payload)}
                        onMovedProject={() => this.refreshProjectName()}
                    ></FolderGrid>
                </Pane>
                <Pane
                    style="display: flex; flex-direction: column; overflow: auto; position: relative;"
                    key={1}
                    size={this.panelSizes.toplevel.panel2}
                    xmin-size={25}
                    xmax-size={100}
                    dbl-click-splitter={true}
                >
                    <Splitpanes horizontal={true} push-other-panes={false} onResized={(e) => this.storeFlowPaneSize('main', e)}>
                        <Pane
                            style={`display: flex; flex-direction: column; overflow-x: ${this.editorSurface === 'config' ? 'hidden' : 'auto'}; overflow-y: auto; position: relative;`}
                            class="ag-grid-noborder"
                            key={0}
                            size={this.debugMode != 'stopped' ? this.panelSizes.main.panel1 : 100}
                            dbl-click-splitter={true}
                        >

                            <div ref="editorToolbar" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', minWidth: 0, overflow: 'hidden', backgroundColor: 'white', visibility: this.FlowID || this.parent_id ? 'visible' : 'hidden' }}>
                                {this.getMethodNavBackControl()}
                                {this.getSaveStatusIcon()}
                                {/* Always reserve connector control width so surface switch does not shift. */}
                                <div
                                    style={{
                                        visibility: (this.ItemType == 'FlowHeader' && this.editorSurface === 'document') ? 'visible' : 'hidden',
                                        pointerEvents: (this.ItemType == 'FlowHeader' && this.editorSurface === 'document') ? 'auto' : 'none',
                                    }}
                                >
                                    <QBtn flat dense color="indigo-8" class="q-mt-none q-mb-none q-mx-sm" size="sm" disable={this.editorReadOnly}>
                                        <QIcon name="mdi-chart-sankey-variant" size="sm" />
                                        <QIcon name="mdi-menu-down" size="sm" />
                                        {(this.ItemType == 'FlowHeader' && this.editorSurface === 'document' && !this.editorReadOnly) ? (
                                            <QMenu anchor="bottom start" self="top start" auto-close>
                                                <QList dense class="q-pa-none">
                                                    {this.connectorStyles.map((item, idx) =>
                                                        <QItem key={idx} clickable v-ripple active={this.connectorStyle === item.value} onClick={() => this.updateRouter(item.value)}>
                                                            <QItemSection><QItemLabel>{item.title}</QItemLabel></QItemSection>
                                                        </QItem>
                                                    )}
                                                </QList>
                                            </QMenu>
                                        ) : null}
                                    </QBtn>
                                </div>
                                {this.askAiEnabled ? utils.tt('Ask AI',
                                    <QBtn
                                        flat
                                        dense
                                        color="indigo-8"
                                        class="q-mx-sm q-mt-xs"
                                        icon="mdi-creation-outline"
                                        aria-label="Ask AI"
                                        disable={this.editorReadOnly || !this.FlowID}
                                        onClick={() => { this.askAiOpen = !this.askAiOpen; }}
                                    />
                                ) : null}
                                {utils.tt('Toggle ID', <QBtn onClick={() => this.viewMethodID = !this.viewMethodID} icon="mdi-identifier" flat dense color="indigo-8" class="q-mt-xs" />)}
                                {/* Fixed caption slot so toggling ID does not nudge the surface switch. */}
                                <span
                                    class="text-caption text-truncate q-mt-sm q-mr-sm"
                                    style={{
                                        maxWidth: '120px',
                                        whiteSpace: 'nowrap',
                                        visibility: this.viewMethodID ? 'visible' : 'hidden',
                                        minWidth: '72px',
                                    }}
                                >{this.FlowID || '\u00a0'}</span>

                                {(this.FlowID || this.parent_id) ? (
                                    <div class={`flow-v2-surface-switch q-ml-sm ${SENTENCE_CASE_BUTTON_CLASS}`}>
                                        <QBtn
                                            label="Editor"
                                            unelevated
                                            no-caps
                                            class={`${SENTENCE_CASE_BUTTON_CLASS} q-my-xs ThemeRightConnector`}
                                            color={this.editorSurface !== 'config' ? 'primary' : 'grey-3'}
                                            text-color={this.editorSurface !== 'config' ? 'white' : 'grey-8'}
                                            onClick={() => this.closeConfigSurface()}
                                        />
                                        <QBtn
                                            label="Configuration"
                                            unelevated
                                            no-caps
                                            class={`${SENTENCE_CASE_BUTTON_CLASS} q-my-xs ThemeLeftConnector`}
                                            color={this.editorSurface === 'config' ? 'primary' : 'grey-3'}
                                            text-color={this.editorSurface === 'config' ? 'white' : 'grey-8'}
                                            onClick={() => {
                                                if (this.FlowID)
                                                    this.openConfigSurface('method', 'signature');
                                                else if (this.parent_id)
                                                    this.openConfigSurface('project', 'settings');
                                            }}
                                        />
                                    </div>
                                ) : null}

                                <QSpace />

                                {/* Keep debug chrome in layout (hidden) so nothing to the right/left reflows on surface change. */}
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        flexShrink: 0,
                                        visibility: this.editorSurface === 'document' && this.debugTransportVisible() ? 'visible' : 'hidden',
                                        pointerEvents: this.editorSurface === 'document' && this.debugTransportVisible() ? 'auto' : 'none',
                                    }}
                                >
                                    {this.getWebRtcStatusIcon()}
                                    {utils.tt(this.debugStartTip(), <QBtn onClick={() => this.debugStart()} disable={this.debugMode == 'paused' ? !this.canDriveDebugSession() : !this.canLaunchDebugSession()} icon="mdi-play" flat dense color="green-8" class="q-mt-xs" />)}
                                    {utils.tt(this.debugStepTip('Step Over'), <QBtn onClick={() => this.debugStep(false)} disable={!this.canStepDebugSession()} icon="mdi-debug-step-over" flat dense color="green-8" class="q-mt-xs" />)}
                                    {utils.tt(this.debugStepTip('Step Into'), <QBtn onClick={() => this.debugStep(true)} disable={!this.canStepDebugSession()} icon="mdi-debug-step-into" flat dense color="green-8" class="q-mt-xs" />)}
                                    {utils.tt(this.editorReadOnly ? 'Debugging in progress' : 'Settings', <QBtn onClick={() => this.debugStettings()} disable={this.editorReadOnly} icon="mdi-dots-vertical" size="sm" flat dense color="green-8" class="q-mt-sm" />)}
                                    <div style="padding: 5px; margin-left: 5px; margin-right: 5px;" class="q-mt-xs">
                                        <div style="border-left: 1px solid #a080a080; height: 20px;"></div>
                                    </div>
                                    {utils.tt(this.canPauseDebugSession() ? 'Pause' : (this.debugLaunchBlockReason() || 'Pause'), <QBtn onClick={() => this.debugPause()} disable={!this.canPauseDebugSession()} icon="mdi-pause" flat dense color="green-8" class="q-mt-xs" />)}
                                    {utils.tt(this.canStopDebugSession() ? 'Stop' : (this.debugLaunchBlockReason() || 'Stop'), <QBtn onClick={() => this.debugStop()} disable={!this.canStopDebugSession()} icon="mdi-stop" flat dense color="green-8" class="q-mt-xs" />)}
                                    {(this.debugLocked && !this.isDebugOwner) ? utils.tt(this.debugRole === 'follower' ? 'Stop following' : 'Follow debug session', <QBtn onClick={() => this.debugRole === 'follower' ? this.unfollowDebugSession() : this.followDebugSession()} icon={this.debugRole === 'follower' ? 'mdi-eye-off' : 'mdi-eye'} flat dense unelevated={this.debugRole === 'follower'} color={this.debugRole === 'follower' ? 'positive' : 'green-8'} class="q-mt-xs" />) : null}
                                    <div style="padding: 5px; margin-left: 5px; margin-right: 5px;" class="q-mt-xs">
                                        <div style="border-left: 1px solid #a080a080; height: 20px;"></div>
                                    </div>
                                    <div style="flex-shrink: 0; display: flex; align-items: center;" class="q-mt-xs">
                                        {utils.tt(this.waitNextTip(), <QBtn disable={this.waitNextDisabled()} icon={this.debugWaitForNext === 0 ? 'mdi-timer-sand' : 'mdi-av-timer'} flat dense unelevated={this.debugWaitForNext !== 0} color="green-8" onClick={() => this.debugWaitNext(this.debugWaitForNext === 0 ? 1 : 0)} />)}
                                    </div>
                                    <div style="padding: 5px; margin-left: 5px; margin-right: 5px;" class="q-mt-xs">
                                        <div style="border-left: 1px solid #a080a080; height: 20px;"></div>
                                    </div>
                                    {utils.tt(this.canToggleDebugBreakpoints() ? 'Toggle Break Point' : (this.debugLaunchBlockReason() || 'Debugging in progress'), <QBtn disable={!this.selected || !this.canToggleDebugBreakpoints()} onClick={() => this.toggleBreakpoint()} icon="mdi-pause-octagon-outline" flat dense color="green-8" class="q-mt-xs" />)}
                                    {utils.tt(this.canToggleDebugBreakpoints() ? 'Clear All Break Points' : (this.debugLaunchBlockReason() || 'Debugging in progress'), <QBtn disable={!this.canToggleDebugBreakpoints()} onClick={() => this.clearAllBreakpoints()} icon="mdi-delete-forever" flat dense color="green-8" class="q-mt-xs" />)}
                                </div>
                            </div>

                            {(this.debugLocked && !this.isDebugOwner) ? (
                                <div
                                    class="flow-v2-debug-lock-banner q-px-sm q-py-xs"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexShrink: 0,
                                        backgroundColor: this.debugRole === 'follower' ? 'rgba(76, 175, 80, 0.12)' : 'rgba(255, 193, 7, 0.18)',
                                        borderBottom: '1px solid rgba(0,0,0,0.06)',
                                        fontSize: '13px',
                                    }}
                                >
                                    <span style={{ flex: 1, minWidth: 0 }}>
                                        {this.debugRole === 'follower'
                                            ? 'Following debug session'
                                            : 'Another session is debugging this project'}
                                    </span>
                                    <QBtn
                                        dense
                                        flat
                                        no-caps
                                        size="sm"
                                        color={this.debugRole === 'follower' ? 'positive' : 'amber-10'}
                                        label={this.debugRole === 'follower' ? 'Stop following' : 'Follow'}
                                        icon={this.debugRole === 'follower' ? 'mdi-eye-off' : 'mdi-eye'}
                                        onClick={() => this.debugRole === 'follower' ? this.unfollowDebugSession() : this.followDebugSession()}
                                    />
                                </div>
                            ) : null}

                            <div class={{
                                'flow-v2-context-strip': true,
                                'flow-v2-context-strip--collapsed': !this.showContextStrip,
                                'flow-v2-context-strip--project-only': this.showContextStrip && !this.hasFlowTabs,
                            }}>
                                <div class={{
                                    'flow-v2-context-strip__tabs': true,
                                    'flow-v2-context-strip__tabs--hidden': !this.showFlowTabs,
                                }}>
                                    <div class="c-BasicTab">
                                        <QTabs
                                            ref="editorTabs"
                                            dense
                                            align="left"
                                            breakpoint={0}
                                            indicatorColor="transparent"
                                            style={{ color: 'var(--v-secondaryText-base)' }}
                                            modelValue={this.selected_tab}
                                            onUpdate:modelValue={(index) => this.changeSelectedTab(index)}
                                        >
                                            {this.tabs.map((t, i) =>
                                                t.text ? (
                                                    <QTab key={t.value} name={t.value} class="text-none" style="min-width: 0;">
                                                        <span>
                                                            {t.text}
                                                            {this.editorReadOnly ? (
                                                                <QIcon name="mdi-lock-outline" size="xs" color="blue-grey-5" class="q-ml-xs" title="Read-only while debugging" />
                                                            ) : null}
                                                            {i === 0 ?
                                                                <QIcon name="mdi-pin-outline" size="xs" class="q-ml-xs" title="Pin" onClick={(e) => { e.stopPropagation(); this.pinSelectedTab(e); }} style="cursor: pointer;" />
                                                                : t.value === this.selected_tab ?
                                                                    <QIcon name="mdi-pin" size="xs" class="q-ml-xs" title="Unpin" onClick={(e) => this.unpinSelectedTab(e, t.value)} style="cursor: pointer;" />
                                                                    :
                                                                    <QIcon name="mdi-close-circle" size="xs" class="q-ml-xs" title="Close" onClick={(e) => this.closePinnedFlowTab(e, t.value)} style="cursor: pointer;" />
                                                            }
                                                        </span>
                                                    </QTab>
                                                ) : null
                                            )}
                                        </QTabs>
                                    </div>
                                </div>
                                <div
                                    class={{
                                        'flow-v2-context-strip__project': true,
                                        'flow-v2-context-strip__project--hidden': this.showFlowTabs,
                                    }}
                                    aria-hidden={this.showFlowTabs ? 'true' : 'false'}
                                >
                                    <QIcon name="mdi-folder-cog-outline" size="xs" />
                                    <span class="text-truncate">
                                        Project · {this.project_name || this.parent_id || ''}
                                    </span>
                                </div>
                            </div>

                            <div v-show={this.editorSurface === 'document'} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, position: 'relative' }}>
                            {this.getFlowEditor()}
                            {this.getAPIEditor()}
                            {this.recipeSetupCard()}

                            <QInnerLoading showing={!this.IsWebSocketActive}>
                                <div style="display: flex; flex-direction: column; align-items: center; gap: 8px; background-color: white; padding: 10px; border-radius: 8px;">
                                    <QSpinner color="orange" size="40px" />
                                    <span>Lost Connection. Please wait...</span>
                                </div>
                            </QInnerLoading>

                            <FlowMessageLog
                                messages={this.messages}
                                prefs={this.messageLogPrefs}
                                mutedCount={this.messageLogMutedCount}
                                onUpdate:prefs={p => this.onMessageLogPrefs(p)}
                                onDismiss={id => this.dismissEditorMessage(id)}
                                onClear={() => this.clearEditorMessages()}
                                onClearVisible={ids => this.clearVisibleEditorMessages(ids)}
                            />
                            </div>

                            {this.editorSurface === 'config' ? (
                                <div style={{ flex: 1, minHeight: 0, minWidth: 0, overflow: 'hidden' }}>
                                    <FlowConfigPanel
                                        readOnly={this.editorReadOnly}
                                        configScope={this.configScope}
                                        configTab={this.configTab}
                                        flowId={this.FlowID}
                                        flowType={this.ItemType}
                                        flowName={this.flow_name}
                                        projectId={this.parent_id}
                                        projectName={this.project_name}
                                        channelType={this.channelConfig?.ChannelType}
                                        channelConfig={this.channelConfig}
                                        root={this.root}
                                        scopeitems={this.scopeitems}
                                        controlscope={this.controlscope}
                                        onUpdate:configScope={(v) => { this.configScope = v; }}
                                        onUpdate:configTab={(v) => { this.configTab = v; }}
                                        onClose={() => this.closeConfigSurface()}
                                        onMethodSaved={(d) => this.onMethodSettingsSaved(d)}
                                        onProjectSaved={(d) => this.onProjectSettingsSaved(d)}
                                    />
                                </div>
                            ) : null}

                        </Pane>
                        {(this.showDebugSessionPane()) ?
                            <Pane
                                style="display: flex; flex-direction: column; overflow: auto; position: relative;"
                                class="ag-grid-noborder"
                                key={0}
                                size={100 - this.panelSizes.main.panel1}
                                dbl-click-splitter={false}
                            >
                                <QBar class="bg-primary text-white" style="min-height: 35px;">
                                    <QTabs dense modelValue={this.debugWindows_tab} onUpdate:modelValue={(v) => this.debugWindows_tab = v} active-color="white" indicator-color="white" narrow-indicator>
                                        <QTab name={0} label="Call Stack" />
                                        <QTab name={1} label="Locals" />
                                    </QTabs>
                                </QBar>

                                <QTabPanels modelValue={this.debugWindows_tab} onUpdate:modelValue={(v) => this.debugWindows_tab = v} style="flex-grow: 1; display: flex; flex-direction: column; overflow: auto;">
                                    <QTabPanel name={0} style="display: flex; flex-direction: column; overflow: auto; padding: 0;">
                                        <DebugCallStack
                                            items={this.debugStack}
                                            index={this.debugStackIndex}
                                            execIndex={this.debugExecStackIndex}
                                            idToName={this.getInstanceIDToName}
                                            onActivate={this.debugChangeStack}
                                            onDoubleClick={this.debugChangeStack}
                                        ></DebugCallStack>
                                    </QTabPanel>
                                    <QTabPanel name={1} style="display: flex; flex-direction: column; overflow: auto; padding: 0;">
                                        <DebugLocals items={this.debugLocals}></DebugLocals>
                                    </QTabPanel>
                                </QTabPanels>

                            </Pane>
                            :
                            null
                        }
                    </Splitpanes>
                    <AskAiDrawer
                        ref="askAiDrawer"
                        open={this.askAiOpen}
                        flowId={this.FlowID || ''}
                        itemType={this.ItemType || ''}
                        methodName={this.flow_name || ''}
                        readOnly={!!this.editorReadOnly}
                        selectedIds={this.askAiSelectionIds()}
                        currentBody={this.askAiCurrentBody()}
                        onClose={() => { this.askAiOpen = false; }}
                        onApplied={() => { this.askAiAwaitingValidation = true; }}
                    />
                    <AskAiRecipeDialog
                        open={this.askAiRecipeOpen}
                        flowId={this.FlowID || ''}
                        readOnly={!!this.editorReadOnly}
                        onClose={() => { this.askAiRecipeOpen = false; }}
                    />
                </Pane>
                <Pane
                    style="display: flex; flex-direction: column; overflow: auto;"
                    key={2}
                    size={100 - this.panelSizes.toplevel.panel2 - this.panelSizes.toplevel.panel1}
                    dbl-click-splitter={true}
                >
                    <Splitpanes horizontal={true} onResized={(e) => this.storeFlowPaneSize('toolprops', e)}>
                        <Pane
                            size={this.propertiesPinned ? this.panelSizes.toolprops.panel1 : 100}
                            style="display: flex; flex-direction: column; overflow: auto; background-color: white;">
                            <QBar class="bg-primary text-white" style="min-height: 35px;">
                                <QTabs dense modelValue={this.upperRight_tab} onUpdate:modelValue={(v) => this.upperRight_tab = v} active-color="white" indicator-color="white" narrow-indicator>
                                    <QTab name={0} label="Tool Palette" />
                                    <QTab name={1} label="Variables" />
                                    {this.ItemType == 'APIHeader' ? <QTab name={2} label="Imports" /> : null}
                                </QTabs>
                            </QBar>

                            {/* v-show instead of QTabPanels so Tool Palette + Variables stay mounted and retain state */}
                            <div class="ag-grid-noborder" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
                                <div
                                    v-show={this.upperRight_tab == 0}
                                    style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}
                                >
                                    <div
                                        v-show={this.ItemType == 'APIHeader'}
                                        style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                                    >
                                        <ApiGrid />
                                    </div>
                                    <div
                                        v-show={this.ItemType != 'APIHeader'}
                                        style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                                    >
                                        <ToolGrid
                                            items={this.filteredToolPaletteItems}
                                            readOnly={this.editorReadOnly}
                                            onDragStart={this.handleDragStart}
                                            onConfigurePalettes={this.openPaletteSettings}
                                        />
                                    </div>
                                </div>
                                <div
                                    v-show={this.upperRight_tab == 1}
                                    style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'auto', padding: 0 }}
                                >
                                    <Variables
                                        type={this.ItemType}
                                        readOnly={this.editorReadOnly}
                                        items={this.variables_bytype}
                                        onAddvar={this.addVariable}
                                        onRemovevar={this.removeVariable}
                                        onUpdatevar={this.updateVariable}
                                    ></Variables>
                                </div>
                                <div
                                    v-show={this.upperRight_tab == 2 && this.ItemType == 'APIHeader'}
                                    style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}
                                >
                                    <ImportsPanel
                                        rows={this.siblingRows}
                                        readOnly={this.editorReadOnly}
                                        loading={this.siblingLoading}
                                        error={this.siblingError}
                                        currentProjectId={this.parent_id}
                                        visible={this.upperRight_tab == 2 && this.ItemType == 'APIHeader'}
                                        folderProjects={this.$refs.folderGrid?.folderData || []}
                                        validateAlias={(alias, except) => this.isLegalAliasTokenExcept(alias, except)}
                                        suggestAlias={(name) => this.suggestSiblingAlias(name)}
                                        onAdd={this.addExplicitSibling}
                                        onAddAlias={this.addSiblingAlias}
                                        onRenameAlias={this.renameSiblingAlias}
                                        onChangeAliasClass={this.changeSiblingAliasClass}
                                        onDropProject={this.handleImportPanelDrop}
                                        onRemoveAlias={this.removeSiblingAlias}
                                        onRemoveExplicit={this.removeExplicitSibling}
                                    />
                                </div>
                            </div>
                        </Pane>
                        {this.propertiesPinned ? (
                            <Pane
                                size={100 - this.panelSizes.toolprops.panel1}
                                style="display: flex; flex-direction: column; overflow: hidden;">
                                <div style="border-bottom: 1px solid gray; background-color: rgb(86,112,155); color: white; padding: 2px;">Properties</div>
                                <div style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    <IconPropertyDockedPanel
                                        advanced={this.propertiesAdvancedMode}
                                        pinned={this.propertiesPinned}
                                        onUpdate:advanced={(v) => this.setPropertiesAdvancedMode(v)}
                                        onUpdate:pinned={(v) => this.setPropertiesPinned(v)}
                                        schema={this.schema}
                                        model={this.model}
                                        tool={this.tool}
                                        banner={this.batchBanner}
                                        selectionKey={this.batchSelectionKey || this.selected?.model?.attributes?.prop?.InstanceID || ''}
                                        validationErrors={this.selected?.model?.attributes?.prop?.Errors || null}
                                        root={this.root}
                                        scopeitems={this.scopeitems}
                                        controlscope={this.controlscope}
                                        description={this.schema?.description || ''}
                                        readonly={this.propertiesReadOnly}
                                        variableBindingContext={this.variableBindingContext}
                                        flowContext={this.flowContext}
                                        hasBreakpoint={this.selectedHasBreakpoint}
                                    />
                                </div>
                            </Pane>
                        ) : null}
                    </Splitpanes>
                </Pane>
            </Splitpanes>;

            return (
                <div style={this.styles}
                    class={{ 'c-FlowV2': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    v-show={this.isvisible}>
                    {layout}
                    <IconPropertyOverlay
                        visible={this.iconOverlayVisible && !this.propertiesPinned}
                        left={this.iconOverlayPosition.left}
                        top={this.iconOverlayPosition.top}
                        width={this.iconOverlaySize.width || OVERLAY_WIDTH_PX}
                        height={this.iconOverlaySize.height || OVERLAY_HEIGHT_ADVANCED_PX}
                        maxHeight={this.iconOverlayMaxHeight}
                        scale={this.scale || 1}
                        placement={this.iconOverlayPlacement}
                        title={formatDisplayName(this.model?.API?.Name || this.tool?.name || '')}
                        advanced={this.propertiesAdvancedMode}
                        pinned={this.propertiesPinned}
                        onUpdate:advanced={(v) => this.setPropertiesAdvancedMode(v)}
                        onUpdate:pinned={(v) => this.setPropertiesPinned(v)}
                        onClose={() => this.closeIconPropertyOverlay()}
                        onResize={(size) => this.onIconOverlayResize(size)}
                        onContentHeight={(h) => this.onIconOverlayContentHeight(h)}
                        onZoom={(e) => this.paper_wheel(e)}
                        schema={this.schema}
                        model={this.model}
                        tool={this.tool}
                        selectionKey={this.selected?.model?.attributes?.prop?.InstanceID || ''}
                        validationErrors={this.selected?.model?.attributes?.prop?.Errors || null}
                        readonly={this.propertiesReadOnly}
                        root={this.root}
                        scopeitems={this.scopeitems}
                        controlscope={this.controlscope}
                        variableBindingContext={this.variableBindingContext}
                        flowContext={this.flowContext}
                        hasBreakpoint={this.selectedHasBreakpoint}
                    />
                    <QDialog
                        modelValue={this.paletteSettingsOpen}
                        onUpdate:modelValue={(v) => { this.paletteSettingsOpen = v; }}
                        persistent
                    >
                        <QCard style={{ width: '420px', maxWidth: 'calc(100vw - 24px)' }}>
                            <QBar class="bg-primary text-white">
                                <QToolbarTitle>Palette settings</QToolbarTitle>
                                <QSpace />
                                <QBtn flat round dense icon="mdi-close" onClick={() => { this.paletteSettingsOpen = false; }} />
                            </QBar>
                            <QCardSection>
                                <div class="text-body2 q-mb-sm">Choose which tool groups appear in the palette.</div>
                                {this.paletteSettingsLoading
                                    ? <QSpinner color="primary" size="32px" />
                                    : null}
                                {this.paletteSettingsError
                                    ? <div class="text-negative q-mb-sm">{this.paletteSettingsError}</div>
                                    : null}
                                {!this.paletteSettingsLoading
                                    ? (
                                        <div style={{ maxHeight: '360px', overflow: 'auto' }}>
                                            {this.paletteNameOptions.map((option) => (
                                                <QCheckbox
                                                    key={option.name}
                                                    class="flow-v2-web-access-check caption sform-checkbox-neutral full-width"
                                                    dense
                                                    modelValue={option.selected}
                                                    label={formatDisplayName(option.name)}
                                                    onUpdate:modelValue={(v) => this.togglePaletteName(option.name, v)}
                                                />
                                            ))}
                                            {!this.paletteNameOptions.length && !this.paletteSettingsError
                                                ? <div class="text-grey-7">No palettes are available.</div>
                                                : null}
                                        </div>
                                    )
                                    : null}
                            </QCardSection>
                            <QSeparator />
                            <QCardActions align="right">
                                <QBtn flat label="Cancel" onClick={() => { this.paletteSettingsOpen = false; }} />
                                <QBtn
                                    unelevated
                                    color="primary"
                                    label="Save"
                                    loading={this.paletteSettingsSaving}
                                    disable={this.paletteSettingsLoading || (!!this.paletteSettingsError && !this.paletteNameOptions.length)}
                                    onClick={() => this.savePaletteSettings()}
                                />
                            </QCardActions>
                        </QCard>
                    </QDialog>
                    <GenericDialog ref="genericDialog"></GenericDialog>
                    {
                        this.debugResultsVisible ?
                            <FloatingWindow
                                title="Results"
                                content={this.debugResults}
                                onClose={() => this.debugResultsVisible = false}
                            ></FloatingWindow>
                            : null
                    }
                    <RichTooltip ref="richTooltip"></RichTooltip>
                    <PhoneKeypad v-show={this.showWebRtcDebugUi && this.debugMode != 'stopped' && this.WebRtcPhone?.state == 'accepted'} title="Keypad" onKeypress={(key) => this.debugPhoneKeypress(key)}></PhoneKeypad>
                </div>
            );
        }
        catch(e) {
            utils.error('FlowV2 Render failed', e);
            return <div>FlowV2 Failed to Render {e}</div>;
        }
    }
});